"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var Window = /*#__PURE__*/function () {
    function Window(window, config) {
      _classCallCheck(this, Window);

      this.init(window, config);
    }

    _createClass(Window, [{
      key: "init",
      value: function init(window, config) {
        this.window = window;
        this.options = new NS.Utils.OptionsResolver(config);
        this.configure();
      }
    }, {
      key: "configure",
      value: function configure() {
        this.window.button("park").hide();
        this.window.button("minmax").hide();
        this.window.setIconCss(this.options.getOption("icon-css", "window-icon-clear md-desktop-windows"));
        this.window.setModal(this.options.getOption("modal", true));
        this.window.setText(this.options.getOption("title"));
        this.window.center();
      }
    }, {
      key: "dhtmlxObject",
      value: function dhtmlxObject() {
        return this.window;
      }
    }, {
      key: "show",
      value: function show() {
        this.window.show();
      }
    }]);

    return Window;
  }();

  global.NS = global.NS || {};
  global.NS.Window = global.NS.Window || {};
  global.NS.Window.Control = Window;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var Manager = /*#__PURE__*/function () {
    function Manager(config) {
      _classCallCheck(this, Manager);

      this.init(config);
    }

    _createClass(Manager, [{
      key: "init",
      value: function init(config) {
        this.options = new NS.Utils.OptionsResolver(config); // noinspection JSPotentiallyInvalidConstructorUsage

        this.windowsManager = new dhtmlXWindows(this.options.getOption("container-id", null));
      }
    }, {
      key: "createWindow",
      value: function createWindow(config) {
        var windowOptions = new NS.Utils.OptionsResolver(config);
        var id = windowOptions.getOption("id");
        var position = windowOptions.getOption("position", {
          "x": 100,
          "y": 100
        });
        var size = windowOptions.getOption("size", {
          "width": 500,
          "height": 300
        });

        if (!id) {
          throw new Error("Cannot create window without ID.");
        }

        if (this.windowsManager.isWindow(id)) {
          throw new Error("Window with id: " + id + " already exists.");
        }

        var dhtmlxWindow = this.windowsManager.createWindow(id, position.x, position.y, size.width, size.height);
        return new NS.Window.Control(dhtmlxWindow, config);
      }
    }, {
      key: "dhtmlxObject",
      value: function dhtmlxObject() {
        return this.windowsManager;
      }
    }]);

    return Manager;
  }();

  global.NS = global.NS || {};
  global.NS.Window = global.NS.Window || {};
  global.NS.Window.Manager = Manager;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  // deklaracja klasy
  // noinspection JSPotentiallyInvalidConstructorUsage
  var Control = /*#__PURE__*/function () {
    function Control(config) {
      _classCallCheck(this, Control);

      this.gridId = null;
      this.showAllRows = null;
      this.containerId = null;
      this.dataSource = null;
      this.reloadTime = 0;
      this.columnDefinitionSource = null;
      this.settingsManager = null;
      this.grid = null;
      this.gridDataProcessor = null;
      this.autoLoad = false;
      this.pageSize = 40;
      this.listeners = {};
      this.allowMultiselect = false;
      this.enableMultiline = false;
      this.loadCallback = null;
      this.init(config);
    }
    /**
     * Listener obsługujący zdarzenie edycji komórki.
     * W fazie 0, czyli przed rozpoczęciem edycji, następuje weryfikacja, czy komórka jest dostępna dla edycji.
     *
     * Weryfikacja następuje na podstawie 2 opcji konfiguracji definicji kolumn - isEditable i isEditableOnAdd.
     * Pierwsza umożliwia edycję rekordu istniejącego, druga umożliwia edycję nowego, niezapisanego rekordu.
     *
     * @param stage - faza edycji, 0 - przed, 1 - otwarcie edytora, 2 - zakończenie edycji
     * @param rowId - identyfikator wiersza
     * @param cellIndex - index komórki
     * @param value - nowa wartość (etap 2)
     * @param oldValue - stara wartość (etap 2)
     * @returns {boolean}
     */


    _createClass(Control, [{
      key: "onEditCell",
      value: function onEditCell(stage, rowId, cellIndex, value, oldValue) {
        var columnId = this.grid.getColumnId(cellIndex);
        var columnDefinition = this.columnDefinitionSource.getByDataIndex(columnId);
        var isEditable;

        if (this.gridDataProcessor.getState(rowId) === "inserted") {
          isEditable = !!columnDefinition.isEditableOnAdd;
        } else {
          isEditable = !!columnDefinition.isEditable;
        }

        return isEditable;
      }
      /**
       * Obsługa eventu o zmianie zaznaczenia i triggerowanie tablicy z identyfikatorami DHTMLX-owych wierszy.
       *
       * @param id - identyfikator (null, lub string z identyfikatorami przedzielonymi przecinkami - patrz: DHTMLX this.grid api)
       */

    }, {
      key: "onSelectStateChanged",
      value: function onSelectStateChanged(id) {
        if (id === null) {
          this.trigger("onSelectionChange", []);
        } else {
          var idsArray = id.split(",");
          this.trigger("onSelectionChange", idsArray);
        }
      }
    }, {
      key: "getSelectedRowIds",
      value: function getSelectedRowIds() {
        var idsArray = [];
        var id = this.grid.getSelectedRowId();

        if (id !== null) {
          idsArray = id.split(",");
        }

        return idsArray.length > 0 ? idsArray[0] : null;
      }
      /**
       * Listener
       * @param columnIndex
       * @param dhtmlXGridObject this.gridObj
       * @param direction
       * @returns {boolean}
       */

    }, {
      key: "onBeforeSorting",
      value: function onBeforeSorting(columnIndex, dhtmlXGridObject, direction) {
        var columnDataIndex = this.grid.getColumnId(columnIndex);
        var columnDefinition = this.columnDefinitionSource.getByDataIndex(columnDataIndex);
        this.dataSource.orderBy(columnDefinition.dataIndex, direction);
        this.settingsManager.set(this.gridId + "_sort_column", columnDataIndex);
        this.settingsManager.set(this.gridId + "_sort_direction", direction);
        this.settingsManager.save();
        this.load();
        return false;
      }
      /**
       * @param _ Indeks przesuwanej kolumny
       * @param posIndex Indeks nowej pozycji
       */

    }, {
      key: "onAfterColumnMove",
      value: function onAfterColumnMove(_, posIndex) {
        for (var columnIndex = 0; columnIndex < this.columnDefinitionSource.count(); columnIndex++) {
          var columnDataIndex = this.grid.getColumnId(columnIndex);
          this.settingsManager.set(this.gridId + "_" + columnDataIndex + "_position", columnIndex);
        }

        this.settingsManager.save();
        return true;
      }
      /**
       * @param columnIndex
       * @param hidden
       */

    }, {
      key: "onColumnHidden",
      value: function onColumnHidden(columnIndex, hidden) {
        var columnDataIndex = this.grid.getColumnId(columnIndex);
        this.settingsManager.set(this.gridId + "_" + columnDataIndex + "_hidden", hidden);
        this.settingsManager.save();
      }
      /**
       * @param columnIndex
       * @param width
       */

    }, {
      key: "onColumnResize",
      value: function onColumnResize(columnIndex, width) {
        var columnDataIndex = this.grid.getColumnId(columnIndex);
        this.settingsManager.set(this.gridId + "_" + columnDataIndex + "_width", parseInt(width));
        return true;
      }
      /**
       * Powiadomienie o zakończeniu zmiany rozmiaru kolumny - zapisujemy ustawienia.
       *
       * @param gridObject
       */

    }, {
      key: "onColumnResizeEnd",
      value: function onColumnResizeEnd(gridObject) {
        this.settingsManager.save();
        return true;
      }
    }, {
      key: "onLoadStart",
      value: function onLoadStart() {
        this.maskMe(true);
      }
    }, {
      key: "onLoadEnd",
      value: function onLoadEnd() {
        this.maskMe(false);
      }
      /**
       * Funkcja zastępująca domyślne filtrowanie this.grida.
       *
       * UWAGA: W przypadku filtrowania, wykorzystywana jest metoda getFilterElement, która działa na indeksie kolumny,
       * czyli na jej numerze, ale ustawionym na początku. Czyli np. po przesunięciu kolumny (zmianie kolejności)
       * getFilterElement i tak przyjmuje index z przed przesunięcia.
       *
       */

    }, {
      key: "filterGrid",
      value: function filterGrid() {
        var values = [];
        var columnIndex = 0;
        var len = this.columnDefinitionSource.count();

        for (; columnIndex < len; columnIndex++) {
          var input = this.grid.getFilterElement(columnIndex);
          var value = input ? input.value : null;
          var columnDefinition = this.columnDefinitionSource.getByIndex(columnIndex);

          if (value) {
            values.push({
              "dataIndex": columnDefinition.dataIndex,
              "value": value
            });
          }
        }

        this.dataSource.filterBy(values);
        this.load();
      }
      /**
       * Maskowanie kontrolki za pomocą elementu o id this.containerId + "-mask".
       * @param show
       */

    }, {
      key: "maskMe",
      value: function maskMe(show) {
        var loadingMask = document.getElementById(this.containerId + "-mask");

        if (show) {
          loadingMask.style.display = "block";
        } else {
          loadingMask.style.display = "none";
        }
      }
      /**
       * Aktualizacja this.grida o ustawienia zapisane w managerze.
       */

    }, {
      key: "applySettings",
      value: function applySettings() {
        //pozycje, według których poustawiamy kolumny
        var positions = [];
        var widths = {};
        var hiddenColumns = {};

        for (var columnIndex = 0; columnIndex < this.columnDefinitionSource.count(); columnIndex++) {
          var columnDefinition = this.columnDefinitionSource.getByIndex(columnIndex);
          var dataIndex = columnDefinition.dataIndex;
          var width = this.settingsManager.get(this.gridId + "_" + dataIndex + "_width", -1);
          var position = this.settingsManager.get(this.gridId + "_" + dataIndex + "_position", -1);
          var hidden = this.settingsManager.get(this.gridId + "_" + dataIndex + "_hidden", false);

          if (position >= 0) {
            positions[position] = dataIndex;
          }

          if (width > 0) {
            widths[dataIndex] = width;
          }

          hiddenColumns[dataIndex] = hidden;
        }

        for (var _position in positions) {
          if (!positions.hasOwnProperty(_position)) {
            continue;
          }

          var _dataIndex = positions[_position];

          var _columnIndex = this.grid.getColIndexById(_dataIndex);

          this.grid.moveColumn(_columnIndex, _position);
        }

        for (var _dataIndex2 in widths) {
          var _width = widths[_dataIndex2];

          var _columnIndex2 = this.grid.getColIndexById(_dataIndex2);

          this.grid.setColWidth(_columnIndex2, parseInt(_width) + "px");
        }

        for (var _dataIndex3 in hiddenColumns) {
          var _hidden = hiddenColumns[_dataIndex3];

          var _columnIndex3 = this.grid.getColIndexById(_dataIndex3);

          this.grid.setColumnHidden(_columnIndex3, _hidden);
        }
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        if (this.grid !== null) {
          throw new Error("Grid already exists.");
        }

        var gridContainerWidth = document.getElementById(this.containerId).offsetWidth;
        var defaultColumnWidth = parseInt(gridContainerWidth / this.columnDefinitionSource.count()); //Poniższa konfiguracja musi być wywołana we wskazanej kolejności - chociażby dla tego, żeby
        //uwzględnić ustawianie wyrównywania wartości w kolumnach (setColAlign)

        this.grid = new dhtmlXGridObject(this.containerId + "-this.gridbox");
        this.grid.setColumnIds(this.createColumnsConfiguration("dataIndex", {}));
        this.grid.setHeader(this.createHeaderConfiguration());
        this.grid.setColAlign(this.createColumnsAlignConfiguration());
        this.grid.setColTypes(this.createColumnsTypeConfiguration());
        this.grid.setInitWidths(this.createColumnsConfiguration("width", {}, defaultColumnWidth));
        this.grid.setColumnMinWidth(this.createColumnsConfiguration("minWidth", {}, 40));
        this.grid.enableValidation(true);
        this.grid.enableColumnMove(true, this.createColumnsConfiguration("isMovable", {
          "true": "true",
          "false": "false"
        }));
        this.grid.setColSorting(this.createColumnsConfiguration("isSortable", {
          "true": "server",
          "false": "na"
        }));
        this.grid.attachHeader(this.createColumnsConfiguration("isFilterable", {
          "true": "#text_filter",
          "false": "&nbsp"
        }));

        if (this.allowMultiselect) {
          this.grid.enableMultiselect(true);
        }

        if (this.enableMultiline) {
          this.grid.enableMultiline(true);
        }

        this.grid.setDateFormat("%Y-%m-%d %H:%i:00", "%Y-%m-%d %H:%i");

        if (!this.showAllRows) {
          this.initPaging();
        }

        this.grid.enableAutoHeight(true);
        this.grid.setImagesPath("/images/app/vendor/dhtmlx/");
        this.grid.init();
        this.grid.setStyle(null, "color:red;", null, null);
        this.applySettings(); //włączenie opcji ukrywania / pokazywania kolumn

        this.grid.enableHeaderMenu();
        var me = this; //podpięcie eventów

        this.grid.attachEvent("onBeforeSorting", function (id, type, direction) {
          return me.onBeforeSorting(id, type, direction);
        });
        this.grid.attachEvent("onAfterCMove", function (columnIndex, newPosition) {
          return me.onAfterColumnMove(columnIndex, newPosition);
        });
        this.grid.attachEvent("onColumnHidden", function (columnIndex, state) {
          return me.onColumnHidden(columnIndex, state);
        });
        this.grid.attachEvent("onResize", function (cellIndex, cellWidth, gridObject) {
          return me.onColumnResize(cellIndex, cellWidth, gridObject);
        });
        this.grid.attachEvent("onResizeEnd", function (gridObject) {
          return me.onColumnResizeEnd(gridObject);
        });
        this.grid.attachEvent("onXLS", function (gridObject) {
          return me.onLoadStart(gridObject);
        });
        this.grid.attachEvent("onXLE", function (gridObject, addedRowsCount) {
          return me.onLoadEnd(gridObject, addedRowsCount);
        });
        this.grid.attachEvent("onEditCell", function (stage, rowIndex, cellIndex, newValue, oldValue) {
          return me.onEditCell(stage, rowIndex, cellIndex, newValue, oldValue);
        });
        this.grid.attachEvent("onSelectStateChanged", function (id) {
          return me.onSelectStateChanged(id);
        });
        this.grid.attachEvent("onPageChanged", function (calendar, rowIndex, columnIndex) {//TODO: implementacja grupowania
          //me.grid.groupBy(4);
        }); //przesłonięcie standardowych funkcji this.grida

        this.grid.filterByAll = function () {
          me.filterGrid();
        };
      }
    }, {
      key: "prepareDom",
      value: function prepareDom() {
        var gridContainer = document.getElementById(this.containerId);
        var gridContainerGridBox = document.createElement('div');
        gridContainerGridBox.id = this.containerId + "-this.gridbox";
        gridContainerGridBox.style.width = "100%";
        gridContainerGridBox.style.height = "100%";
        var gridContainerPagingBox = document.createElement('div');
        gridContainerPagingBox.id = this.containerId + "-pagingbox";
        var loadingMask = document.createElement("div");
        loadingMask.id = this.containerId + "-mask";
        loadingMask.className = "loading-overlay";
        var loadingIcon = document.createElement("span");
        loadingIcon.className = "loading";
        loadingMask.appendChild(loadingIcon);
        gridContainer.appendChild(gridContainerGridBox);
        gridContainer.appendChild(gridContainerPagingBox);
        gridContainer.appendChild(loadingMask);
      }
    }, {
      key: "load",
      value: function load() {
        var _this = this;

        if (!this.dataSource) {
          throw new Error("No data source defined.");
        }

        this.grid.clearAll();
        var g = this.grid;

        if (this.loadCallback !== null) {
          g.load(this.dataSource.prepareUrl(), function () {
            _this.loadCallback(g);
          }, 'js');
        } else {
          g.load(this.dataSource.prepareUrl(), 'js');
        } //TODO: implementacja grupowania
        //this.grid.groupBy(4);


        var orderBy = this.dataSource.getOrderBy();

        if (orderBy.dataIndex && orderBy.order) {
          var columnIndex = this.grid.getColIndexById(orderBy.dataIndex);
          this.grid.setSortImgState(true, columnIndex, orderBy.order);
        }
      }
    }, {
      key: "createDataProcessor",
      value: function createDataProcessor() {
        if (this.dataSource.getUpdateUrl() === null) {
          return;
        }

        var me = this;
        var url = this.dataSource.getUpdateUrl();
        this.gridDataProcessor = new dataProcessor(url);
        this.gridDataProcessor.init(this.grid);
        this.gridDataProcessor.setTransactionMode("REST", true);
        this.gridDataProcessor.setUpdateMode("off");
        this.gridDataProcessor.enableDataNames(true);
        this.gridDataProcessor.attachEvent("onRowMark", function () {
          me.trigger("onDataChanged");
          return true;
        });
        this.gridDataProcessor.attachEvent("onFullSync", function () {
          me.trigger("onDataSaved");
          me.load();
          return true;
        });
        this.gridDataProcessor.attachEvent("onAfterUpdate", function (id, action, tid, response) {
          if (action === "invalid") {
            var errors = response.errors ? response.errors : {};

            for (var dataIndex in errors) {
              if (!errors.hasOwnProperty(dataIndex)) {
                continue;
              }

              var columnIndex = me.grid.getColIndexById(dataIndex);
              var cell = me.grid.cells(id, columnIndex);
              cell.setBgColor("#ffaaaa");
            }

            me.trigger("onDataInvalid");
          } else if (action === "error") {
            me.trigger("onDataError", response.msg);
          }
        });
      }
    }, {
      key: "initPaging",
      value: function initPaging() {
        this.grid.i18n.paging = {
          results: "Wyniki",
          records: "Wyniki od ",
          to: " do ",
          page: "Strona ",
          perpage: "Rekordów na stronie",
          first: "Pierwsza strona",
          previous: "Poprzednia strona",
          found: "Znalezionych rekordów ",
          next: "Następna strona",
          last: "Ostatnia strona",
          of: " z ",
          notfound: "Brak wyników"
        };
        this.grid.enablePaging(true, this.pageSize, 10, this.containerId + "-pagingbox", true);
        this.grid.setPagingSkin("bricks");
      }
    }, {
      key: "createHeaderConfiguration",
      value: function createHeaderConfiguration() {
        return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
          var label = columnDefinition["label"];
          return '<div class="dhtmlx-grid-header-label" title="' + label + '">' + label + '</div>';
        }).join(",");
      }
    }, {
      key: "createColumnsConfiguration",
      value: function createColumnsConfiguration(index, mapping, defaultValue) {
        return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
          var resolver = new NS.Utils.OptionsResolver(columnDefinition);
          var value = resolver.getOption(index, null);

          if (mapping[value]) {
            return mapping[value];
          } else {
            return value ? value : defaultValue;
          }
        }).join(",");
      }
    }, {
      key: "createColumnsAlignConfiguration",
      value: function createColumnsAlignConfiguration() {
        return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
          var dataType = columnDefinition.dataType;
          var align;

          switch (dataType) {
            case "boolean":
              align = "center";
              break;

            default:
              align = "left";
          }

          return align;
        }).join(",");
      }
    }, {
      key: "createColumnsTypeConfiguration",
      value: function createColumnsTypeConfiguration() {
        return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
          var dataType;

          switch (columnDefinition.dataType) {
            case "number":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "edn" : "ron";
              break;

            case "text":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "ed" : "rotxt";
              break;

            case "textarea":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "txt" : "txt";
              break;

            case "link":
              dataType = columnDefinition.dataType;
              break;

            case "datetime":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "dhxCalendarA" : "rotxt";
              break;

            case 'boolean':
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "boolean" : "boolean";
              break;

            case "actions":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "actions" : "actions";
              break;

            case "blocked":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "blocked" : "blocked";
              break;

            case "importants":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "importants" : "importants";
              break;

            case "reports":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "reports" : "reports";
              break;

            case "danger":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "danger" : "danger";
              break;

            case "download_status":
              dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "download_status" : "download_status";
              break;

            default:
              dataType = "ro";
              break;
          }

          return dataType;
        }).join(",");
      }
    }, {
      key: "validateConfiguration",
      value: function validateConfiguration() {
        if (!this.gridId) {
          throw new Error("Unknown this.grid control identifier. Provide 'id' value in configuration.");
        }

        if (!this.containerId) {
          throw new Error("Unknown this.grid control container DOM id. Provide 'this.containerId' value in configuration.");
        }

        if (this.columnDefinitionSource.count() === 0) {
          throw new Error("No column definitions.");
        }

        if (!this.dataSource) {
          throw new Error("No data source defined. Provide this.dataSource parameter (i.e. new NS.Grid.SimpleDataSource({ 'url': '/data.json'});");
        }
      }
    }, {
      key: "trigger",
      value: function trigger(eventName, data) {
        if (this.listeners[eventName]) {
          data = data ? data : {};
          this.listeners[eventName].call(this, data);
        }
      }
      /**
       * Funkcja wczytuje dane inicjalne, aby uruchomić następnie tworzenie kontrolki
       */

    }, {
      key: "loadInitialData",
      value: function loadInitialData() {
        var leftToLoad = 2;
        var me = this;
        this.columnDefinitionSource.load(function () {
          leftToLoad--;

          if (leftToLoad === 0) {
            me.afterInit();
          }
        }); // noinspection JSUnusedLocalSymbols

        this.settingsManager.load(function () {
          leftToLoad--;

          if (leftToLoad === 0) {
            me.afterInit();
          }
        }, function (msg) {
          leftToLoad--;

          if (leftToLoad === 0) {
            me.afterInit();
          }
        });
      }
    }, {
      key: "afterInit",
      value: function afterInit() {
        this.validateConfiguration();
        this.createGrid();
        this.createDataProcessor();

        if (this.autoLoad) {
          this.load();
        } else {
          this.maskMe(false);
        }
      } //funkcje publiczne

    }, {
      key: "init",
      value: function init(config) {
        this.gridId = config.id ? config.id : null;
        this.showAllRows = config.showAllRows || false;
        this.containerId = config.containerId ? config.containerId : null;
        this.dataSource = config.dataSource ? config.dataSource : null;
        this.reloadTime = config.reloadTime ? config.reloadTime : null;
        this.autoLoad = config.autoLoad ? config.autoLoad : false;
        this.pageSize = config.pageSize ? config.pageSize : this.pageSize;
        this.listeners = config.listeners ? config.listeners : {};
        this.columnDefinitionSource = config.columnDefinitionSource ? config.columnDefinitionSource : null;
        this.settingsManager = config.settingsManager ? config.settingsManager : null;
        this.allowMultiselect = config.allowMultiselect ? config.allowMultiselect : false;
        this.enableMultiline = config.enableMultiline ? config.enableMultiline : false;
        this.loadCallback = config.loadCallback ? config.loadCallback : null;
        this.prepareDom();
        this.loadInitialData();
      }
    }, {
      key: "createNewRecord",
      value: function createNewRecord(record) {
        var me = this;
        var newId = new Date().valueOf();
        var recordValues = [];

        for (var colIndex = 0; colIndex < this.columnDefinitionSource.count(); colIndex++) {
          var columnDefinition = this.columnDefinitionSource.getByIndex(colIndex);
          var columnDataIndex = columnDefinition.dataIndex;
          recordValues[this.grid.getColIndexById(columnDataIndex)] = record[columnDataIndex];
        }

        var firstEditableDataIndex = this.columnDefinitionSource.getFirstEditableDataIndex(
        /* newRecord = */
        true);
        var firstEditableIndex = firstEditableDataIndex ? this.grid.getColIndexById(firstEditableDataIndex) : -1;
        this.grid.addRow(newId, recordValues, 0);
        this.grid.selectRow(0);

        if (firstEditableIndex >= 0) {
          this.grid.selectCell(0, firstEditableIndex, false, true);
          setTimeout(function () {
            me.grid.editCell();
          }, 2);
        }
      }
    }, {
      key: "rowDelete",
      value: function rowDelete() {
        this.grid.deleteRow("1");
      }
    }, {
      key: "saveChanges",
      value: function saveChanges() {
        this.gridDataProcessor.sendData();
      }
    }, {
      key: "reload",
      value: function reload() {
        this.load();
      }
      /**
       * @deprecated
       */

    }, {
      key: "getGridObject",
      value: function getGridObject() {
        return this.dhtmlxObject();
      }
    }, {
      key: "dhtmlxObject",
      value: function dhtmlxObject() {
        return this.grid;
      }
    }]);

    return Control;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Grid = global.NS.Grid || {};
  global.NS.Grid.Control = Control;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  // deklaracja klasy
  var CookiesSettingsManager = /*#__PURE__*/function () {
    function CookiesSettingsManager(config) {
      _classCallCheck(this, CookiesSettingsManager);

      //deklaracje zmiennych prywatnych
      this.settingsIdentifier = null;
      this.settings = {};
      this.init(config);
    } //funkcje publiczne


    _createClass(CookiesSettingsManager, [{
      key: "init",
      value: function init(config) {
        this.settingsIdentifier = config.id;

        if (!this.settingsIdentifier) {
          throw new Error("Please set id in constructor.");
        }
      }
      /**
       * @param successCallback
       * @param failureCallback
       */

    }, {
      key: "load",
      value: function load(successCallback, failureCallback) {
        this.settings = {};
        var fromCookie = Cookies.get(this.settingsIdentifier + "_cookie");

        if (fromCookie) {
          this.settings = JSON.parse(fromCookie);
        }

        successCallback.call(this);
      }
    }, {
      key: "save",
      value: function save() {
        Cookies.set(this.settingsIdentifier + "_cookie", this.settings);
      }
    }, {
      key: "get",
      value: function get(key, defaultValue) {
        var retVal = defaultValue ? defaultValue : null;

        if (this.settings[key] !== null) {
          retVal = this.settings[key];
        }

        return retVal;
      }
    }, {
      key: "set",
      value: function set(key, value) {
        this.settings[key] = value;
      }
    }]);

    return CookiesSettingsManager;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Grid = global.NS.Grid || {};
  global.NS.Grid.CookiesSettingsManager = CookiesSettingsManager;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DatabaseSettingsManager = /*#__PURE__*/function () {
    function DatabaseSettingsManager(config) {
      _classCallCheck(this, DatabaseSettingsManager);

      this.saveUrl = null;
      this.getUrl = null;
      this.settingsIdentifier = null;
      this.settings = {};
      this.init(config);
    }

    _createClass(DatabaseSettingsManager, [{
      key: "init",
      value: function init(config) {
        var options = new NS.Utils.OptionsResolver(config);
        this.saveUrl = options.getOption("saveUrl");
        this.getUrl = options.getOption("getUrl");
        this.settingsIdentifier = options.getOption("id");

        if (!this.settingsIdentifier) {
          throw new Error("Please set id in constructor.");
        }

        if (!this.saveUrl || !this.getUrl) {
          throw new Error("save or get url not defined - provide them in constructor.");
        }
      }
    }, {
      key: "load",
      value: function load(successCallback, failureCallback) {
        var _this = this;

        $.ajax({
          url: this.getUrl,
          type: 'GET',
          dataType: 'json',
          data: {
            name: this.settingsIdentifier
          },
          success: function success(response) {
            if (response['success']) {
              _this.settings = response['data'] === null ? {} : response['data'];
              successCallback.call(_this);
            } else {
              failureCallback.call(_this);
            }
          },
          error: function error() {
            _this.settings = {};
            failureCallback.call(_this);
          }
        });
      }
    }, {
      key: "save",
      value: function save() {
        $.ajax({
          url: this.saveUrl,
          type: 'POST',
          dataType: 'json',
          data: {
            name: this.settingsIdentifier,
            content: JSON.stringify(this.settings)
          },
          success: function success(response) {
            if (!response.success) {
              console.error("Błąd zapisu ustawień: ", response.error);
            }
          },
          error: function error() {
            console.error("Błąd zapisu ustawień.");
          }
        });
      }
    }, {
      key: "get",
      value: function get(key, defaultValue) {
        var retVal = defaultValue ? defaultValue : null;

        if (this.settings[key] !== null) {
          retVal = this.settings[key];
        }

        return retVal;
      }
    }, {
      key: "set",
      value: function set(key, value) {
        this.settings[key] = value;
      }
    }]);

    return DatabaseSettingsManager;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Grid = global.NS.Grid || {};
  global.NS.Grid.DatabaseSettingsManager = DatabaseSettingsManager;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } return method; }

(function (global) {
  //deklaracja klasy
  var SimpleColumnDefinitionSource = /*#__PURE__*/function () {
    function SimpleColumnDefinitionSource(config) {
      _classCallCheck(this, SimpleColumnDefinitionSource);

      this.columnDefinitions = [];
      this.init(config);
    } //funkcje publiczne


    _createClass(SimpleColumnDefinitionSource, [{
      key: "init",
      value: function init(config) {
        var temporaryColumnDefinitions = config.columnDefinitions ? config.columnDefinitions : [];
        this.columnDefinitions = _classStaticPrivateMethodGet(SimpleColumnDefinitionSource, SimpleColumnDefinitionSource, _prepare).call(SimpleColumnDefinitionSource, temporaryColumnDefinitions);
      }
      /**
       * @param successCallback
       * @param failureCallback
       */

    }, {
      key: "load",
      value: function load(successCallback, failureCallback) {
        successCallback.call(this);
      }
    }, {
      key: "getColumnDefinitions",
      value: function getColumnDefinitions() {
        return this.columnDefinitions;
      }
    }, {
      key: "getByDataIndex",
      value: function getByDataIndex(dataIndex) {
        var columnDefinition = null;

        for (var key in this.columnDefinitions) {
          if (!this.columnDefinitions.hasOwnProperty(key)) {
            continue;
          }

          if (this.columnDefinitions[key].dataIndex === dataIndex) {
            columnDefinition = this.columnDefinitions[key];
          }
        }

        return columnDefinition;
      }
    }, {
      key: "getByIndex",
      value: function getByIndex(index) {
        return this.columnDefinitions.length > index ? this.columnDefinitions[index] : null;
      }
    }, {
      key: "count",
      value: function count() {
        return this.columnDefinitions.length;
      }
      /**
       * Funkcja zwraca indeks pierwszej edytowalnej kolumny.
       *
       * @param newRecord - true oznacza, ze dla nowego rekordu (dodawanie rekordu), false oznacza, ze przy edycji rekordu
       * @returns {Number}
       */

    }, {
      key: "getFirstEditableDataIndex",
      value: function getFirstEditableDataIndex(newRecord) {
        newRecord = !!newRecord;
        var firstEditableDataIndex = null;

        for (var key in this.columnDefinitions) {
          if (!this.columnDefinitions.hasOwnProperty(key)) {
            continue;
          }

          var columnIsEditable = this.columnDefinitions[key].isEditable;
          var columnIsEditableOnAdd = this.columnDefinitions[key].isEditableOnAdd;

          if (columnIsEditable && newRecord === false || columnIsEditableOnAdd && newRecord === true) {
            firstEditableDataIndex = this.columnDefinitions[key].dataIndex;
            break;
          }
        }

        return firstEditableDataIndex;
      } //funkcje prywatne

    }]);

    return SimpleColumnDefinitionSource;
  }(); //wyeksportowanie klasy


  var _prepare = function _prepare(temporaryColumnDefinitions) {
    var results = [];
    var columnIndex = 0;
    var length = temporaryColumnDefinitions.length;

    for (; columnIndex < length; columnIndex++) {
      var temporaryColumnDefinition = temporaryColumnDefinitions[columnIndex];
      var resolver = new NS.Utils.OptionsResolver(temporaryColumnDefinition);
      var columnDefinition = {
        "label": temporaryColumnDefinition.label ? temporaryColumnDefinition.label : "Column " + parseInt(columnIndex),
        "dataIndex": temporaryColumnDefinition.dataIndex ? temporaryColumnDefinition.dataIndex : "data_" + parseInt(columnIndex),
        "dataType": temporaryColumnDefinition.dataType ? temporaryColumnDefinition.dataType : "text",
        "isEditable": temporaryColumnDefinition.isEditable ? temporaryColumnDefinition.isEditable : false,
        "isEditableOnAdd": temporaryColumnDefinition.isEditableOnAdd ? temporaryColumnDefinition.isEditableOnAdd : false,
        "isSortable": resolver.getOption("isSortable", true),
        "isFilterable": resolver.getOption("isFilterable", true),
        "isMovable": temporaryColumnDefinition.isMovable ? temporaryColumnDefinition.isMovable : true,
        "width": temporaryColumnDefinition.width ? temporaryColumnDefinition.width : null,
        "minWidth": temporaryColumnDefinition.minWidth ? temporaryColumnDefinition.minWidth : null
      };
      results.push(columnDefinition);
    }

    return results;
  };

  global.NS = global.NS || {};
  global.NS.Grid = global.NS.Grid || {};
  global.NS.Grid.SimpleColumnDefinitionSource = SimpleColumnDefinitionSource;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function (global) {
  //deklaracja klasy
  var SimpleDataSource = /*#__PURE__*/function () {
    function SimpleDataSource(config) {
      _classCallCheck(this, SimpleDataSource);

      _defineProperty(this, "prepareBaseParametersQueryString", function () {
        var queryString = [];

        for (var key in this.baseParameters) {
          if (!this.baseParameters.hasOwnProperty(key)) {
            continue;
          }

          var value = this.baseParameters[key];

          if (value instanceof Array) {
            var subIndex = 0;
            var subLen = value.length;

            for (; subIndex < subLen; subIndex++) {
              queryString.push(key + "[]=" + value[subIndex]);
            }
          } else {
            queryString.push(key + "=" + value);
          }
        }

        return queryString;
      });

      /**
       * Adres dostępowy do danych
       */
      this.baseUrl = null;
      /**
       * Adres na który będą wysyłane zapytania do aktualizacji.
       *
       * @type String
       */

      this.updateUrl = null;
      /**
       * Podstawowe parametry przekazywane razem z każdym requestem.
       *
       * @type Object
       */

      this.baseParameters = {};
      this.filterValues = [];
      this.sortValues = {
        "order": null,
        "dataIndex": null
      };
      this.init(config);
    }

    _createClass(SimpleDataSource, [{
      key: "init",
      value: function init(config) {
        this.baseUrl = config.url ? config.url : null;
        this.baseParameters = config.baseParameters ? config.baseParameters : {};
        this.updateUrl = config.updateUrl ? config.updateUrl : config.url;
      }
    }, {
      key: "filterBy",
      value: function filterBy(values) {
        this.filterValues = values;
      }
    }, {
      key: "orderBy",
      value: function orderBy(dataIndex, direction) {
        this.sortValues.dataIndex = dataIndex;
        this.sortValues.order = direction;
      }
    }, {
      key: "getOrderBy",
      value: function getOrderBy() {
        return this.sortValues;
      }
    }, {
      key: "getUpdateUrl",
      value: function getUpdateUrl() {
        var retVal = null;

        if (this.updateUrl !== null) {
          var baseQueryString = this.prepareBaseParametersQueryString();
          retVal = this.updateUrl + (this.updateUrl.indexOf("?") > -1 ? "&" : "?") + baseQueryString.join("&");
        }

        return retVal;
      }
    }, {
      key: "changeParameterValue",
      value: function changeParameterValue(key, value) {
        this.baseParameters[key] = value;
      }
    }, {
      key: "prepareUrl",
      value: function prepareUrl() {
        var url = this.baseUrl;
        var queryString;
        queryString = this.filterValues.map(function (filterValue) {
          return "filters[" + filterValue.dataIndex + "]=" + encodeURIComponent(filterValue.value);
        });
        queryString = queryString.concat(this.prepareBaseParametersQueryString());

        if (this.sortValues.dataIndex && this.sortValues.order) {
          queryString.push("sort[order]=" + encodeURIComponent(this.sortValues.order));
          queryString.push("sort[key]=" + encodeURIComponent(this.sortValues.dataIndex));
        }

        return url + (url.indexOf("?") > -1 ? "&" : "?") + (queryString.length > 0 ? queryString.join("&") : '');
      }
    }]);

    return SimpleDataSource;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Grid = global.NS.Grid || {};
  global.NS.Grid.SimpleDataSource = SimpleDataSource;
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var SimpleOrderedTable = /*#__PURE__*/function () {
    function SimpleOrderedTable(config) {
      _classCallCheck(this, SimpleOrderedTable);

      this.init(config);
    }

    _createClass(SimpleOrderedTable, [{
      key: "init",
      value: function init(config) {
        this.config = config;
        this.drawTable(this.prepareData());
      }
    }, {
      key: "prepareData",
      value: function prepareData() {
        return this.config["data"];
      }
    }, {
      key: "drawTable",
      value: function drawTable(data) {
        var id = this.config["table-id"];
        var tableSelector = '#' + id;
        var ordinal = 1;
        var me = this;
        var rowHtml;
        var value;
        $(tableSelector).html('');
        data.rows.forEach(function (row) {
          rowHtml = '<tr data-id="' + row.id + '"><td>' + ordinal++ + '</td>';
          me.config.fields.forEach(function (fieldName) {
            value = row[fieldName];

            if (Array.isArray(value)) {
              value = value.join("\n");
            }

            rowHtml += '<td>' + value + '</td>';
          });
          rowHtml += '<td><button class="edit">Edytuj</button></td>';
          $('#' + id).append(rowHtml);
        });
        rowHtml = '<tr><td>' + ordinal++ + '</td>';
        me.config.fields.forEach(function () {
          rowHtml += '<td></td>';
        });
        rowHtml += '<td><button class="add">Dodaj</button></td>';
        $(tableSelector).append(rowHtml);
      }
    }]);

    return SimpleOrderedTable;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Grid = global.NS.Grid || {};
  global.NS.Grid.SimpleOrderedTable = SimpleOrderedTable || {};
})(window);
"use strict";

//CUSTOMOWE KOLUMNY
function eXcell_importants(cell) {
  if (cell) {
    this.cell = cell;
    this.grid = this.cell.parentNode.grid;
  }

  this.edit = function () {};

  this.isDisabled = function () {
    return true;
  };

  this.setValue = function (val) {
    if (val.toUpperCase() === 'LOW' || val.toUpperCase() === 'NISKI') {
      val = '<span class="priority-icon priority-low">Niska</span>';
    }

    if (val.toUpperCase() === 'MEDIUM' || val.toUpperCase() === 'ŚREDNI') {
      val = '<span class="priority-icon priority-medium">Średnia</span>';
    }

    if (val.toUpperCase() === 'HIGH' || val.toUpperCase() === 'WYSOKI') {
      val = '<span class="priority-icon priority-high">Wysoka</span>';
    }

    this.setCValue(val);
  };
} // noinspection JSPotentiallyInvalidConstructorUsage


eXcell_importants.prototype = new eXcell();

function eXcell_download_status(cell) {
  if (cell) {
    this.cell = cell;
    this.grid = this.cell.parentNode.grid;
  }

  this.edit = function () {};

  this.isDisabled = function () {
    return true;
  };

  this.setValue = function (val) {
    if (val.toUpperCase() === 'RECENT') {
      val = '<span class="download-status download-recent">Pobrano</span>';
    }

    if (val.toUpperCase() === 'LATE') {
      val = '<span class="download-status download-late">Pobrano ponad 24h temu</span>';
    }

    if (val.toUpperCase() === 'NEVER') {
      val = '<span class="download-status download-never">Nigdy nie pobrano</span>';
    }

    this.setCValue(val);
  };
} // noinspection JSPotentiallyInvalidConstructorUsage


eXcell_download_status.prototype = new eXcell();

function eXcell_blocked(cell) {
  if (cell) {
    this.cell = cell;
    this.grid = this.cell.parentNode.grid;
  }

  this.edit = function () {};

  this.isDisabled = function () {
    return true;
  };

  this.setValue = function (val) {
    if (val.toUpperCase() === 'NOTIFIED') {
      val = 'Loguj';
    }

    if (val.toUpperCase() === 'BLOCKED') {
      val = 'Blokuj';
    }

    this.setCValue(val);
  };
} // noinspection JSPotentiallyInvalidConstructorUsage


eXcell_blocked.prototype = new eXcell();

function eXcell_danger(cell) {
  if (cell) {
    this.cell = cell;
    this.grid = this.cell.parentNode.grid;
  }

  this.edit = function () {};

  this.isDisabled = function () {
    return true;
  };

  this.setValue = function (val) {
    if (val.toUpperCase() === 'LOW' || val.toUpperCase() === 'NISKI') {
      val = '<span class="priority-icon priority-low">Niskie</span>';
    }

    if (val.toUpperCase() === 'MEDIUM' || val.toUpperCase() === 'ŚREDNI') {
      val = '<span class="priority-icon priority-medium">Średnie</span>';
    }

    if (val.toUpperCase() === 'HIGH' || val.toUpperCase() === 'WYSOKI') {
      val = '<span class="priority-icon priority-high">Wysokie</span>';
    }

    this.setCValue(val);
  };
} // noinspection JSPotentiallyInvalidConstructorUsage


eXcell_danger.prototype = new eXcell();

function eXcell_reports(cell) {
  if (cell) {
    this.cell = cell;
    this.grid = this.cell.parentNode.grid;
  }

  this.edit = function () {};

  this.isDisabled = function () {
    return true;
  };

  this.setValue = function (val) {
    if (val.toUpperCase() === 'BRAK RAPORTU') {
      val = '<span class="c-red f-700">Brak raportu</span>';
    }

    if (val.toUpperCase() === 'RAPORT DODANO') {
      val = '<span class="c-green f-700">Raport dodano</span>';
    }

    this.setCValue(val);
  };
} // noinspection JSPotentiallyInvalidConstructorUsage


eXcell_reports.prototype = new eXcell();

function eXcell_boolean(cell) {
  //the eXcell name is defined here
  if (cell) {
    // the default pattern, just copy it
    this.cell = cell;
    this.grid = this.cell.parentNode.grid;
  }

  this.edit = function () {}; //read-only cell doesn't have edit method
  // the cell is read-only, so it's always in the disabled state


  this.isDisabled = function () {
    return true;
  };

  this.setValue = function (val) {
    if (val) {
      this.setCValue('<span class="dhtmlx-grid-checkbox-cnt"><input type="checkbox" checked disabled readonly><i class="state"></i></span>', val);
    } else {
      this.setCValue('<span class="dhtmlx-grid-checkbox-cnt"><input type="checkbox" disabled readonly><i class="state"></i></span>', val);
    }
  };
} // noinspection JSPotentiallyInvalidConstructorUsage


eXcell_boolean.prototype = new eXcell();

function eXcell_actions(cell) {
  if (cell) {
    this.cell = cell;
    this.grid = this.cell.parentNode.grid;
  }

  this.edit = function () {};

  this.isDisabled = function () {
    return true;
  };

  this.setValue = function (val) {
    var tmp = val.split(';');
    var actions = '';
    $.each(tmp, function (index, val) {
      var action = val.split('^');
      var name = action[0];

      if (action[0].endsWith('-confirm')) {
        name = val.split('-');
        name = name[0];
        actions += '<a href="' + action[1] + '" data-dialog="true" data-redirect="' + action[1] + '" data-cancel-button="true" data-confirm-button-text="TAK" data-cancel-button-text="NIE" data-type="warning" data-title="' + (action[2] || 'Czy jesteś pewien?') + '" data-confirm-button-color="#FF6601" class="m-r-15">' + name + '</a> ';
      } else if (action[0] === 'delete') {
        name = 'Usuń';
        actions += '<a href="' + action[1] + '" data-dialog="true" data-redirect="' + action[1] + '" data-cancel-button="true" data-confirm-button-text="TAK" data-cancel-button-text="NIE" data-type="warning" data-title="Czy na pewno chcesz usunąć ten element?" data-confirm-button-color="#FF6601" class="m-r-15">' + name + '</a> ';
      } else if (action[0] === 'download' || action[0] === 'Raport' || action[0] === 'Pobierz') {
        name = 'Pobierz';

        if (action[0] === 'Raport') {
          name = 'Raport';
        }

        actions += '<a href="' + action[1] + '" class="m-r-15">' + name + '</a>   ';
      } else {
        actions += '<a href="' + action[1] + '" class="m-r-15">' + name + '</a>   ';
      }
    });
    this.setCValue(actions);
    this.setAttribute('title', ' ');
    setTimeout(function () {
      ApiNotification.bindEvents();
    });
  };
} // noinspection JSPotentiallyInvalidConstructorUsage


eXcell_actions.prototype = new eXcell();
/**
 * Kontrolka odpowiedzialna za rysowanie wykresów słupkowych.
 * Dane w konfiguracji:
 *  container-id - id kontenera
 *  data - dane dla wykresu
 *  name-mapping - mapowanie danych w wykresie
 *  colors - kolory dla konkretnych partii danych
 * Funkcje:
 *  init()
 *  prepareData() - przygotowanie danych w formie określonej przez plugin chart.js
 *  drawChart() - rysowanie wykresu za pomocą pluginu chart.js
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var BarChart = /*#__PURE__*/function () {
    function BarChart(config) {
      _classCallCheck(this, BarChart);

      this.settings = {
        colors: {
          "1": "#ff6600",
          "2": "#4bb4e6",
          "3": "#fadc00",
          "4": "#50be87",
          "5": "#9164cd",
          "6": "#ffb4e6",
          "7": "#d54733"
        }
      };
      this.init(config);
    }

    _createClass(BarChart, [{
      key: "init",
      value: function init(config) {
        var settings = this.settings;
        var data;

        if (config["multidata"] === true) {
          data = this.prepareData(config, settings);
        } else {
          data = this.prepareSingleData(config, settings);
        }

        if (typeof config["show_legend"] == 'undefined' || typeof config['show_legend'] === 'undefined') {
          config["show_legend"] = true;
        }

        this.drawChart(config, data);
      }
    }, {
      key: "objectSize",
      value: function objectSize(object) {
        var keys = Object.keys(object);
        return keys.length;
      }
    }, {
      key: "colorLuminance",
      value: function colorLuminance(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, "");

        if (hex.length < 6) {
          hex = hex.replace(/(.)/g, '$1$1');
        }

        lum = lum || 0;
        var rgb = "#",
            c;

        for (var i = 0; i < 3; ++i) {
          c = parseInt(hex.substr(i * 2, 2), 16);
          c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
          rgb += ("00" + c).substr(c.length);
        }

        return rgb;
      }
    }, {
      key: "prepareData",
      value: function prepareData(config, settings) {
        var data = config["data"];
        var xAxis = [];
        var dataSet = {};
        var me = this;
        var colorsCounter = 1;
        var color;
        var colorHighlight;
        var colorRepeat = 0;
        $.each(data, function (index, val) {
          xAxis.push(val.name);
          $.each(val.values, function (index, val) {
            if (typeof dataSet[index] == 'undefined') {
              dataSet[index] = [];
            }

            dataSet[index].push(val);
          });
        });
        var tmpDataSet = [];
        $.each(dataSet, function (index, val) {
          if (typeof config["colors"] != 'undefined') {
            var tmp = config["colors"][index];
            color = "rgba(" + tmp + ",0.9)";
            colorHighlight = "rgba(" + tmp + ",1)";
          } else {
            var _tmp = settings["colors"][colorsCounter];

            if (colorsCounter >= me.objectSize(settings["colors"])) {
              colorsCounter = 1;
              colorRepeat++;
            }

            var lum = colorRepeat / 10;
            color = me.colorLuminance(_tmp, -lum); // color = "rgba(" + tmp + ",0.9)";

            colorHighlight = me.colorLuminance(_tmp, -lum - 0.05);
            colorsCounter++;
          }

          var name = index;

          if (typeof config["name_mapping"] != 'undefined') {
            $.each(config["name_mapping"], function (index, val) {
              if (name === index) {
                name = val;
              }
            });
          }

          tmpDataSet.push({
            label: name,
            fillColor: color,
            strokeColor: color,
            highlightFill: colorHighlight,
            highlightStroke: colorHighlight,
            data: val
          });
        });
        return {
          labels: xAxis,
          datasets: tmpDataSet
        };
      }
    }, {
      key: "prepareSingleData",
      value: function prepareSingleData(config, settings) {
        var data = config["data"];
        var columnsData = [];
        var xAxis = [];
        var me = this;
        var color = me.colorLuminance(settings["colors"][1], 0.1);
        var colorHighlight = settings["colors"][1];
        var name = data["name"];
        $.each(data["values"], function (index, val) {
          xAxis.push(index);
          columnsData.push(val);
        });
        return {
          labels: xAxis,
          datasets: [{
            label: name,
            fillColor: color,
            strokeColor: color,
            highlightFill: colorHighlight,
            highlightStroke: colorHighlight,
            data: columnsData
          }]
        };
      }
    }, {
      key: "drawChart",
      value: function drawChart(config, data) {
        var options = {
          scaleBeginAtZero: true,
          scaleShowGridLines: true,
          scaleGridLineColor: "rgba(0,0,0,.05)",
          scaleGridLineWidth: 1,
          scaleShowHorizontalLines: true,
          scaleShowVerticalLines: true,
          barShowStroke: true,
          barStrokeWidth: 0,
          barValueSpacing: 5,
          barDatasetSpacing: 1,
          legendTemplate: "<ul class=\"char-legend\"><% for (var i = 0; i < datasets.length; i++){%><li <%if(datasets[i].label){%>title=\"<%=datasets[i].label%>\"<%}%>><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><strong><%if(datasets[i].label){%><%=datasets[i].label%><%}%></strong></li><%}%></ul>",
          labelLength: config["labelLength"] || 99
        };
        var id = config["container-id"];
        var ctx = document.getElementById(id).getContext("2d"); // noinspection JSUnresolvedFunction

        var myBarChart = new Chart(ctx).Bar(data, options);

        if (config['show_legend']) {
          var legend = myBarChart.generateLegend();
          $('#' + id).parent().append(legend);
        }
      }
    }]);

    return BarChart;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Charts = global.NS.Charts || {};
  global.NS.Charts.BarChart = BarChart || {};
})(window);
/**
 * Kontrolka odpowiedzialna za rysowanie wykresów słupkowych.
 * Dane w konfiguracji:
 *  container-id - id kontenera
 *  data - dane dla wykresu
 *  name-mapping - mapowanie danych w wykresie
 *  colors - kolory dla konkretnych partii danych
 * Funkcje:
 *  init()
 *  prepareData() - przygotowanie danych w formie określonej przez plugin chart.js
 *  drawChart() - rysowanie wykresu za pomocą pluginu chart.js
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Chart.types.Line.extend({
  name: "LineAlt",
  draw: function draw() {
    if (typeof this.scale !== 'undefined') {
      this.scale.xScalePaddingLeft = 60; //przestrzeń dla lewej labelki
    } //this.scale.xScalePaddingRight = 130;


    Chart.types.Line.prototype.draw.apply(this, arguments);
    var ctx = this.chart.ctx;
    ctx.save(); // text alignment and color

    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.fillStyle = this.options.scaleFontColor; // position

    var x = this.scale.xScalePaddingLeft * 0.4 - 5;
    var y = this.chart.height / 2; // change origin

    ctx.translate(x, y); // rotate text

    ctx.rotate(-90 * Math.PI / 180);
    ctx.fillText(this.options.labelY, 0, 0);
    ctx.restore();
  }
});

(function (global) {
  var DdosProtocolChart = /*#__PURE__*/function () {
    function DdosProtocolChart(config) {
      _classCallCheck(this, DdosProtocolChart);

      this.settings = {
        colors: {
          "1": "#ff6600",
          "2": "#4bb4e6",
          "3": "#fadc00",
          "4": "#50be87",
          "5": "#9164cd",
          "6": "#ffb4e6",
          "7": "#d54733"
        }
      };
      this.options = null;
      this.myBarChart = null;
      this.init(config);
    }

    _createClass(DdosProtocolChart, [{
      key: "init",
      value: function init(config) {
        var settings = this.settings;
        var data;

        if (config["multidata"] === true) {
          data = this.prepareData(config, settings);
        } else {
          data = this.prepareSingleData(config, settings);
        }

        this.drawChart(config, data);
      }
    }, {
      key: "objectSize",
      value: function objectSize(object) {
        var keys = Object.keys(object);
        return keys.length;
      }
    }, {
      key: "colorLuminance",
      value: function colorLuminance(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, "");

        if (hex.length < 6) {
          hex = hex.replace(/(.)/g, '$1$1');
        }

        lum = lum || 0;
        var rgb = "#",
            c;

        for (var i = 0; i < 3; ++i) {
          c = parseInt(hex.substr(i * 2, 2), 16);
          c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
          rgb += ("00" + c).substr(c.length);
        }

        return rgb;
      }
    }, {
      key: "prepareData",
      value: function prepareData(config, settings) {
        var _this = this;

        var data = config["data"];
        var xAxis = [];
        var dataSet = {};
        var colorsCounter = 1;
        var colorHighlight;
        var colorRepeat = 0;
        var labelY = config["label_y"];
        var defaultShow = config["default_show"];
        $.each(data, function (index, val) {
          xAxis.push(val.name);

          if (val.values) {
            $.each(val.values, function (index, val) {
              if (typeof dataSet[index] == 'undefined') {
                dataSet[index] = [];
              }

              dataSet[index].push(val);
            });
          }
        });
        var tmpDataSet = [];
        var counter = 0;
        $.each(dataSet, function (index, val) {
          var color;

          if (typeof config["colors"] != 'undefined') {
            var _tmp = config["colors"][index];
            color = "rgba(" + _tmp + ",0.9)";
            colorHighlight = "rgba(" + _tmp + ",1)";
          } else {
            var _tmp2 = settings["colors"][colorsCounter];

            if (colorsCounter >= _this.objectSize(settings["colors"])) {
              colorsCounter = 1;
              colorRepeat++;
            }

            var lum = colorRepeat / 10;
            color = _this.colorLuminance(_tmp2, -lum); // color = "rgba(" + tmp + ",0.9)";

            colorHighlight = _this.colorLuminance(_tmp2, -lum - 0.05);
            colorsCounter++;
          }

          var name = index;

          if (typeof config["name_mapping"] != 'undefined') {
            $.each(config["name_mapping"], function (index, val) {
              if (name === index) {
                name = val;
              }
            });
          }

          var tmp = {
            label: name,
            fillColor: color,
            strokeColor: color,
            pointColor: color,
            pointStrokeColor: color,
            pointHighlightFill: colorHighlight,
            pointHighlightStroke: colorHighlight,
            data: val
          };
          tmpDataSet.push(tmp);
          counter++;
        });
        return {
          labels: xAxis,
          label_y: labelY,
          default_show: defaultShow,
          labels_store: xAxis,
          datasets: tmpDataSet,
          datastore: tmpDataSet
        };
      }
    }, {
      key: "prepareSingleData",
      value: function prepareSingleData(config, settings) {
        var data = config["data"];
        var columnsData = [];
        var xAxis = []; // noinspection JSUnresolvedVariable

        var labelY = data.label_y; // noinspection JSUnresolvedVariable

        var defaultShow = data.default_show;
        var color = this.colorLuminance(settings["colors"][1], 0.1);
        var colorHighlight = settings["colors"][1];
        var name = data["name"];
        $.each(data["values"], function (index, val) {
          xAxis.push(index);
          columnsData.push(val);
        });
        return {
          labels: [],
          label_y: labelY,
          default_show: defaultShow,
          labels_store: xAxis,
          datasets: [{
            label: name,
            fillColor: color,
            strokeColor: color,
            pointColor: color,
            pointStrokeColor: color,
            pointHighlightFill: colorHighlight,
            pointHighlightStroke: colorHighlight,
            data: columnsData
          }],
          datastore: [{
            label: name,
            fillColor: color,
            strokeColor: color,
            pointColor: color,
            pointStrokeColor: color,
            pointHighlightFill: colorHighlight,
            pointHighlightStroke: colorHighlight,
            data: columnsData
          }]
        };
      }
    }, {
      key: "legendEvents",
      value: function legendEvents(config, chart, data, options) {
        var $legend;

        if (config['show_legend']) {
          $legend = $('<ul class="char-legend"></ul>');
          var defaultShow = data['default_show']; // noinspection JSUnusedLocalSymbols

          $.each(data['datastore'], function (i, v) {
            var d = data['datastore'][i];
            var checked = $.inArray(d.label, defaultShow) !== -1 ? ' checked ' : '';
            $legend.append('<li><label><input type="checkbox" ' + checked + ' /><span style="background-color:' + d.strokeColor + '"></span><strong>' + d.label + '</strong></label></li>');
          });
          $('#' + config["container-id"]).parent().after($legend);
        }

        var $chk = $legend.find('input:checkbox');
        data['datasets'] = [];
        $chk.each(function () {
          var index = $chk.index($(this));

          if ($(this).is(':checked')) {
            data['datasets'].push(data['datastore'][index]); //data['labels'].push(data['labels_store'][index]);
          }
        });
        chart.destroy();
        var id = config["container-id"];
        var ctx = document.getElementById(id).getContext("2d"); // noinspection JSUnresolvedFunction

        chart = new Chart(ctx).LineAlt(data, options);
        $chk.on('click', function () {
          data['datasets'] = [];
          $chk.each(function () {
            var index = $chk.index($(this));

            if ($(this).is(':checked')) {
              data['datasets'].push(data['datastore'][index]); //data['labels'].push(data['labels_store'][index]);
            }
          });
          chart.destroy();
          var id = config["container-id"]; //przy przełączaniu nie potrzebujemy animacji

          options.animation = false;
          var ctx = document.getElementById(id).getContext("2d"); // noinspection JSUnresolvedFunction

          chart = new Chart(ctx).LineAlt(data, options);
        });
      }
    }, {
      key: "fixCanvasWidth",
      value: function fixCanvasWidth(id, config, data) {
        var $canvas = $('#' + id);
        var width = $canvas.parent().width();
        var targetWidth = data['labels'].length * 35 + 40;

        if (width < targetWidth) {
          $canvas.attr('width', targetWidth);
        } else {
          $canvas.attr('width', $canvas.parent().width());
        }

        $canvas.data('width', $canvas.width());
        $canvas.data('height', $canvas.height());
      }
    }, {
      key: "fixResize",
      value: function fixResize(id, config, data) {
        var _this2 = this;

        var $canvas = $('#' + id);
        var targetWidth = data['labels'].length * 35 + 40;
        var ctx = document.getElementById(id).getContext("2d");
        $(window).resize(function () {
          if (typeof _this2.myBarChart !== 'undefined' && _this2.myBarChart !== null) {
            if ($canvas.parent().width() < targetWidth) {
              $canvas.width(targetWidth);
            } else {
              $canvas.width($canvas.parent().width());
            }

            _this2.myBarChart.destroy();

            _this2.myBarChart = new Chart(ctx).Line(data, _this2.options);
            $canvas.height($canvas.data('height'));
          }
        });
      }
    }, {
      key: "drawChart",
      value: function drawChart(config, data) {
        var options = {
          animation: false,
          scaleBeginAtZero: true,
          scaleShowGridLines: true,
          scaleGridLineColor: "rgba(0,0,0,0.05)",
          scaleGridLineWidth: 1,
          scaleShowHorizontalLines: true,
          scaleShowVerticalLines: true,
          bezierCurve: true,
          bezierCurveTension: 0.3,
          pointDot: true,
          pointDotRadius: 4,
          pointDotStrokeWidth: 1,
          pointHitDetectionRadius: 10,
          datasetStroke: true,
          datasetStrokeWidth: 2,
          datasetFill: false,
          multiTooltipTemplate: "<%= datasetLabel %> - <%= value %>",
          labelY: data.label_y,
          onAnimationComplete: function onAnimationComplete() {
            var sourceCanvas = this.chart.ctx.canvas;
            var copyWidth = this.scale.xScalePaddingLeft - 5; // the +5 is so that the bottommost y axis label is not clipped off
            // we could factor this in using measureText if we wanted to be generic

            var copyHeight = this.scale.endPoint + 5;
            var targetCtx = document.getElementById(id + 'Axis').getContext("2d");
            targetCtx.canvas.width = copyWidth;
            targetCtx.fillStyle = 'rgba(255,255,255,0.8)';
            targetCtx.fillRect(0, 0, copyWidth, copyHeight);
            targetCtx.drawImage(sourceCanvas, 0, 0, copyWidth, copyHeight, 0, 0, copyWidth, copyHeight);
            this.chart.ctx.clearRect(0, 0, copyWidth, copyHeight); //usuwam domyślne dane
          }
        };
        this.options = options;
        var id = config["container-id"];
        var $containerSelector = $('#' + id);
        this.fixCanvasWidth(id, config, data, this.myBarChart);
        $containerSelector.wrap('<div class="chartAreaWrapper"></div>');
        $containerSelector.parent().wrap('<div class="chartWrapper"></div>');
        var height = $containerSelector.height();
        $containerSelector.parent().after('<canvas id="' + id + 'Axis" width="0" height="' + height + '"></canvas>'); //data.datasets = data.datastore;

        var ctx = document.getElementById(id).getContext("2d"); // noinspection JSUnresolvedFunction

        this.myBarChart = new Chart(ctx).LineAlt(data, this.options);
        this.fixResize(id, config, data, this.myBarChart);
        this.legendEvents(config, this.myBarChart, data, options);
        $containerSelector.parent().niceScroll({
          cursorcolor: '#FF6600',
          cursorborder: '0',
          cursorborderradius: '0',
          horizrailenabled: true,
          cursorwidth: 5,
          background: '#fafafa',
          autohidemode: false
        });
      }
    }]);

    return DdosProtocolChart;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Charts = global.NS.Charts || {};
  global.NS.Charts.DdosProtocolChart = DdosProtocolChart || {};
})(window);
/**
 * Kontrolka odpowiedzialna za rysowanie wykresów słupkowych.
 * Dane w konfiguracji:
 *  container-id - id kontenera
 *  data - dane dla wykresu
 *  name-mapping - mapowanie danych w wykresie
 *  colors - kolory dla konkretnych partii danych
 * Funkcje:
 *  init() 
 *  prepareData() - przygotowanie danych w formie określonej przez plugin chart.js
 *  drawChart() - rysowanie wykresu za pomocą pluginu chart.js
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var LineChart = /*#__PURE__*/function () {
    function LineChart(config) {
      _classCallCheck(this, LineChart);

      this.settings = {
        colors: {
          "1": "#ff6600",
          "2": "#4bb4e6",
          "3": "#fadc00",
          "4": "#50be87",
          "5": "#9164cd",
          "6": "#ffb4e6",
          "7": "#d54733"
        }
      };
      this.init(config);
    }

    _createClass(LineChart, [{
      key: "init",
      value: function init(config) {
        var settings = this.settings;
        var data;

        if (config["multidata"] === true) {
          data = this.prepareData(config, settings);
        } else {
          data = this.prepareSingleData(config, settings);
        }

        this.drawChart(config, data);
      }
    }, {
      key: "objectSize",
      value: function objectSize(object) {
        var keys = Object.keys(object);
        return keys.length;
      }
    }, {
      key: "colorLuminance",
      value: function colorLuminance(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, "");

        if (hex.length < 6) {
          hex = hex.replace(/(.)/g, '$1$1');
        }

        lum = lum || 0;
        var rgb = "#",
            c;

        for (var i = 0; i < 3; ++i) {
          c = parseInt(hex.substr(i * 2, 2), 16);
          c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
          rgb += ("00" + c).substr(c.length);
        }

        return rgb;
      }
    }, {
      key: "prepareData",
      value: function prepareData(config, settings) {
        var data = config["data"];
        var xAxis = [];
        var dataSet = {};
        var me = this;
        var colorsCounter = 1;
        var color;
        var colorHighlight;
        var colorRepeat = 0;
        $.each(data, function (index, val) {
          xAxis.push(val.name);
          $.each(val.values, function (index, val) {
            if (typeof dataSet[index] == 'undefined') {
              dataSet[index] = [];
            }

            dataSet[index].push(val);
          });
        });
        var tmpDataSet = [];
        $.each(dataSet, function (index, val) {
          if (typeof config["colors"] != 'undefined') {
            var tmp = config["colors"][index];
            color = "rgba(" + tmp + ",0.9)";
            colorHighlight = "rgba(" + tmp + ",1)";
          } else {
            var _tmp = settings["colors"][colorsCounter];

            if (colorsCounter >= me.objectSize(settings["colors"])) {
              colorsCounter = 1;
              colorRepeat++;
            }

            var lum = colorRepeat / 10;
            color = me.colorLuminance(_tmp, -lum); // color = "rgba(" + tmp + ",0.9)";

            colorHighlight = me.colorLuminance(_tmp, -lum - 0.05);
            colorsCounter++;
          }

          var name = index;

          if (typeof config["name_mapping"] != 'undefined') {
            $.each(config["name_mapping"], function (index, val) {
              if (name === index) {
                name = val;
              }
            });
          }

          tmpDataSet.push({
            label: name,
            fillColor: color,
            strokeColor: color,
            pointColor: color,
            pointStrokeColor: color,
            pointHighlightFill: colorHighlight,
            pointHighlightStroke: colorHighlight,
            data: val
          });
        });
        return {
          labels: xAxis,
          datasets: tmpDataSet
        };
      }
    }, {
      key: "prepareSingleData",
      value: function prepareSingleData(config, settings) {
        var data = config["data"];
        var columnsData = [];
        var xAxis = [];
        var me = this;
        var color = me.colorLuminance(settings["colors"][1], 0.1);
        var colorHighlight = settings["colors"][1];
        var name = data["name"];
        $.each(data["values"], function (index, val) {
          xAxis.push(index);
          columnsData.push(val);
        });
        return {
          labels: xAxis,
          datasets: [{
            label: name,
            fillColor: color,
            strokeColor: color,
            pointColor: color,
            pointStrokeColor: color,
            pointHighlightFill: colorHighlight,
            pointHighlightStroke: colorHighlight,
            data: columnsData
          }]
        };
      }
    }, {
      key: "drawChart",
      value: function drawChart(config, data) {
        var options = {
          scaleBeginAtZero: true,
          scaleShowGridLines: true,
          scaleGridLineColor: "rgba(0,0,0,0.05)",
          scaleGridLineWidth: 1,
          scaleShowHorizontalLines: true,
          scaleShowVerticalLines: true,
          bezierCurve: true,
          bezierCurveTension: 0.3,
          pointDot: true,
          pointDotRadius: 4,
          pointDotStrokeWidth: 1,
          pointHitDetectionRadius: 20,
          datasetStroke: true,
          datasetStrokeWidth: 2,
          datasetFill: false,
          legendTemplate: "<ul class=\"char-legend\"><% for (var i = 0; i < datasets.length; i++){%><li <%if(datasets[i].label){%>title=\"<%=datasets[i].label%>\"<%}%>><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><strong><%if(datasets[i].label){%><%=datasets[i].label%><%}%></strong></li><%}%></ul>"
        };
        var id = config["container-id"];
        var ctx = document.getElementById(id).getContext("2d");
        var myBarChart = new Chart(ctx).Line(data, options);

        if (config['show_legend']) {
          var legend = myBarChart.generateLegend();
          $('#' + id).parent().append(legend);
        }
      }
    }]);

    return LineChart;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Charts = global.NS.Charts || {};
  global.NS.Charts.LineChart = LineChart || {};
})(window);
/**
 * Kontrolka odpowiedzialna za rysowanie wykresów słupkowych.
 * Dane w konfiguracji:
 *  container-id - id kontenera
 *  data - dane dla wykresu
 *  name-mapping - mapowanie danych w wykresie
 *  colors - kolory dla konkretnych partii danych
 * Funkcje:
 *  init() 
 *  prepareData() - przygotowanie danych w formie określonej przez plugin chart.js
 *  drawChart() - rysowanie wykresu za pomocą pluginu chart.js
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var LineChartScroll = /*#__PURE__*/function () {
    function LineChartScroll(config) {
      _classCallCheck(this, LineChartScroll);

      this.settings = {
        colors: {
          "1": "#ff6600",
          "2": "#4bb4e6",
          "3": "#fadc00",
          "4": "#50be87",
          "5": "#9164cd",
          "6": "#ffb4e6",
          "7": "#d54733"
        }
      };
      this.options = null;
      this.myBarChart = null;
      this.init(config);
    }

    _createClass(LineChartScroll, [{
      key: "init",
      value: function init(config) {
        var settings = this.settings;
        var data;

        if (config["multidata"] === true) {
          data = this.prepareData(config, settings);
        } else {
          data = this.prepareSingleData(config, settings);
        }

        this.drawChart(config, data);
      }
    }, {
      key: "objectSize",
      value: function objectSize(object) {
        var keys = Object.keys(object);
        return keys.length;
      }
    }, {
      key: "colorLuminance",
      value: function colorLuminance(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, "");

        if (hex.length < 6) {
          hex = hex.replace(/(.)/g, '$1$1');
        }

        lum = lum || 0;
        var rgb = "#",
            c;

        for (var i = 0; i < 3; ++i) {
          c = parseInt(hex.substr(i * 2, 2), 16);
          c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
          rgb += ("00" + c).substr(c.length);
        }

        return rgb;
      }
    }, {
      key: "prepareData",
      value: function prepareData(config, settings) {
        var data = config["data"];
        var xAxis = [];
        var dataSet = {};
        var me = this;
        var colorsCounter = 1;
        var color;
        var colorHighlight;
        var colorRepeat = 0;
        $.each(data, function (index, val) {
          xAxis.push(val.name);
          $.each(val.values, function (index, val) {
            if (typeof dataSet[index] == 'undefined') {
              dataSet[index] = [];
            }

            dataSet[index].push(val);
          });
        });
        var tmpDataSet = [];
        $.each(dataSet, function (index, val) {
          if (typeof config["colors"] != 'undefined') {
            var tmp = config["colors"][index];
            color = "rgba(" + tmp + ",0.9)";
            colorHighlight = "rgba(" + tmp + ",1)";
          } else {
            var _tmp = settings["colors"][colorsCounter];

            if (colorsCounter >= me.objectSize(settings["colors"])) {
              colorsCounter = 1;
              colorRepeat++;
            }

            var lum = colorRepeat / 10;
            color = me.colorLuminance(_tmp, -lum); // color = "rgba(" + tmp + ",0.9)";

            colorHighlight = me.colorLuminance(_tmp, -lum - 0.05);
            colorsCounter++;
          }

          var name = index;

          if (typeof config["name_mapping"] != 'undefined') {
            $.each(config["name_mapping"], function (index, val) {
              if (name === index) {
                name = val;
              }
            });
          }

          tmpDataSet.push({
            label: name,
            fillColor: color,
            strokeColor: color,
            pointColor: color,
            pointStrokeColor: color,
            pointHighlightFill: colorHighlight,
            pointHighlightStroke: colorHighlight,
            data: val
          });
        });
        return {
          labels: xAxis,
          datasets: tmpDataSet
        };
      }
    }, {
      key: "prepareSingleData",
      value: function prepareSingleData(config, settings) {
        var data = config["data"];
        var columnsData = [];
        var xAxis = [];
        var me = this;
        var color = me.colorLuminance(settings["colors"][1], 0.1);
        var colorHighlight = settings["colors"][1];
        var name = data["name"];
        $.each(data["values"], function (index, val) {
          xAxis.push(index);
          columnsData.push(val);
        });
        return {
          labels: xAxis,
          datasets: [{
            label: name,
            fillColor: color,
            strokeColor: color,
            pointColor: color,
            pointStrokeColor: color,
            pointHighlightFill: colorHighlight,
            pointHighlightStroke: colorHighlight,
            data: columnsData
          }]
        };
      }
    }, {
      key: "fixCanvasWidth",
      value: function fixCanvasWidth(id, config, data) {
        var $canvas = $('#' + id);
        var width = $canvas.parent().width();
        var targetWidth = data['labels'].length * 35 + 40;

        if (width < targetWidth) {
          $canvas.attr('width', targetWidth);
        } else {
          $canvas.attr('width', $canvas.parent().width());
        }

        $canvas.data('width', $canvas.width());
        $canvas.data('height', $canvas.height());
      }
    }, {
      key: "fixResize",
      value: function fixResize(id, config, data) {
        var _this = this;

        var $canvas = $('#' + id);
        var targetWidth = data['labels'].length * 35 + 40;
        var ctx = document.getElementById(id).getContext("2d");
        $(window).resize(function () {
          if (typeof _this.myBarChart !== 'undefined' && _this.myBarChart !== null) {
            if ($canvas.parent().width() < targetWidth) {
              $canvas.width(targetWidth);
            } else {
              $canvas.width($canvas.parent().width());
            }

            _this.myBarChart.destroy();

            _this.myBarChart = new Chart(ctx).Line(data, _this.options);
            $canvas.height($canvas.data('height'));
          }
        });
      }
    }, {
      key: "drawChart",
      value: function drawChart(config, data) {
        var options = {
          scaleBeginAtZero: true,
          scaleShowGridLines: true,
          scaleGridLineColor: "rgba(0,0,0,0.05)",
          scaleGridLineWidth: 1,
          scaleShowHorizontalLines: true,
          scaleShowVerticalLines: true,
          bezierCurve: true,
          bezierCurveTension: 0.3,
          pointDot: true,
          pointDotRadius: 4,
          pointDotStrokeWidth: 1,
          pointHitDetectionRadius: 5,
          datasetStroke: true,
          datasetStrokeWidth: 2,
          tooltipCaretSize: 8,
          datasetFill: false,
          legendTemplate: "<ul class=\"char-legend\"><% for (var i = 0; i < datasets.length; i++){%><li <%if(datasets[i].label){%>title=\"<%=datasets[i].label%>\"<%}%>><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><strong><%if(datasets[i].label){%><%=datasets[i].label%><%}%></strong></li><%}%></ul>",
          onAnimationComplete: function onAnimationComplete() {
            var id = config["container-id"];
            var sourceCanvas = this.chart.ctx.canvas;
            var copyWidth = this.scale.xScalePaddingLeft - 5; // the +5 is so that the bottommost y axis label is not clipped off
            // we could factor this in using measureText if we wanted to be generic

            var copyHeight = this.scale.endPoint + 5;
            var targetCtx = document.getElementById(id + 'Axis').getContext("2d");
            targetCtx.canvas.width = copyWidth;
            targetCtx.fillStyle = 'rgba(255,255,255,0.8)';
            targetCtx.fillRect(0, 0, copyWidth, copyHeight);
            targetCtx.drawImage(sourceCanvas, 0, 0, copyWidth, copyHeight, 0, 0, copyWidth, copyHeight);
            this.chart.ctx.clearRect(0, 0, copyWidth, copyHeight); //usuwam domyślne dane
          }
        };

        if (typeof config['scaleLabel'] !== 'undefined' && config['scaleLabel'] !== null) {
          options['scaleShowLabels'] = true;
          options['scaleLabel'] = "<%=value%>" + config['scaleLabel'];
        }

        var yValueDecimals = config['y_value_decimals'];

        if (typeof yValueDecimals !== 'undefined' && yValueDecimals !== null) {
          options['tooltipTemplate'] = "<%if (label){%><%=label%>: <%}%><%= value.toFixed(" + yValueDecimals + ") %>";
        }

        this.options = options;
        var id = config["container-id"];
        var $containerSelector = $('#' + id);
        this.fixCanvasWidth(id, config, data, this.myBarChart);
        $containerSelector.wrap('<div class="chartAreaWrapper"></div>');
        $containerSelector.parent().wrap('<div class="chartWrapper"></div>');
        var height = $containerSelector.height();
        $containerSelector.parent().after('<canvas id="' + id + 'Axis" width="0" height="' + height + '"></canvas>');
        var ctx = document.getElementById(id).getContext("2d");
        this.myBarChart = new Chart(ctx).Line(data, options);

        if (config['show_legend']) {
          var legend = this.myBarChart.generateLegend();
          $containerSelector.parent().append(legend);
        }

        this.fixResize(id, config, data, this.myBarChart);
        $containerSelector.parent().niceScroll({
          cursorcolor: '#FF6600',
          cursorborder: '0',
          cursorborderradius: '0',
          horizrailenabled: true,
          cursorwidth: 5,
          background: '#fafafa',
          autohidemode: false
        });
      }
    }]);

    return LineChartScroll;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Charts = global.NS.Charts || {};
  global.NS.Charts.LineChartScroll = LineChartScroll || {};
})(window);
/**
 * Kontrolka odpowiedzialna za rysowanie wykresów kołowych.
 * Dane w konfiguracji:
 *  container-id - id kontenera
 *  data - dane dla wykresu
 *  name-mapping - mapowanie danych w wykresie
 *  colors - kolory dla konkretnych partii danych
 * Funkcje:
 * 	init() 
 * 	prepareData() - przygotowanie danych w formie określonej przez plugin chart.js
 * 	drawChart() - rysowanie wykresu za pomocą pluginu chart.js
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var PieChart = /*#__PURE__*/function () {
    function PieChart(config) {
      _classCallCheck(this, PieChart);

      this.settings = {
        colors: {
          "1": "#ff6600",
          "2": "#4bb4e6",
          "3": "#fadc00",
          "4": "#50be87",
          "5": "#9164cd",
          "6": "#ffb4e6",
          "7": "#d54733"
        }
      };
      this.init(config);
    }

    _createClass(PieChart, [{
      key: "init",
      value: function init(config) {
        var settings = this.settings;
        var data = this.prepareData(config, settings);

        if (typeof config["show_legend"] === 'undefined') {
          config["show_legend"] = true;
        }

        this.drawChart(config, data);
      }
    }, {
      key: "objectSize",
      value: function objectSize(object) {
        var keys = Object.keys(object);
        return keys.length;
      }
    }, {
      key: "colorLuminance",
      value: function colorLuminance(hex, lum) {
        // Validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, "");

        if (hex.length < 6) {
          hex = hex.replace(/(.)/g, '$1$1');
        }

        lum = lum || 0; // Convert to decimal and change luminosity

        var rgb = "#",
            c;

        for (var i = 0; i < 3; ++i) {
          c = parseInt(hex.substr(i * 2, 2), 16);
          c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
          rgb += ("00" + c).substr(c.length);
        }

        return rgb;
      }
    }, {
      key: "prepareData",
      value: function prepareData(config, settings) {
        var data = [];
        var me = this;
        var colorsCounter = 1;
        var color;
        var colorHighlight;
        var colorRepeat = 0;

        if (Object.keys(config["data"]["values"]).length === 0) {
          return false;
        }

        $.each(config["data"]["values"], function (index, val) {
          var name = index;

          if (typeof config["colors"] != 'undefined') {
            var tmp = config["colors"][index];
            color = "rgba(" + tmp + ",0.9)";
            colorHighlight = "rgba(" + tmp + ",1)";
          } else {
            var _tmp = settings["colors"][colorsCounter];

            if (colorsCounter >= me.objectSize(settings["colors"])) {
              colorsCounter = 0;
              colorRepeat++;
            }

            var lum = colorRepeat / 10 * 2;
            color = me.colorLuminance(_tmp, lum);
            colorHighlight = me.colorLuminance(_tmp, lum - 0.05);
            colorsCounter++;
          }

          if (typeof config["name_mapping"] !== 'undefined') {
            $.each(config["name_mapping"], function (index, val) {
              if (name === index) {
                name = val;
              }
            });
          }

          data.push({
            value: val,
            color: color,
            highlight: colorHighlight,
            label: name
          });
        });
        return data;
      }
    }, {
      key: "drawChart",
      value: function drawChart(config, data) {
        var valuesTotal = 0;

        if (data) {
          data.forEach(function (val) {
            valuesTotal += val.value;
          });
        }

        if (valuesTotal > 0) {
          var options = {
            legendTemplate: "<ul class=\"char-legend\"><% for (var i = 0; i < segments.length; i++){%><li <%if(segments[i].label){%>title=\"<%=segments[i].label%>\"<%}%>><span style=\"background-color:<%=segments[i].fillColor%>\"></span><strong><%if(segments[i].label){%><%=segments[i].label%><%}%></strong></li><%}%></ul>"
          };
          var id = config["container-id"];
          var ctx = document.getElementById(id).getContext("2d"); // noinspection JSUnresolvedFunction

          var myPieChart = new Chart(ctx).Pie(data, options);

          if (config['show_legend']) {
            var legend = myPieChart.generateLegend();
            $('#' + id).parent().append(legend);
          }
        } else {
          var tmp = '<div class="vh-center">Brak danych dla wykresu</div>';
          $('#' + config["container-id"]).parent().append(tmp);
        }
      }
    }]);

    return PieChart;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Charts = global.NS.Charts || {};
  global.NS.Charts.PieChart = PieChart || {};
})(window);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// noinspection JSUnresolvedVariable (scheduler i toastr - czy one są jakoś definiowane, czy to błędny kod?)
var ApiScheduler = /*#__PURE__*/function () {
  function ApiScheduler() {
    _classCallCheck(this, ApiScheduler);
  }

  _createClass(ApiScheduler, null, [{
    key: "init",
    value: function init(schedulerId, config) {
      settings = ApiScheduler.settingsBuilder(schedulerId, config);

      if (settings.methodSaveForm === 'POST') {
        ApiScheduler.buildHiddenForm();
      }

      ApiScheduler.buildCalendar();
      ApiScheduler.initScheduler();
      ApiScheduler.bindSaveButton();
      ApiScheduler.lockExit();
    }
    /**
     * Funkcja sprawdza czy przycisk jest ustawiony jeżeli nie to nadaje mu wartość true
     * @param {bool} button wartość bool dla przycisku z konfiguracji
     * @returns {*}
     */

  }, {
    key: "isConfigButtonSet",
    value: function isConfigButtonSet(button) {
      var value;

      if (typeof button === 'undefined') {
        value = true;
      } else {
        value = button;
      }

      return value;
    }
    /**
     * Budowanie ustawień na podstawie przekazanej konfiguracji
     * @param  {string} schedulerId ID obiektu kalendarza
     * @param  {json} config        Konfiguracja kalendarza
     * @return {json}               konfiguracja funkcji
     */

  }, {
    key: "settingsBuilder",
    value: function settingsBuilder(schedulerId, config) {
      var yearView, monthView, weekView, dayView, today;

      if (_typeof(config) !== 'object') {
        throw new Error('Konfiguracja powinna być obiektem JSON');
      }

      if (!config.hasOwnProperty('dataUrl') || typeof config.dataUrl === 'undefined') {
        throw new Error('W obiekcie konfiguracji nie zdefiniowano pola `dataUrl`');
      }

      if (config.hasOwnProperty('navLine') && typeof config.navLine !== 'undefined') {
        // noinspection JSUnresolvedVariable
        today = ApiScheduler.isConfigButtonSet(config.navLine.todayButton); // noinspection JSUnresolvedVariable

        dayView = ApiScheduler.isConfigButtonSet(config.navLine.dayViewButton); // noinspection JSUnresolvedVariable

        weekView = ApiScheduler.isConfigButtonSet(config.navLine.weekViewButton); // noinspection JSUnresolvedVariable

        monthView = ApiScheduler.isConfigButtonSet(config.navLine.monthViewButton); // noinspection JSUnresolvedVariable

        yearView = ApiScheduler.isConfigButtonSet(config.navLine.yearViewButton);
      } else {
        today = dayView = weekView = monthView = yearView = true;
      }

      var lockExit;

      if (config.hasOwnProperty('lockExit') && typeof config.lockExit !== 'undefined') {
        lockExit = config.lockExit;
      } else {
        lockExit = false;
      }

      var formAction = $('#' + schedulerId).attr('formAction');
      var todayButton = today ? '<div class="dhx_cal_today_button"></div>' : '';
      var dayButton = dayView ? "<div class=\"dhx_cal_tab\" name=\"day_tab\"></div>" : '';
      var weekButton = weekView ? "<div class=\"dhx_cal_tab\" name=\"week_tab\"></div>" : '';
      var monthButton = monthView ? "<div class=\"dhx_cal_tab\" name=\"month_tab\"></div>" : '';
      var yearButton = yearView ? "<div class=\"dhx_cal_tab\" name=\"year_tab\"></div>" : '';
      return {
        "buttonsCode": {
          "today": todayButton,
          "dayView": dayButton,
          "weekView": weekButton,
          "monthView": monthButton,
          "yearView": yearButton
        },
        "classes": {
          "saveButton": ".btn-save"
        },
        'texts': {
          "lockExit": "Nie zapisałeś zmian."
        },
        "hiddenForm": {
          "formID": "hiddenFormToSave",
          "formAction": formAction,
          "iframeID": "hidden_frame",
          "urlID": "hiddenUrlInputToSave",
          "dataID": "hiddenDataInputToSave"
        },
        "lockExit": lockExit,
        "dataUrl": config.dataUrl,
        "schedulerId": schedulerId,
        "methodSaveForm": "Ajax" //POST

      };
    }
    /**
     * Tworzenie struktury kalendarza na podstawie danych podanych w konfiguracji w blocku navLine
     */

  }, {
    key: "buildCalendar",
    value: function buildCalendar() {
      var classNav = '';

      if (settings.buttonsCode.save) {
        classNav = settings.classes.saveButton;
      }

      var navLine = '<div class="dhx_cal_navline ' + classNav + '">' + '<div class="dhx_cal_prev_button">&nbsp;</div>' + '<div class="dhx_cal_next_button">&nbsp;</div>' + settings.buttonsCode.today + '<div class="dhx_cal_date"></div>' + settings.buttonsCode.dayView + settings.buttonsCode.weekView + settings.buttonsCode.monthView + settings.buttonsCode.yearView + '</div>';
      var header = '<div class="dhx_cal_header"></div>';
      var calendar = '<div class="dhx_cal_data"></div>';
      $('#' + settings.schedulerId).prepend(navLine).prepend(header).prepend(calendar);
    }
    /**
     * Budowanie ukrytego formularza i iframe w celu zapisywania kalendarza przez wysyłanie go formularzem.
     * Stworzenie tych elementów pozwala wysłać formularz bez przeładowania strony.
     */

  }, {
    key: "buildHiddenForm",
    value: function buildHiddenForm() {
      //Tworzenie formularza
      var form = document.createElement('form');
      form.method = 'post';
      form.action = settings.hiddenForm.formAction;
      form.target = settings.hiddenForm.iframeID;
      form.id = settings.hiddenForm.formID;
      var iframe = document.createElement('iframe');
      iframe.src = 'auto:blank';
      iframe.width = 0;
      iframe.height = 0;
      iframe.id = settings.hiddenForm.iframeID;
      iframe.name = settings.hiddenForm.iframeID;
      var data = document.createElement("input"); //input element, text

      data.type = 'hidden';
      data.name = 'data';
      data.id = settings.hiddenForm.dataID;
      var url = document.createElement("input"); //input element, text

      url.type = 'hidden';
      url.name = 'url';
      url.id = settings.hiddenForm.urlID;
      form.appendChild(data);
      form.appendChild(url);
      document.body.appendChild(form);
      document.body.appendChild(iframe);
    }
    /**
     * Inicjalizacja kalendarza DHTMLXa wraz z załadowaniem danych z linka podanego w konfiguracji
     */

  }, {
    key: "initScheduler",
    value: function initScheduler() {
      var $scheduler = $('#' + settings.schedulerId);

      if ($scheduler.length) {
        $scheduler.addClass('dhx_cal_container');

        if (typeof scheduler !== 'undefined') {
          scheduler.init(settings.schedulerId, new Date(), "month");
          scheduler.load(settings.dataUrl, 'json');
        }
      }
    }
    /**
     * Podłączenie funkcji zapisywania JSON-a do pliku, którego ścieżka jest podana w konfiguracji.
     * Dane są zapisywane za pomocą pliku PHP, do którego adres jest podawany w form.action
     */

  }, {
    key: "bindSaveButton",
    value: function bindSaveButton() {
      $(settings.classes.saveButton).on('click', function (e) {
        e.preventDefault();

        if (settings.methodSaveForm === 'POST') {
          if (typeof scheduler !== 'undefined') {
            $('#' + settings.hiddenForm.dataID).val(scheduler.toJSON());
          }

          $('#' + settings.hiddenForm.urlID).val(settings.dataUrl);
          $('#' + settings.hiddenForm.formID).submit();
        } else if (settings.methodSaveForm === 'Ajax') {
          if (typeof scheduler !== 'undefined') {
            $.ajax({
              url: settings.hiddenForm.formAction,
              dataType: 'json',
              method: "POST",
              data: {
                "data": scheduler.toJSON(),
                "url": settings.dataUrl
              }
            }).always(function (data) {
              if (typeof toastr !== 'undefined') {
                toastr.info(data.responseText);
              }
            });
          }
        }
      });
    }
    /**
     * Funkcja sprawdzająca czy są różnice pomiędzy kalendarzem, a wartościami podanymi w pliku.
     * Porównywane są dwa JSONy.
     */

  }, {
    key: "lockExit",
    value: function lockExit() {
      if (settings.lockExit) {
        var exitText = settings.texts.lockExit;
        $(window).on('beforeunload ', function () {
          var file = $.ajax({
            url: settings.dataUrl,
            async: false
          });
          file = JSON.stringify(file.responseText);
          file = file.replace(/(?:\\[r])+/g, "");
          var actual = JSON.stringify(scheduler.toJSON());

          if (file !== actual) {
            return exitText;
          }
        });
      }
    }
  }]);

  return ApiScheduler;
}();
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//Options Resolver
(function (global) {
  var OptionsResolver = /*#__PURE__*/function () {
    function OptionsResolver(inputConfig) {
      _classCallCheck(this, OptionsResolver);

      this.config = typeof inputConfig === "undefined" ? {} : inputConfig;
    }

    _createClass(OptionsResolver, [{
      key: "getOption",
      value: function getOption(key, defaultValue) {
        var value = defaultValue ? defaultValue : null;

        if (typeof this.config[key] != "undefined") {
          value = this.config[key];
        }

        return value;
      }
    }]);

    return OptionsResolver;
  }();

  global.NS = global.NS || {};
  global.NS.Utils = global.NS.Utils || {};
  global.NS.Utils.OptionsResolver = OptionsResolver;
})(window);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function (global) {
  var storage = global.localStorage || global.sessionStorage;

  var OverlayElement = /*#__PURE__*/function (_HTMLDivElement) {
    _inherits(OverlayElement, _HTMLDivElement);

    var _super = _createSuper(OverlayElement);

    function OverlayElement() {
      var _this;

      _classCallCheck(this, OverlayElement);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "_closeable", true);

      return _this;
    }

    _createClass(OverlayElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;

        this.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
        this.style.width = this.style.height = '100%';
        this.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (_this2._closeable) {
            // noinspection JSUnresolvedFunction
            _this2.parentElement.hide();
          }
        });
      }
    }, {
      key: "closeable",
      set: function set(value) {
        this._closeable = value;
      },
      get: function get() {
        return this._closeable;
      }
    }]);

    return OverlayElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var ContainerElement = /*#__PURE__*/function (_HTMLDivElement2) {
    _inherits(ContainerElement, _HTMLDivElement2);

    var _super2 = _createSuper(ContainerElement);

    function ContainerElement() {
      var _this3;

      _classCallCheck(this, ContainerElement);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this3 = _super2.call.apply(_super2, [this].concat(args));
      _this3.headerElement = document.createElement('h2');
      _this3.contentElement = document.createElement('div');
      _this3.skippableElement = document.createElement('div');
      _this3.buttonsContainerElement = document.createElement('div');
      Object.defineProperty(_this3.skippableElement, 'checked', {
        get: function get() {
          return !!(_this3.skippableElement.querySelector('input[type="checkbox"]') || {}).checked;
        }
      });
      return _this3;
    }

    _createClass(ContainerElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.style.position = 'absolute';
        this.style.left = this.style.top = '50%'; // noinspection JSDeprecatedSymbols

        this.style.transform = this.style.webkitTransform = this.style.msTransform = 'translate(-50%, -50%)';
        this.style.minWidth = '300px';
        this.style.minHeight = '140px';
        this.style.backgroundColor = 'white';
        this.style.boxShadow = '0 0 5px rgba(0,0,0,0.3),0 0 20px rgba(0,0,0,0.3)';
        this.style.padding = '10px 40px';
        this.style.maxHeight = '70vh';
        this.style.maxWidth = '70vw';
        this.style.overflow = 'auto';
        this.headerElement.style.textAlign = 'center';
        this.headerElement.style.fontWeight = 'bold';
        this.headerElement.style.textShadow = '2px 2px 3px rgba(0, 0, 0, 0.2)';
        this.headerElement.style.fontSize = '32px';
        this.headerElement.style.marginBottom = '25px';
        this.buttonsContainerElement.style.display = 'flex';
        this.buttonsContainerElement.style.justifyContent = 'center';
        this.skippableElement.classList.add('checkbox');
        this.skippableElement.style.textAlign = 'center';
        var label = this.skippableElement.appendChild(document.createElement('label'));
        var checkbox = label.appendChild(document.createElement('input'));
        checkbox.setAttribute('type', 'checkbox');
        var i = label.appendChild(document.createElement('i'));
        i.classList.add('input-helper');
        label.appendChild(document.createTextNode('Nie wyświetlaj więcej tego okna.'));
        this.appendChild(this.headerElement);
        this.appendChild(this.contentElement);
        this.appendChild(this.skippableElement);
        this.appendChild(this.buttonsContainerElement);
        this.contentElement.style.minHeight = '40px';

        if (!this.skippable) {
          this.skippableElement.style.display = 'none';
        }
      }
    }, {
      key: "addButton",
      value: function addButton(text, action) {
        var _this4 = this;

        var button = document.createElement('button');
        button.classList.add('btn', 'btn-primary');
        button.style.marginLeft = button.style.marginRight = '5px';
        button.innerText = text;

        if (action) {
          button.addEventListener('click', function (e) {
            if (_this4.skippable && button === _this4.defaultButton) {
              if (_this4.skippableElement.checked) {
                storage.setItem(_this4.skippable, 'yes');
              }
            }

            action(e);
          });
        }

        this.buttonsContainerElement.appendChild(button);
        return button;
      }
    }, {
      key: "addDefaultButton",
      value: function addDefaultButton(text, action) {
        return this.defaultButton = this.addButton(text, action);
      }
    }, {
      key: "content",
      set: function set(value) {
        while (this.contentElement.firstChild) {
          this.contentElement.removeChild(this.contentElement.firstChild);
        }

        if (typeof value === 'string') {
          this.contentElement.innerText = value;
          this.contentElement.style.setProperty('text-align', 'center');
        } else if (_typeof(value) === 'object' && value instanceof HTMLElement) {
          this.contentElement.appendChild(value);
          this.contentElement.style.removeProperty('text-align');
        } else {
          console.error('Treść popupa może być jedynie stringiem lub obiektem typu HTMLElement.');
        }
      }
    }, {
      key: "skippableName",
      set: function set(name) {
        this.skippable = name;
        this.skippableElement.style.display = name ? 'block' : 'none';
      }
    }, {
      key: "header",
      set: function set(value) {
        this.headerElement.innerText = value;

        if (value && value.length) {
          this.headerElement.style.minHeight = '60px';
          this.headerElement.style.paddingBottom = '25px';
          this.style.minHeight = '200px';
        } else {
          this.headerElement.style.minHeight = this.headerElement.style.paddingBottom = '0';
          this.style.minHeight = '140px';
        }
      }
    }]);

    return ContainerElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var PopupElement = /*#__PURE__*/function (_HTMLDivElement3) {
    _inherits(PopupElement, _HTMLDivElement3);

    var _super3 = _createSuper(PopupElement);

    function PopupElement() {
      var _this5;

      _classCallCheck(this, PopupElement);

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      _this5 = _super3.call.apply(_super3, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this5), "transition", 400);

      _defineProperty(_assertThisInitialized(_this5), "hidden", true);

      _this5.overlay = new OverlayElement();
      _this5.container = new ContainerElement();

      _this5.escCallback = function (e) {
        // noinspection JSDeprecatedSymbols
        if ("key" in e && (e.key === 'Escape' || e.key === 'Esc') || e.keyCode === 27 || e.which === 27) {
          e.preventDefault();
          e.stopPropagation();

          if (_this5.cancelButton) {
            _this5.cancelButton.click();
          } else if (_this5.overlay.closeable) {
            _this5.hide();
          }
        }
      };

      return _this5;
    }

    _createClass(PopupElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this6 = this;

        this.style.width = '100vw';
        this.style.height = '100vh';
        this.style.position = 'fixed';
        this.style.left = this.style.top = '0px';
        this.style.zIndex = '9999';
        this.style.opacity = '0';
        this.style.transition = "".concat(this.transition, "ms");
        setTimeout(function () {
          return _this6.style.opacity = '1';
        });
        this.appendChild(this.overlay);
        this.appendChild(this.container);
        document.addEventListener('keydown', this.escCallback);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        document.removeEventListener('keydown', this.escCallback);
      }
    }, {
      key: "addButton",
      value: function addButton(text) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
        return this.container.addButton(text, action);
      }
    }, {
      key: "addDefaultButton",
      value: function addDefaultButton(text) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        if (this.defaultButton && console.warn) {
          console.warn('Default button already set.');
        }

        return this.defaultButton = this.container.addDefaultButton(text, action);
      }
    }, {
      key: "addCancelButton",
      value: function addCancelButton(text) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        if (this.cancelButton && console.warn) {
          console.warn('Cancel button already set.');
        }

        return this.cancelButton = this.addButton(text, action);
      }
    }, {
      key: "show",
      value: function show() {
        if (this.parentElement || !this.hidden) {
          return false;
        }

        if (this.skippable) {
          if (!this.defaultButton && console.warn) {
            console.warn('Skippable popup must have the default button set.');
          }

          if (storage.getItem(this.name) === 'yes') {
            if (this.defaultButton) {
              this.defaultButton.click();
            }

            return true;
          }
        }

        if (document.activeElement) {
          // noinspection JSUnresolvedFunction
          document.activeElement.blur();
        }

        document.body.appendChild(this);
        this.hidden = false;
        return true;
      }
    }, {
      key: "hide",
      value: function hide() {
        var _this7 = this;

        if (!this.parentElement || this.hidden) {
          return false;
        }

        this.style.opacity = '0';
        this.hidden = true;
        setTimeout(function () {
          return _this7.remove();
        }, this.transition);
        return true;
      }
    }, {
      key: "header",
      set: function set(value) {
        this.container.header = value;
      }
    }, {
      key: "content",
      set: function set(value) {
        this.container.content = value;
      }
    }, {
      key: "closeable",
      set: function set(value) {
        this.overlay.closeable = value;
      }
    }, {
      key: "skippable",
      set: function set(skippable) {
        if (!skippable) {
          this.container.skippableName = delete this.name;
          return;
        }

        var e = new Error();
        var stack = e.stack.split(/\r?\n/);
        var line = stack[1].substr(stack[1].lastIndexOf(':') + 1);
        this.container.skippableName = this.name = "Popup_".concat(line);
      },
      get: function get() {
        return !!this.name;
      }
    }]);

    return PopupElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  customElements.define('ce-popup', PopupElement, {
    "extends": 'div'
  });
  customElements.define('ce-popup-overlay', OverlayElement, {
    "extends": 'div'
  });
  customElements.define('ce-popup-container', ContainerElement, {
    "extends": 'div'
  });
  global.HTMLElements = global.HTMLElements || {};
  global.HTMLElements.PopupElement = PopupElement;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ApiConnect = /*#__PURE__*/function () {
  function ApiConnect() {
    _classCallCheck(this, ApiConnect);
  }

  _createClass(ApiConnect, null, [{
    key: "get",
    value: function get(url, params) {
      try {
        if (params && Object.keys(params).length > 0) {
          url += '?' + new URLSearchParams(params);
        }

        return fetch(url).then(function (response) {
          if (response.redirected) {
            window.location = response.url;
            return Promise.reject('redirect');
          }

          return response.json();
        });
      } catch (e) {
        console.error('Error: ', e);
        return Promise.reject(e);
      }
    }
  }, {
    key: "post",
    value: function post(url, params) {
      try {
        return fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: params ? JSON.stringify(params) : undefined
        }).then(function (response) {
          if (response.redirected) {
            window.location = response.url;
            return Promise.reject('redirect');
          }

          return response.json();
        });
      } catch (e) {
        console.error('Error: ', e);
        return Promise.reject(e);
      }
    }
  }, {
    key: "request",
    value: function request(url, method, params) {
      try {
        return fetch(url, {
          method: method,
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: params ? JSON.stringify(params) : undefined
        }).then(function (response) {
          if (response.redirected) {
            window.location = response.url;
            return Promise.reject('redirect');
          }

          return response.json();
        });
      } catch (e) {
        console.error('Error: ', e);
        return Promise.reject(e);
      }
    }
  }, {
    key: "put",
    value: function put(url, params) {
      try {
        return fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: params ? JSON.stringify(params) : undefined
        }).then(function (response) {
          if (response.redirected) {
            window.location = response.url;
            return Promise.reject('redirect');
          }

          return response.json();
        });
      } catch (e) {
        console.error('Error: ', e);
        return Promise.reject(e);
      }
    }
  }, {
    key: "delete",
    value: function _delete(url, params) {
      try {
        return fetch(url, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: params ? JSON.stringify(params) : undefined
        }).then(function (response) {
          if (response.redirected) {
            window.location = response.url;
            return Promise.reject('redirect');
          }

          return response.json();
        });
      } catch (e) {
        console.error('Error: ', e);
        return Promise.reject(e);
      }
    }
  }]);

  return ApiConnect;
}();
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  /**
   * Builder w konfiguracji przyjmuje:
   *
   * - "dhtmlx-form-config" - Konfiguracja formularza (według pola typu "settings": http://docs.dhtmlx.com/form__controls_list.html#settings)
   * - "form-config" - konfiguracja przekazywana do nowo utworzonego obiektu NS.Form.Control
   * - @TBD (do dorobienia opcje, np. "form-name")
   *
   * @param config
   * @constructor
   */
  var Builder = /*#__PURE__*/function () {
    function Builder(config) {
      _classCallCheck(this, Builder);

      this.init(config);
    }

    _createClass(Builder, [{
      key: "init",
      value: function init(config) {
        this.options = new NS.Utils.OptionsResolver(config);
        this.settings = this.options.getOption("dhtmlx-form-settings", {
          "position": "label-left",
          "labelAlign": "left"
        });
        this.formConfig = this.options.getOption("form-config", {});
        this.blockPrefix = this.options.getOption("block-prefix");
        this.fields = {};
        this.bottomButtons = {};
      }
    }, {
      key: "createFullFieldName",
      value: function createFullFieldName(name) {
        var fullFieldName = name;

        if (this.blockPrefix) {
          fullFieldName = this.blockPrefix + "[" + name + "]";
        }

        return fullFieldName;
      }
      /**
       * Dodanie nowego pola do formularza.
       *
       * Typy i konfiguracja, patrz: http://docs.dhtmlx.com/form__controls_list.html
       *
       * @param name
       * @param type
       * @param configuration
       * @return Builder this
       */

    }, {
      key: "addField",
      value: function addField(name, type, configuration) {
        if (this.fields[name] !== undefined) {
          console.warn("Field: " + name + " is defined twice (or more?). Be afraid.");
        }

        var fullFieldName = this.createFullFieldName(name);
        this.fields[fullFieldName] = {
          "type": type,
          "configuration": configuration
        };
        return this;
      }
    }, {
      key: "addBottomButton",
      value: function addBottomButton(label, id, configuration) {
        if (typeof this.bottomButtons[id] != "undefined") {
          console.warn("Button with id: " + id + " is defined twice (or more?). Be afraid.");
        }

        var buttonDefinition = configuration ? configuration : {};
        buttonDefinition["label"] = label;
        this.bottomButtons[id] = buttonDefinition;
        return this;
      }
    }, {
      key: "createConfiguration",
      value: function createConfiguration() {
        return new NS.Form.Configuration({
          "fields": this.fields,
          "bottomButtons": this.bottomButtons,
          "settings": this.settings
        });
      }
    }, {
      key: "createForm",
      value: function createForm(dhtmlxComponent) {
        var configuration = this.createConfiguration();
        var form = null;

        if (typeof dhtmlxComponent.attachForm === "function") {
          form = dhtmlxComponent.attachForm(configuration.getDhtmlxFormConfiguration());
        } else if (typeof dhtmlxComponent.dhtmlxObject === "function") {
          form = dhtmlxComponent.dhtmlxObject().attachForm(configuration.getDhtmlxFormConfiguration());
        } else {
          throw new Error("Builder cannot create form inside given object.");
        }

        var formObjectConfiguration = this.formConfig;
        formObjectConfiguration["handlers"] = configuration.getHandlers();
        formObjectConfiguration["block-prefix"] = this.blockPrefix;
        return new NS.Form.Control(form, formObjectConfiguration);
      }
    }]);

    return Builder;
  }();

  global.NS = global.NS || {};
  global.NS.Form = global.NS.Form || {};
  global.NS.Form.Builder = Builder;
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  /**
   * Klasa odpowiedzialna za utworzenie konfiguracji formularza na podstawie konfiguracji buildera.
   *
   * @param config
   * @constructor
   */
  var Configuration = /*#__PURE__*/function () {
    function Configuration(config) {
      _classCallCheck(this, Configuration);

      this.init(config);
    }

    _createClass(Configuration, [{
      key: "init",
      value: function init(config) {
        this.options = new NS.Utils.OptionsResolver(config);
        this.settings = this.options.getOption("settings", {});
        this.fields = this.options.getOption("fields", {});
        this.bottomButtons = this.options.getOption("bottomButtons", {});
        this.formConfiguration = null;
        this.listeners = null;
        this.createConfiguration();
      }
    }, {
      key: "createConfiguration",
      value: function createConfiguration() {
        var settings = this.settings;
        settings["type"] = "settings";
        var formConfiguration = [settings];

        for (var name in this.fields) {
          if (!this.fields.hasOwnProperty(name)) {
            continue;
          }

          var fieldDefinition = this.fields[name];
          var fieldConfig = fieldDefinition["configuration"];
          fieldConfig["name"] = name;
          fieldConfig["type"] = fieldDefinition["type"];
          formConfiguration.push(fieldConfig);
        }

        var bottomButtonsBlock = {
          type: "block",
          blockOffset: 0,
          list: []
        };
        var handlers = {};

        for (var id in this.bottomButtons) {
          if (!this.bottomButtons.hasOwnProperty(id)) {
            continue;
          }

          var buttonDefinition = this.bottomButtons[id];
          bottomButtonsBlock.list.push({
            "type": "button",
            "value": buttonDefinition.label,
            "name": id
          });
          bottomButtonsBlock.list.push({
            type: "newcolumn"
          });

          if (typeof buttonDefinition["handler"] != "undefined") {
            handlers[id + "-click"] = buttonDefinition["handler"];
          }
        }

        if (bottomButtonsBlock.list.length > 0) {
          formConfiguration.push(bottomButtonsBlock);
        }

        this.formConfiguration = formConfiguration;
        this.handlers = handlers;
      }
    }, {
      key: "getDhtmlxFormConfiguration",
      value: function getDhtmlxFormConfiguration() {
        return this.formConfiguration;
      }
    }, {
      key: "getHandlers",
      value: function getHandlers() {
        return this.handlers;
      }
    }]);

    return Configuration;
  }();

  global.NS = global.NS || {};
  global.NS.Form = global.NS.Form || {};
  global.NS.Form.Configuration = Configuration;
})(window);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var Control = /*#__PURE__*/function () {
    function Control(form, config) {
      _classCallCheck(this, Control);

      this.init(form, config);
    }

    _createClass(Control, [{
      key: "init",
      value: function init(form, config) {
        this.form = form;
        this.options = new NS.Utils.OptionsResolver(config);
        this.dataProcessor = null;
        this.blockPrefix = this.options.getOption("block-prefix");
        this.configure();
        this.initListeners();
      } // noinspection JSUnusedLocalSymbols

    }, {
      key: "configure",
      value: function configure() {
        var url = this.options.getOption("url");

        if (!url) {
          throw new Error("Form url is not defined.");
        } // noinspection JSPotentiallyInvalidConstructorUsage


        var formDataProcessor = new dataProcessor(url);
        formDataProcessor.init(this.form);
        formDataProcessor.setTransactionMode("REST", true);
        formDataProcessor.setUpdateMode("off");
        formDataProcessor.enableDataNames(true);
        formDataProcessor.enableDebug(true); // noinspection JSUnusedLocalSymbols

        formDataProcessor.defineAction("invalid", function (response) {
          return true;
        });

        if (this.options.getOption("add-url-trailing-slash", true)) {
          //Obsługa dodawania "trailing slash" do URL-a przy aktualizacji obiektu.
          // noinspection JSUnusedLocalSymbols
          formDataProcessor.attachEvent("onBeforeDataSending", function (id, state, data) {
            formDataProcessor.serverProcessor = url;

            if (state === "updated" || state === "deleted") {
              formDataProcessor.serverProcessor = url + "/";
            }

            return true;
          });
        }

        this.dataProcessor = formDataProcessor;
      }
    }, {
      key: "initListeners",
      value: function initListeners() {
        var me = this;
        var handlers = this.options.getOption("handlers", {});
        this.form.attachEvent("onButtonClick", function (id) {
          var handlerName = id + "-click";

          if (typeof handlers[handlerName] == "function") {
            handlers[handlerName].call(me, me);
          } else if (_typeof(handlers[handlerName]) == "object") {
            var scope = handlers[handlerName]["scope"] ? handlers[handlerName]["scope"] : me;

            if (typeof handlers[handlerName]["function"] != "function") {
              throw new Error("Handler for button: " + id + " is object, but do not have 'function' property.");
            }

            handlers[handlerName]["function"].call(scope, me);
          }
        });
        this.form.attachEvent("onAfterSave", function (id, response) {
          if (response["errors"] != null) {
            me.manageErrors(response["errors"]);
            me.form.resetDataProcessor(response["action"]);
          }

          return response["action"] !== "invalid" && response["action"] !== "error";
        });
      }
    }, {
      key: "save",
      value: function save() {
        var me = this; //Czyszczenie komunikatów walidacyjnych

        this.form.forEachItem(function (name) {
          me.markFieldError(name, true);
        });
        this.form.save();
      }
    }, {
      key: "dhtmlxObject",
      value: function dhtmlxObject() {
        return this.form;
      }
    }, {
      key: "markFieldError",
      value: function markFieldError(fullFieldName, isValid, error) {
        if (!this.form.isItem(fullFieldName)) {
          console && console.warn("Field: " + fullFieldName + " does not exists.");
          return;
        }

        var itemType = this.form.getItemType(fullFieldName);

        if (itemType === "block" || itemType === "button") {
          return;
        }

        this.form.setValidateCss(fullFieldName, isValid);

        if (isValid) {
          this.form.clearNote(fullFieldName);
        } else {
          this.form.setNote(fullFieldName, {
            "text": error
          });
        }
      }
    }, {
      key: "manageErrors",
      value: function manageErrors(errors) {
        for (var fieldName in errors) {
          if (!errors.hasOwnProperty(fieldName)) {
            continue;
          }

          var error = errors[fieldName];
          var fullFieldName = this.blockPrefix + "[" + fieldName + "]";
          this.markFieldError(fullFieldName, false, error);
        }
      }
    }]);

    return Control;
  }();

  global.NS = global.NS || {};
  global.NS.Form = global.NS.Form || {};
  global.NS.Form.Control = Control;
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var ClientListController = /*#__PURE__*/function () {
    function ClientListController(config) {
      _classCallCheck(this, ClientListController);

      this.settings = {
        table: {
          id: 'grid-container'
        }
      };
      this.init(config);
    }

    _createClass(ClientListController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Adres e-mail",
            "dataIndex": "email",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": 400
          }, {
            "label": "Firma",
            "dataIndex": "company_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isFilterable": false,
            "isSortable": false,
            "isEditable": false,
            "width": 300
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config['table_data_url'],
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': this.settings['table']['id'],
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return ClientListController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.ClientListController = ClientListController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CompanyListController = /*#__PURE__*/function () {
    function CompanyListController(config) {
      _classCallCheck(this, CompanyListController);

      this.settings = {
        table: {
          id: 'grid-container'
        }
      };
      this.init(config);
    }

    _createClass(CompanyListController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Nazwa firmy",
            "dataIndex": "firm_name",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": 200
          }, {
            "label": "Usługi",
            "dataIndex": "services",
            "dataType": "text",
            "isEditable": false,
            "isFilterable": true,
            "filterType": "text",
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isFilterable": false,
            "isSortable": false,
            "isEditable": false,
            "width": 300
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config['table_data_url'],
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        }); // noinspection JSUnusedLocalSymbols

        var grid = new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': this.settings['table']['id'],
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CompanyListController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CompanyListController = CompanyListController || {};
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function (global) {
  var InputElement = /*#__PURE__*/function (_HTMLDivElement) {
    _inherits(InputElement, _HTMLDivElement);

    var _super = _createSuper(InputElement);

    function InputElement(inputName, label) {
      var _this;

      _classCallCheck(this, InputElement);

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.inputName = inputName;
      _this.label = label;
      _this.inputId = "custom_input_element_cool_id_".concat(InputElement.lastId++);
      _this.input = document.createElement('input');
      _this.inputType = 'text';
      return _this;
    }

    _createClass(InputElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('form-group', 'fg-float', 'm-b-5');
        var inputDivElement = document.createElement('div');
        inputDivElement.classList.add('fg-line');
        inputDivElement.appendChild(this.input);
        this.input.setAttribute('name', this.inputName);
        this.input.setAttribute('id', this.inputId);
        this.input.setAttribute('type', this.inputType);
        this.input.classList.add('input-sm', 'form-control', 'fg-input');
        this.appendChild(inputDivElement);

        if (this.label !== null) {
          var label = document.createElement('label');
          label.setAttribute('for', this.inputId);
          label.classList.add('fg-label');
          label.innerText = this.label;
          this.appendChild(label);
        }
      }
    }, {
      key: "value",
      get: function get() {
        return this.input.value;
      },
      set: function set(v) {
        this.input.value = v;
      }
    }, {
      key: "type",
      set: function set(type) {
        this.inputType = type;
        this.input.type = type;
      }
    }]);

    return InputElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  _defineProperty(InputElement, "lastId", 1);

  var CheckboxElement = /*#__PURE__*/function (_HTMLDivElement2) {
    _inherits(CheckboxElement, _HTMLDivElement2);

    var _super2 = _createSuper(CheckboxElement);

    function CheckboxElement(inputName, label) {
      var _this2;

      _classCallCheck(this, CheckboxElement);

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this].concat(args));
      _this2.inputName = inputName;
      _this2.label = label;
      _this2.inputId = "custom_input_element_cool_id_".concat(CheckboxElement.lastId++);
      _this2.input = document.createElement('input');
      return _this2;
    }

    _createClass(CheckboxElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('form-group', 'fg-float', 'm-b-5');
        var checkboxContainer = document.createElement('div');
        checkboxContainer.classList.add('col-sm-12', 'checkbox-field-container');
        var checkboxElement = document.createElement('div');
        checkboxElement.classList.add('checkbox');
        var labelElement = document.createElement('label');
        checkboxContainer.appendChild(checkboxElement);
        checkboxElement.appendChild(labelElement);
        labelElement.appendChild(this.input);
        this.input.setAttribute('name', this.inputName);
        this.input.setAttribute('id', this.inputId);
        this.input.setAttribute('type', 'checkbox');
        this.input.classList.add('checkbox', 'style-0');
        var inputHelper = document.createElement('i');
        inputHelper.classList.add('input-helper');
        labelElement.appendChild(inputHelper);
        this.appendChild(checkboxContainer);

        if (this.label !== null) {
          labelElement.appendChild(document.createTextNode(this.label));
        }
      }
    }, {
      key: "value",
      get: function get() {
        return this.input.value;
      },
      set: function set(v) {
        this.input.value = v;
      }
    }]);

    return CheckboxElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  _defineProperty(CheckboxElement, "lastId", 1);

  var DeleteRowButtonElement = /*#__PURE__*/function (_HTMLDivElement3) {
    _inherits(DeleteRowButtonElement, _HTMLDivElement3);

    var _super3 = _createSuper(DeleteRowButtonElement);

    function DeleteRowButtonElement(elementToRemove) {
      var _this3;

      _classCallCheck(this, DeleteRowButtonElement);

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      _this3 = _super3.call.apply(_super3, [this].concat(args));
      _this3.victim = elementToRemove;
      return _this3;
    }

    _createClass(DeleteRowButtonElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this4 = this;

        this.classList.add('col-md-1');
        var button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.classList.add('btn');
        button.classList.add('btn-default');
        button.innerText = 'Usuń';
        this.appendChild(button);
        this.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (_this4.victim) {
            _this4.victim.remove();

            delete _this4.victim;
          }
        });
      }
    }]);

    return DeleteRowButtonElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var DdosNotificationEmailElement = /*#__PURE__*/function (_HTMLDivElement4) {
    _inherits(DdosNotificationEmailElement, _HTMLDivElement4);

    var _super4 = _createSuper(DdosNotificationEmailElement);

    function DdosNotificationEmailElement() {
      _classCallCheck(this, DdosNotificationEmailElement);

      return _super4.apply(this, arguments);
    }

    _createClass(DdosNotificationEmailElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var li = document.createElement('li');
        li.classList.add('row', 'm-b-20');
        this.appendChild(li);
        var liDiv = document.createElement('div');
        liDiv.classList.add('col-md-11');
        li.appendChild(liDiv);
        liDiv.appendChild(new InputElement('companyServicesType[ddosNotificationEmails][][email]', 'Adres email'));
        li.appendChild(new DeleteRowButtonElement(this));
      }
    }]);

    return DdosNotificationEmailElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var ManagedObject = function ManagedObject(id, label, companyName, selected) {
    var children = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    _classCallCheck(this, ManagedObject);

    this.id = id;
    this.label = label;
    this.companyName = companyName;
    this.selected = selected;
    this.children = children;
  };

  var DDoSContainer = /*#__PURE__*/function () {
    function DDoSContainer() {
      _classCallCheck(this, DDoSContainer);

      this.element = document.getElementById('mo-container');
      this.ul = undefined;
    }

    _createClass(DDoSContainer, [{
      key: "clear",
      value: function clear() {
        while (this.element.lastChild) {
          this.element.removeChild(this.element.lastChild);
        }

        delete this.ul;
      }
    }, {
      key: "append",
      value: function append(mo) {
        if (!this.ul) {
          this.ul = document.createElement('ul');
          this.ul.classList.add('checkbox-tree');
          this.element.appendChild(this.ul);
        }

        var li = this._li(mo);

        var ul = document.createElement('ul');

        var _iterator = _createForOfIteratorHelper(mo.children),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            ul.appendChild(this._li(child));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.ul.appendChild(li);
        li.appendChild(ul);
      }
    }, {
      key: "message",
      value: function message(msg) {
        var p = document.createElement('p');
        p.style.textAlign = 'center';
        p.innerText = msg;
        this.clear();
        this.element.appendChild(p);
      } // noinspection JSMethodCanBeStatic

    }, {
      key: "_li",
      value: function _li(mo) {
        var div = document.createElement('div');
        div.classList.add('checkbox');
        var li = document.createElement('li'); // noinspection JSUndefinedPropertyAssignment

        li.managedObject = mo;
        li.appendChild(div);
        var label = document.createElement('label');
        div.appendChild(label);
        var input = document.createElement('input');
        input.setAttribute('type', 'checkbox');
        input.classList.add('checkbox', 'style-0');
        input.setAttribute('value', "".concat(mo.id));
        input.setAttribute('name', 'companyServicesType[managedObjects][]');
        label.appendChild(input);

        if (mo.selected) {
          input.setAttribute('checked', 'checked');
        }

        var i = document.createElement('i');
        i.classList.add('input-helper');
        label.appendChild(i);
        var txt = document.createTextNode("".concat(mo.label, " (").concat(mo.companyName || 'n.a.', ")"));
        label.appendChild(txt);
        return li;
      }
    }]);

    return DDoSContainer;
  }();

  var DDoS = /*#__PURE__*/function () {
    function DDoS(companyId, loadUrl) {
      var _this5 = this;

      _classCallCheck(this, DDoS);

      this.container = new DDoSContainer();
      this.companyId = companyId;
      this.loadUrl = loadUrl;
      this.managedObjects = [];
      this.mo = new rxjs.Subject();
      this.mo$ = this.mo.asObservable().pipe(rxjs.operators.map(function (data) {
        var results = [];

        var _iterator2 = _createForOfIteratorHelper(data),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;
            var children = [];

            var _iterator3 = _createForOfIteratorHelper(row.children || []),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var child = _step3.value;
                children.push(new ManagedObject(child.id, child.label, child.companyName, child.selected));
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            results.push(new ManagedObject(row.id, row.label, row.companyName, row.selected, children));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return results;
      }), rxjs.operators.tap(function (data) {
        return _this5.managedObjects = data;
      }));
      this.mo$.subscribe(this.draw.bind(this));
      this.container.message('Wczytywanie danych...');
      this.loadManagedObjects();
      this.bindEvents();
    }

    _createClass(DDoS, [{
      key: "loadManagedObjects",
      value: function loadManagedObjects() {
        var _this6 = this;

        // noinspection JSUnusedLocalSymbols
        ApiConnect.get(this.loadUrl).then(function (data) {
          _this6.mo.next(data);
        })["catch"](function (errorThrown) {
          _this6.mo.error(errorThrown.toString());

          _this6.container.message('Wystąpił błąd podczas wczytywania danych.');
        });
      }
    }, {
      key: "draw",
      value: function draw(data) {
        this.container.clear();

        if (!(data || []).length) {
          this.container.message('Brak danych do wyświetlenia.');
          return;
        }

        var _iterator4 = _createForOfIteratorHelper(data),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var mo = _step4.value;
            this.container.append(mo);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        ApiCheckboxTree.init();
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        document.getElementById('addDdosNotificationEmailID').addEventListener('click', function (e) {
          e.preventDefault();
          var list = document.getElementById('ddosNotificationEmailsList');
          list.appendChild(new DdosNotificationEmailElement());
        });
      }
    }]);

    return DDoS;
  }();

  var VlanIdentifierElement = /*#__PURE__*/function (_HTMLLIElement) {
    _inherits(VlanIdentifierElement, _HTMLLIElement);

    var _super5 = _createSuper(VlanIdentifierElement);

    function VlanIdentifierElement() {
      _classCallCheck(this, VlanIdentifierElement);

      return _super5.apply(this, arguments);
    }

    _createClass(VlanIdentifierElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row', 'm-b-20');
        var div = document.createElement('div');
        div.classList.add('col-md-11');
        div.appendChild(new InputElement('companyServicesType[vlans][][name]', 'Identyfikator vlan'));
        this.appendChild(div);
        this.appendChild(new DeleteRowButtonElement(this));
      }
    }]);

    return VlanIdentifierElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  var MalwareFirewallElement = /*#__PURE__*/function (_HTMLLIElement2) {
    _inherits(MalwareFirewallElement, _HTMLLIElement2);

    var _super6 = _createSuper(MalwareFirewallElement);

    function MalwareFirewallElement() {
      _classCallCheck(this, MalwareFirewallElement);

      return _super6.apply(this, arguments);
    }

    _createClass(MalwareFirewallElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row', 'm-b-20');
        var liDivOuter = document.createElement('div');
        liDivOuter.classList.add('col-md-11');
        var liDivInner = document.createElement('div');
        liDivInner.classList.add('row');
        liDivOuter.appendChild(liDivInner);
        var inputs = [{
          name: "companyServicesType[firewalls][".concat(this.id, "][ip]"),
          label: 'IP firewalla'
        }, {
          name: "companyServicesType[firewalls][".concat(this.id, "][name]"),
          label: 'Nazwa firewalla'
        }, {
          name: "companyServicesType[firewalls][".concat(this.id, "][deviceId]"),
          label: 'Identyfikator device id'
        }];

        for (var _i = 0, _inputs = inputs; _i < _inputs.length; _i++) {
          var data = _inputs[_i];
          var inputContainer = document.createElement('div');
          inputContainer.classList.add('col-md-4');
          inputContainer.appendChild(new InputElement(data.name, data.label));
          liDivInner.appendChild(inputContainer);
        }

        this.appendChild(liDivOuter);
        this.appendChild(new DeleteRowButtonElement(this));
      }
    }, {
      key: "id",
      get: function get() {
        return this._id || (this._id = MalwareFirewallElement.lastId++);
      }
    }]);

    return MalwareFirewallElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  _defineProperty(MalwareFirewallElement, "lastId", 1000);

  var MalwareProtection = /*#__PURE__*/function () {
    function MalwareProtection() {
      _classCallCheck(this, MalwareProtection);

      this.addVlanButton = document.getElementById('addVlanID');
      this.addDeviceButton = document.getElementById('addFirewall');
      this.bindEvents();
    }

    _createClass(MalwareProtection, [{
      key: "bindEvents",
      value: function bindEvents() {
        this.addVlanButton.addEventListener('click', function (e) {
          e.preventDefault();
          var list = document.getElementById('vLanList');
          list.appendChild(new VlanIdentifierElement());
        });
        this.addDeviceButton.addEventListener('click', function (e) {
          e.preventDefault();
          var list = document.getElementById('firewallsList');
          list.appendChild(new MalwareFirewallElement());
        });
      }
    }]);

    return MalwareProtection;
  }();

  var WebApplicationInputElement = /*#__PURE__*/function (_HTMLLIElement3) {
    _inherits(WebApplicationInputElement, _HTMLLIElement3);

    var _super7 = _createSuper(WebApplicationInputElement);

    function WebApplicationInputElement(inputName, label) {
      var _this7;

      _classCallCheck(this, WebApplicationInputElement);

      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      _this7 = _super7.call.apply(_super7, [this].concat(args));
      _this7.inputName = inputName;
      _this7.label = label;
      return _this7;
    }

    _createClass(WebApplicationInputElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row', 'm-b-20');
        var div = document.createElement('div');
        div.classList.add('col-md-11');
        div.appendChild(new InputElement(this.inputName, this.label));
        this.appendChild(div);
        this.appendChild(new DeleteRowButtonElement(this));
      }
    }]);

    return WebApplicationInputElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  var WebApplicationProtection = function WebApplicationProtection() {
    _classCallCheck(this, WebApplicationProtection);

    var actions = [{
      buttonId: 'addTunnelID',
      listId: 'tunnelList',
      inputName: 'companyServicesType[tunnels][][name]',
      label: 'Identyfikator tunelu'
    }, {
      buttonId: 'addNetworkPolicyName',
      listId: 'networkPolicyList',
      inputName: 'companyServicesType[networkPolicies][][name]',
      label: 'Nazwa polityki'
    }, {
      buttonId: 'addServerPolicyName',
      listId: 'serverPolicyList',
      inputName: 'companyServicesType[serverPolicies][][name]',
      label: 'Nazwa polityki'
    }];

    var _loop = function _loop() {
      var action = _actions[_i2];
      document.getElementById(action.buttonId).addEventListener('click', function (e) {
        e.preventDefault();
        var list = document.getElementById(action.listId);
        list.appendChild(new WebApplicationInputElement(action.inputName, action.label));
      });
    };

    for (var _i2 = 0, _actions = actions; _i2 < _actions.length; _i2++) {
      _loop();
    }
  };

  var CyberPakietNotificationEmailElement = /*#__PURE__*/function (_HTMLDivElement5) {
    _inherits(CyberPakietNotificationEmailElement, _HTMLDivElement5);

    var _super8 = _createSuper(CyberPakietNotificationEmailElement);

    function CyberPakietNotificationEmailElement() {
      _classCallCheck(this, CyberPakietNotificationEmailElement);

      return _super8.apply(this, arguments);
    }

    _createClass(CyberPakietNotificationEmailElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var li = document.createElement('li');
        li.classList.add('row', 'm-b-20');
        this.appendChild(li);
        var liDiv = document.createElement('div');
        liDiv.classList.add('col-md-11');
        li.appendChild(liDiv);
        liDiv.appendChild(new InputElement('companyServicesType[cyberPakietNotificationEmails][][email]', 'Adres email'));
        li.appendChild(new DeleteRowButtonElement(this));
      }
    }]);

    return CyberPakietNotificationEmailElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var CyberPakietInputElement = /*#__PURE__*/function (_HTMLLIElement4) {
    _inherits(CyberPakietInputElement, _HTMLLIElement4);

    var _super9 = _createSuper(CyberPakietInputElement);

    function CyberPakietInputElement(inputName, label) {
      var _this8;

      _classCallCheck(this, CyberPakietInputElement);

      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      _this8 = _super9.call.apply(_super9, [this].concat(args));
      _this8.inputName = inputName;
      _this8.label = label;
      return _this8;
    }

    _createClass(CyberPakietInputElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row', 'm-b-20');
        var div = document.createElement('div');
        div.classList.add('col-md-11');
        div.appendChild(new InputElement(this.inputName, this.label));
        this.appendChild(div);
        this.appendChild(new DeleteRowButtonElement(this));
      }
    }]);

    return CyberPakietInputElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  var CyberPakietNetworkTestConfigurationItemElement = /*#__PURE__*/function (_HTMLLIElement5) {
    _inherits(CyberPakietNetworkTestConfigurationItemElement, _HTMLLIElement5);

    var _super10 = _createSuper(CyberPakietNetworkTestConfigurationItemElement);

    function CyberPakietNetworkTestConfigurationItemElement() {
      _classCallCheck(this, CyberPakietNetworkTestConfigurationItemElement);

      return _super10.apply(this, arguments);
    }

    _createClass(CyberPakietNetworkTestConfigurationItemElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row', 'm-b-20');
        var liDivOuter = document.createElement('div');
        liDivOuter.classList.add('col-md-11');
        var liDivInner = document.createElement('div');
        liDivInner.classList.add('row', 'm-t-30');
        liDivOuter.appendChild(liDivInner);
        var inputs = [{
          name: "companyServicesType[cyberPakietNetworkTestConfiguration][".concat(this.id, "][ipAddress]"),
          label: 'Adres IP',
          widthClass: 'col-md-3',
          labelUpClass: 'label-up'
        }, {
          name: "companyServicesType[cyberPakietNetworkTestConfiguration][".concat(this.id, "][hostname]"),
          label: 'Hostname',
          widthClass: 'col-md-3',
          labelUpClass: 'label-up'
        }, {
          name: "companyServicesType[cyberPakietNetworkTestConfiguration][".concat(this.id, "][routingDomain]"),
          label: 'Domena routingowa',
          type: 'text',
          widthClass: 'col-md-1',
          labelUpClass: 'label-up-25'
        }, {
          name: "companyServicesType[cyberPakietNetworkTestConfiguration][".concat(this.id, "][daysInterval]"),
          label: 'Interwał w dniach',
          type: 'number',
          widthClass: 'col-md-1',
          labelUpClass: 'label-up-25'
        }, {
          name: "companyServicesType[cyberPakietNetworkTestConfiguration][".concat(this.id, "][orderHour]"),
          label: 'Godz. zlecenia (0-23)',
          type: 'number',
          widthClass: 'col-md-1',
          labelUpClass: 'label-up-40'
        }, {
          name: "companyServicesType[cyberPakietNetworkTestConfiguration][".concat(this.id, "][forceOnNextRequest]"),
          label: 'Wymuś przy kolejnym żądaniu',
          type: 'checkbox',
          widthClass: 'col-md-3'
        }];

        for (var _i3 = 0, _inputs2 = inputs; _i3 < _inputs2.length; _i3++) {
          var data = _inputs2[_i3];
          var inputContainer = document.createElement('div');
          inputContainer.classList.add(data.widthClass);
          var inputElement = void 0;

          if (data.type === 'checkbox') {
            inputElement = new CheckboxElement(data.name, data.label);
          } else {
            inputElement = new InputElement(data.name, data.label);

            if (typeof data.type !== 'undefined') {
              inputElement.type = data.type;
            }
          }

          if (typeof data.labelUpClass !== 'undefined') {
            inputElement.classList.add(data.labelUpClass);
          }

          inputContainer.appendChild(inputElement);
          liDivInner.appendChild(inputContainer);
        }

        this.appendChild(liDivOuter);
        var deleteRowButtonElement = new DeleteRowButtonElement(this);
        deleteRowButtonElement.classList.add('m-t-20');
        this.appendChild(deleteRowButtonElement);
      }
    }, {
      key: "id",
      get: function get() {
        return this._id || (this._id = CyberPakietNetworkTestConfigurationItemElement.lastId++);
      }
    }]);

    return CyberPakietNetworkTestConfigurationItemElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  var CyberPakietWebAppTestConfigurationItemElement = /*#__PURE__*/function (_HTMLLIElement6) {
    _inherits(CyberPakietWebAppTestConfigurationItemElement, _HTMLLIElement6);

    var _super11 = _createSuper(CyberPakietWebAppTestConfigurationItemElement);

    function CyberPakietWebAppTestConfigurationItemElement() {
      _classCallCheck(this, CyberPakietWebAppTestConfigurationItemElement);

      return _super11.apply(this, arguments);
    }

    _createClass(CyberPakietWebAppTestConfigurationItemElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row', 'm-b-20');
        var liDivOuter = document.createElement('div');
        liDivOuter.classList.add('col-md-11');
        var liDivInner = document.createElement('div');
        liDivInner.classList.add('row', 'm-t-30');
        liDivOuter.appendChild(liDivInner);
        var id = this.id;
        var inputs = [{
          name: "companyServicesType[cyberPakietWebAppTestConfiguration][".concat(id, "][url]"),
          label: 'URL',
          widthClass: 'col-md-2',
          labelUpClass: 'label-up'
        }, {
          name: "companyServicesType[cyberPakietWebAppTestConfiguration][".concat(id, "][username]"),
          label: 'Nazwa użytkownika',
          widthClass: 'col-md-2',
          labelUpClass: 'label-up'
        }, {
          name: "companyServicesType[cyberPakietWebAppTestConfiguration][".concat(id, "][password]"),
          label: 'Hasło',
          widthClass: 'col-md-2',
          labelUpClass: 'label-up'
        }, {
          name: "companyServicesType[cyberPakietWebAppTestConfiguration][".concat(id, "][routingDomain]"),
          label: 'Domena routingowa',
          type: 'text',
          widthClass: 'col-md-1',
          labelUpClass: 'label-up-25'
        }, {
          name: "companyServicesType[cyberPakietWebAppTestConfiguration][".concat(id, "][daysInterval]"),
          label: 'Interwał w dniach',
          widthClass: 'col-md-1',
          type: 'number',
          labelUpClass: 'label-up-25'
        }, {
          name: "companyServicesType[cyberPakietWebAppTestConfiguration][".concat(id, "][orderHour]"),
          label: 'Godz. zlecenia (0-23)',
          widthClass: 'col-md-1',
          type: 'number',
          labelUpClass: 'label-up-40'
        }, {
          name: "companyServicesType[cyberPakietWebAppTestConfiguration][".concat(id, "][forceOnNextRequest]"),
          label: 'Wymuś przy kolejnym żądaniu',
          widthClass: 'col-md-3',
          type: 'checkbox'
        }];

        for (var _i4 = 0, _inputs3 = inputs; _i4 < _inputs3.length; _i4++) {
          var data = _inputs3[_i4];
          var inputContainer = document.createElement('div');
          inputContainer.classList.add(data.widthClass);
          var inputElement = void 0;

          if (data.type === 'checkbox') {
            inputElement = new CheckboxElement(data.name, data.label);
          } else {
            inputElement = new InputElement(data.name, data.label);

            if (typeof data.type !== 'undefined') {
              inputElement.type = data.type;
            }
          }

          if (typeof data.labelUpClass !== 'undefined') {
            inputElement.classList.add(data.labelUpClass);
          }

          inputContainer.appendChild(inputElement);
          liDivInner.appendChild(inputContainer);
        }

        this.appendChild(liDivOuter);
        var deleteRowButtonElement = new DeleteRowButtonElement(this);
        deleteRowButtonElement.classList.add('m-t-20');
        this.appendChild(deleteRowButtonElement);
      }
    }, {
      key: "id",
      get: function get() {
        return this._id || (this._id = CyberPakietWebAppTestConfigurationItemElement.lastId++);
      }
    }]);

    return CyberPakietWebAppTestConfigurationItemElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  var CyberPakiet = /*#__PURE__*/function () {
    function CyberPakiet() {
      _classCallCheck(this, CyberPakiet);

      var actions = [{
        buttonId: 'addCyberPakietIpAddress',
        listId: 'cyberPakietIpAddressList',
        inputName: 'companyServicesType[cyberPakietIpAddresses][][ipAddress]',
        label: null
      }, {
        buttonId: 'addCyberPakietIpRange',
        listId: 'cyberPakietIpRangeList',
        inputName: 'companyServicesType[cyberPakietIpRanges][][ipRange]',
        label: null
      }, {
        buttonId: 'addCyberPakietDomainName',
        listId: 'cyberPakietDomainNameList',
        inputName: 'companyServicesType[cyberPakietDomainNames][][fqdn]',
        label: null
      }, {
        buttonId: 'addCyberPakietKeyword',
        listId: 'cyberPakietKeywordList',
        inputName: 'companyServicesType[cyberPakietKeywords][][keyword]',
        label: null
      }, {
        buttonId: 'addCyberPakietId',
        listId: 'cyberPakietIdList',
        inputName: 'companyServicesType[cyberPakietIds][][identifier]',
        label: null
      }, {
        buttonId: 'addCyberPakietEmailDomain',
        listId: 'cyberPakietEmailDomainsList',
        inputName: 'companyServicesType[cyberPakietEmailDomains][][domain]',
        label: null
      }];

      var _loop2 = function _loop2() {
        var action = _actions2[_i5];
        document.getElementById(action.buttonId).addEventListener('click', function (e) {
          e.preventDefault();
          var list = document.getElementById(action.listId);
          list.appendChild(new CyberPakietInputElement(action.inputName, action.label));
        });
      };

      for (var _i5 = 0, _actions2 = actions; _i5 < _actions2.length; _i5++) {
        _loop2();
      }

      this.addNetworkTestConfigurationItemButton = document.getElementById('addCyberPakietNetworkTestConfigurationItem');
      this.addWebAppTestConfigurationItemButton = document.getElementById('addCyberPakietWebAppTestConfigurationItem');
      this.bindEvents();
    }

    _createClass(CyberPakiet, [{
      key: "bindEvents",
      value: function bindEvents() {
        this.addNetworkTestConfigurationItemButton.addEventListener('click', function (e) {
          e.preventDefault();
          var list = document.getElementById('cyberPakietNetworkTestConfigurationList');

          if (typeof CyberPakietNetworkTestConfigurationItemElement.lastId === 'undefined') {
            CyberPakietNetworkTestConfigurationItemElement.lastId = list.childElementCount;
          }

          list.appendChild(new CyberPakietNetworkTestConfigurationItemElement());
        });
        this.addWebAppTestConfigurationItemButton.addEventListener('click', function (e) {
          e.preventDefault();
          var list = document.getElementById('cyberPakietWebAppTestConfigurationList');

          if (typeof CyberPakietWebAppTestConfigurationItemElement.lastId === 'undefined') {
            CyberPakietWebAppTestConfigurationItemElement.lastId = list.childElementCount;
          }

          list.appendChild(new CyberPakietWebAppTestConfigurationItemElement());
        });
        document.getElementById('addCyberPakietNotificationEmailID').addEventListener('click', function (e) {
          e.preventDefault();
          var list = document.getElementById('cyberPakietNotificationEmailsList');
          list.appendChild(new CyberPakietNotificationEmailElement());
        });
      }
    }]);

    return CyberPakiet;
  }();

  var IpQueryElement = /*#__PURE__*/function (_HTMLLIElement7) {
    _inherits(IpQueryElement, _HTMLLIElement7);

    var _super12 = _createSuper(IpQueryElement);

    function IpQueryElement() {
      _classCallCheck(this, IpQueryElement);

      return _super12.apply(this, arguments);
    }

    _createClass(IpQueryElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row', 'm-b-20');
        var outerDivElement = document.createElement('div');
        outerDivElement.classList.add('col-md-11');
        var innerDivElement = document.createElement('div');
        innerDivElement.classList.add('row');
        var id = IpQueryElement.lastId++;
        var inputs = [{
          name: "companyServicesType[ipQueryLimits][".concat(id, "][queryingIp]"),
          label: 'Adres IP'
        }, {
          name: "companyServicesType[ipQueryLimits][".concat(id, "][dailyQueriesLimit]"),
          label: 'Dzienny limit zapytań'
        }];

        for (var _i6 = 0, _inputs4 = inputs; _i6 < _inputs4.length; _i6++) {
          var data = _inputs4[_i6];
          var div = document.createElement('div');
          div.classList.add('col-md-4');
          div.appendChild(new InputElement(data.name, data.label));
          innerDivElement.appendChild(div);
        }

        outerDivElement.appendChild(innerDivElement);
        this.appendChild(outerDivElement);
        this.appendChild(new DeleteRowButtonElement(this));
      }
    }]);

    return IpQueryElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  _defineProperty(IpQueryElement, "lastId", 1000);

  var ApplicationVersionElement = /*#__PURE__*/function (_HTMLDivElement6) {
    _inherits(ApplicationVersionElement, _HTMLDivElement6);

    var _super13 = _createSuper(ApplicationVersionElement);

    function ApplicationVersionElement(appId, version) {
      var _this9;

      _classCallCheck(this, ApplicationVersionElement);

      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      _this9 = _super13.call.apply(_super13, [this].concat(args));
      _this9.appId = appId;
      _this9.version = version;
      return _this9;
    }

    _createClass(ApplicationVersionElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('row');
        this.style.marginBottom = '15px';
        var inputElement = new InputElement("companyServicesType[applications][".concat(this.appId, "][versions][][name]"), '');
        inputElement.value = this.version;
        var inputContainerElement = document.createElement('div');
        inputContainerElement.classList.add('col-md-8');
        inputContainerElement.appendChild(inputElement);
        this.appendChild(inputContainerElement);
        this.appendChild(new DeleteRowButtonElement(this));
      }
    }]);

    return ApplicationVersionElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var ApplicationVersionsContainerElement = /*#__PURE__*/function (_HTMLDivElement7) {
    _inherits(ApplicationVersionsContainerElement, _HTMLDivElement7);

    var _super14 = _createSuper(ApplicationVersionsContainerElement);

    function ApplicationVersionsContainerElement(appId, versions) {
      var _this10;

      _classCallCheck(this, ApplicationVersionsContainerElement);

      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      _this10 = _super14.call.apply(_super14, [this].concat(args));
      _this10.appId = appId;
      _this10.versions = versions;
      return _this10;
    }

    _createClass(ApplicationVersionsContainerElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this11 = this;

        this.style.padding = '15px';
        var containerElement = document.createElement('div');
        containerElement.classList.add('row');
        var labelContainerElement = document.createElement('div');
        labelContainerElement.classList.add('col-md-2');
        labelContainerElement.style.lineHeight = '37px';
        labelContainerElement.innerText = 'Wersja aplikacji';
        var versionsContainerElement = document.createElement('div');
        versionsContainerElement.classList.add('col-md-10');
        this.appendChild(containerElement);
        containerElement.appendChild(labelContainerElement);
        containerElement.appendChild(versionsContainerElement);
        var addVersionButton = document.createElement('button');
        addVersionButton.classList.add('btn', 'btn-primary');
        addVersionButton.innerText = 'Dodaj wersję aplikacji';
        addVersionButton.addEventListener('click', function (e) {
          e.preventDefault();
          versionsContainerElement.removeChild(addVersionButton);
          versionsContainerElement.appendChild(new ApplicationVersionElement(_this11.appId, ''));
          versionsContainerElement.appendChild(addVersionButton);
        });

        var _iterator5 = _createForOfIteratorHelper(this.versions),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var version = _step5.value;
            versionsContainerElement.appendChild(new ApplicationVersionElement(this.appId, version));
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        versionsContainerElement.appendChild(addVersionButton);
      }
    }]);

    return ApplicationVersionsContainerElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var ApplicationElement = /*#__PURE__*/function (_HTMLDivElement8) {
    _inherits(ApplicationElement, _HTMLDivElement8);

    var _super15 = _createSuper(ApplicationElement);

    function ApplicationElement(app) {
      var _this12;

      _classCallCheck(this, ApplicationElement);

      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      _this12 = _super15.call.apply(_super15, [this].concat(args));
      _this12.name = (app || {}).name || '';
      _this12.versions = (app || {}).versions || [];
      _this12.appId = ApplicationElement.lastId++;
      return _this12;
    }

    _createClass(ApplicationElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.style.border = '1px solid gray';
        this.style.borderRadius = '3px';
        this.style.overflow = 'hidden';
        this.style.marginBottom = '15px';
        var nameContainerElement = document.createElement('div');
        nameContainerElement.classList.add('row');
        nameContainerElement.style.backgroundColor = '#fafafa';
        nameContainerElement.style.padding = '15px';
        nameContainerElement.style.borderBottom = '1px solid gray';
        var nameLabelContainerElement = document.createElement('div');
        nameLabelContainerElement.classList.add('col-md-2');
        nameLabelContainerElement.style.lineHeight = '37px';
        nameLabelContainerElement.innerText = 'Nazwa aplikacji';
        var inputElement = new InputElement("companyServicesType[applications][".concat(this.appId, "][name]"), '');
        inputElement.value = this.name;
        var nameInputContainerElement = document.createElement('div');
        nameInputContainerElement.classList.add('col-md-8');
        nameInputContainerElement.appendChild(inputElement);
        nameContainerElement.appendChild(nameLabelContainerElement);
        nameContainerElement.appendChild(nameInputContainerElement);
        nameContainerElement.appendChild(new DeleteRowButtonElement(this));
        this.appendChild(nameContainerElement);
        this.appendChild(new ApplicationVersionsContainerElement(this.appId, this.versions));
      }
    }]);

    return ApplicationElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  _defineProperty(ApplicationElement, "lastId", 0);

  var CompanyServicesSettingsController = function CompanyServicesSettingsController(options) {
    _classCallCheck(this, CompanyServicesSettingsController);

    this.companyId = options.companyId;
    this.ddosProtection = new DDoS(this.companyId, options.ddos.loadUrl);
    this.malwareProtection = new MalwareProtection();
    this.webApplicationProtection = new WebApplicationProtection();
    this.cyberPakiet = new CyberPakiet();
    var deleteButtons = document.querySelectorAll('.delete-row');

    var _loop3 = function _loop3() {
      var button = _Array$from[_i7];
      button.addEventListener('click', function (e) {
        e.preventDefault();
        button.closest('li').remove();
      });
    };

    for (var _i7 = 0, _Array$from = Array.from(deleteButtons); _i7 < _Array$from.length; _i7++) {
      _loop3();
    } // Security Reputation Service


    document.getElementById('addIpQueryLimit').addEventListener('click', function (e) {
      e.preventDefault();
      var list = document.getElementById('ipQueryLimitsList');
      list.appendChild(new IpQueryElement());
    }); // Security Code Security Audit

    document.getElementById('addNewApplication').addEventListener('click', function (e) {
      e.preventDefault();
      var list = document.getElementById('applicationList');
      list.appendChild(new ApplicationElement({}));
    });
    var applications = options.sourceCodeSecurityAudit.applications.map(function (app) {
      app.versions = (app.versions || []).map(function (version) {
        return version.name;
      });
      return app;
    });
    var list = document.getElementById('applicationList');

    var _iterator6 = _createForOfIteratorHelper(applications),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var app = _step6.value;
        list.appendChild(new ApplicationElement(app));
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }; //rejestracja customElements


  customElements.define('ddos-notification-email', DdosNotificationEmailElement, {
    "extends": 'div'
  });
  customElements.define('cyber-pakiet-notification-email', CyberPakietNotificationEmailElement, {
    "extends": 'div'
  });
  customElements.define('delete-row-button', DeleteRowButtonElement, {
    "extends": 'div'
  });
  customElements.define('form-input', InputElement, {
    "extends": 'div'
  });
  customElements.define('form-input-checkbox', CheckboxElement, {
    "extends": 'div'
  });
  customElements.define('vlan-identifier', VlanIdentifierElement, {
    "extends": 'li'
  });
  customElements.define('malware-firewall', MalwareFirewallElement, {
    "extends": 'li'
  });
  customElements.define('web-app-input', WebApplicationInputElement, {
    "extends": 'li'
  });
  customElements.define('cyber-pakiet-input', CyberPakietInputElement, {
    "extends": 'li'
  });
  customElements.define('cyber-pakiet-network-test-config-item-input', CyberPakietNetworkTestConfigurationItemElement, {
    "extends": 'li'
  });
  customElements.define('cyber-pakiet-web-app-test-config-item-input', CyberPakietWebAppTestConfigurationItemElement, {
    "extends": 'li'
  });
  customElements.define('ip-query', IpQueryElement, {
    "extends": 'li'
  });
  customElements.define('app-element', ApplicationElement, {
    "extends": 'div'
  });
  customElements.define('app-versions-container', ApplicationVersionsContainerElement, {
    "extends": 'div'
  });
  customElements.define('app-version', ApplicationVersionElement, {
    "extends": 'div'
  }); //wyeksportowanie klasy

  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CompanyServicesSettings = CompanyServicesSettingsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietAwarenessMemberReportsController = /*#__PURE__*/function () {
    function CyberPakietAwarenessMemberReportsController(config) {
      _classCallCheck(this, CyberPakietAwarenessMemberReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(CyberPakietAwarenessMemberReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Temat",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Forma",
            "dataIndex": "type",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isSortable": false,
            "isFilterable": false,
            "width": "*"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietAwarenessMemberReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietAwarenessMemberReportsController = CyberPakietAwarenessMemberReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietAwarenessReportsController = /*#__PURE__*/function () {
    function CyberPakietAwarenessReportsController(config) {
      _classCallCheck(this, CyberPakietAwarenessReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "grind-container"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(CyberPakietAwarenessReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Temat",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Forma",
            "dataIndex": "type",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 180
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietAwarenessReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietAwarenessReportsController = CyberPakietAwarenessReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietCisoSupportMemberReportsController = /*#__PURE__*/function () {
    function CyberPakietCisoSupportMemberReportsController(config) {
      _classCallCheck(this, CyberPakietCisoSupportMemberReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(CyberPakietCisoSupportMemberReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isSortable": false,
            "isFilterable": false,
            "width": "*"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietCisoSupportMemberReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietCisoSupportMemberReportsController = CyberPakietCisoSupportMemberReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietCisoSupportReportsController = /*#__PURE__*/function () {
    function CyberPakietCisoSupportReportsController(config) {
      _classCallCheck(this, CyberPakietCisoSupportReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "grind-container"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(CyberPakietCisoSupportReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Status raportu",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 180
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietCisoSupportReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietCisoSupportReportsController = CyberPakietCisoSupportReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietCtiEventsController = /*#__PURE__*/function () {
    function CyberPakietCtiEventsController(config) {
      _classCallCheck(this, CyberPakietCtiEventsController);

      this.settings = {};
      this.init(config);
    }

    _createClass(CyberPakietCtiEventsController, [{
      key: "init",
      value: function init(config) {
        // noinspection JSUnusedLocalSymbols
        var controller = this;
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Id",
            "dataIndex": "id",
            "dataType": "number",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "150"
          }, {
            "label": "Zasób",
            "dataIndex": "asset",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "300"
          }, {
            "label": "Typ assetu",
            "dataIndex": "asset_type",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "200"
          }, {
            "label": "Dane",
            "dataIndex": "data",
            "dataType": "textarea",
            "isEditable": false,
            "width": "*"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        }); // noinspection JSUnusedLocalSymbols

        var grid = new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          'enableMultiline': true,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
        grid.grid.attachEvent("onXLE", function (gridObject, addedRowsCount) {
          gridObject.forEachRow(function (id) {
            console.log('grid.cells(' + id + ', 3).cell.className = \'json\'');
            gridObject.cells(id, 3).cell.className = 'json';
          });
        });
      }
    }]);

    return CyberPakietCtiEventsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietCtiEventsController = CyberPakietCtiEventsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietCtiReportEntriesController = /*#__PURE__*/function () {
    function CyberPakietCtiReportEntriesController(config) {
      _classCallCheck(this, CyberPakietCtiReportEntriesController);

      this.settings = {};
      this.init(config);
    }

    _createClass(CyberPakietCtiReportEntriesController, [{
      key: "init",
      value: function init(config) {
        // noinspection JSUnusedLocalSymbols
        var controller = this;
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Id",
            "dataIndex": "id",
            "dataType": "number",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "150"
          }, {
            "label": "Data przesłania",
            "dataIndex": "upload_date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "company_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Typ",
            "dataIndex": "check_type",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 170
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        }); // noinspection JSUnusedLocalSymbols

        var grid = new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietCtiReportEntriesController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietCtiReportEntriesController = CyberPakietCtiReportEntriesController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietInfrastructureVulnerabilitiesHierarchicalController = /*#__PURE__*/function () {
    function CyberPakietInfrastructureVulnerabilitiesHierarchicalController() {
      _classCallCheck(this, CyberPakietInfrastructureVulnerabilitiesHierarchicalController);

      var controller = this;
      ApiConnect.get('/member/api/cyber-pakiet/infrastructure/applications/ips').then(function (response) {
        var ips = $("#accordion");
        response.data.forEach(function (ip) {
          var count;

          if (ip.count === 1) {
            count = '1 podatność';
          } else {
            count = ip.count + ' podatności';
          }

          var head = document.createElement("h3");
          var displayedIp = ip.ip === 'unknown' ? 'Nieznany adres IP' : ip.ip;
          head.innerHTML = displayedIp + ' (' + count + ')';
          ips.append(head);
          var body = document.createElement("div");
          body.innerHTML = "<div data-ip='" + ip.ip + "' class='id'></div>";
          ips.append(body);
        });
        ips.accordion({
          heightStyle: "content",
          collapsible: true,
          active: false,
          beforeActivate: function beforeActivate(event, ui) {
            if (ui.newPanel[0].children[0].className === 'id') {
              var ip = ui.newPanel[0].children[0].dataset['ip'];
              var block = $("[data-ip='" + ip + "']");
              block.html("");
              block.removeClass('id');
              block.addClass('spinner');
              ApiConnect.get('/member/api/cyber-pakiet/infrastructure/applications/' + ip).then(function (response) {
                block.removeClass('spinner');
                controller.showSeverityList(response);
              })["catch"](function (errorThrown) {
                if (errorThrown !== 'redirect') {
                  ApiNotification.notify({
                    type: 'error',
                    _message: 'Wystąpił błąd podczas wczytywania danych'
                  });
                }
              });
            }
          }
        });
      })["catch"](function (errorThrown) {
        if (errorThrown !== 'redirect') {
          ApiNotification.notify({
            type: 'error',
            _message: 'Wystąpił błąd podczas wczytywania danych'
          });
        }
      });
    }

    _createClass(CyberPakietInfrastructureVulnerabilitiesHierarchicalController, [{
      key: "showSeverityList",
      value: function showSeverityList(response) {
        var controller = this;
        var container = $("[data-ip='" + response.ip + "']");
        response.data.forEach(function (severity) {
          var count;

          if (severity.count === 1) {
            count = '1 podatność';
          } else {
            count = severity.count + ' podatności';
          }

          var head = document.createElement("h3");
          var displayedSeverity = 'Nieznana krytyczność';

          switch (severity.severity) {
            case 'critical':
              displayedSeverity = 'Krytyczna';
              break;

            case 'high':
              displayedSeverity = 'Wysoka';
              break;

            case 'medium':
              displayedSeverity = 'Średnia';
              break;

            case 'low':
              displayedSeverity = 'Niska';
              break;

            case 'log':
              displayedSeverity = 'Log';
              break;

            case 'info':
              displayedSeverity = 'Informacyjna';
              break;
          }

          head.innerHTML = displayedSeverity + ' (' + count + ')';
          container.append(head);
          var body = document.createElement("div");
          body.innerHTML = "<div data-ip='" + response.ip + "' data-severity='" + severity.severity + "' class='id'></div>";
          container.append(body);
        });
        container.accordion({
          heightStyle: "content",
          collapsible: true,
          active: false,
          beforeActivate: function beforeActivate(event, ui) {
            if (ui.newPanel[0].children[0].className === 'id') {
              var ip = ui.newPanel[0].children[0].dataset['ip'];
              var severity = ui.newPanel[0].children[0].dataset['severity'];
              var block = $("[data-ip='" + ip + "'][data-severity='" + severity + "']");
              block.html("");
              block.removeClass('id');
              block.addClass('spinner');
              ApiConnect.get('/member/api/cyber-pakiet/infrastructure/applications/' + ip + '/' + severity).then(function (data) {
                controller.listVulnerabilities(data);
              })["catch"](function (errorThrown) {
                if (errorThrown !== 'redirect') {
                  ApiNotification.notify({
                    type: 'error',
                    _message: 'Wystąpił błąd podczas wczytywania danych'
                  });
                }
              });
            }
          }
        });
      }
    }, {
      key: "listVulnerabilities",
      value: function listVulnerabilities(response) {
        var list = document.createElement("div");
        list.setAttribute('class', 'vulnerabilities');
        response.data.forEach(function (vulnerability) {
          var el = document.createElement("a");
          el.setAttribute('href', '/member/cyber-pakiet/infrastructure/vulnerabilities/' + vulnerability.id); // noinspection JSUnresolvedVariable

          el.innerText = vulnerability.name + ' (protokół: ' + (vulnerability.ipProtocol || 'b.d.') + ', port: ' + (vulnerability.port || 'b.d.') + ')';
          list.append(el);
        });
        var selector = "[data-ip='" + response.ip + "'][data-severity='" + response.severity + "']";
        $(selector).removeClass('spinner');
        $(selector).append(list);
      }
    }]);

    return CyberPakietInfrastructureVulnerabilitiesHierarchicalController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietInfrastructureVulnerabilitiesHierarchicalController = CyberPakietInfrastructureVulnerabilitiesHierarchicalController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietPenetrationTestingMemberReportsController = /*#__PURE__*/function () {
    function CyberPakietPenetrationTestingMemberReportsController(config) {
      _classCallCheck(this, CyberPakietPenetrationTestingMemberReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(CyberPakietPenetrationTestingMemberReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isSortable": false,
            "isFilterable": false,
            "width": "*"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietPenetrationTestingMemberReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietPenetrationTestingMemberReportsController = CyberPakietPenetrationTestingMemberReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietPenetrationTestingReportsController = /*#__PURE__*/function () {
    function CyberPakietPenetrationTestingReportsController(config) {
      _classCallCheck(this, CyberPakietPenetrationTestingReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "grind-container"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(CyberPakietPenetrationTestingReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Status raportu",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 180
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietPenetrationTestingReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietPenetrationTestingReportsController = CyberPakietPenetrationTestingReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietVulnerabilityScanReportMemberController = /*#__PURE__*/function () {
    function CyberPakietVulnerabilityScanReportMemberController(config) {
      _classCallCheck(this, CyberPakietVulnerabilityScanReportMemberController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(CyberPakietVulnerabilityScanReportMemberController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data wygenerowania",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Typ raportu",
            "dataIndex": "subtype",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Zakres skanu",
            "dataIndex": "scan_scope",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Liczba podatności",
            "dataIndex": "vulnerability_count",
            "dataType": "number",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": "*"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CyberPakietVulnerabilityScanReportMemberController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietVulnerabilityScanReportMemberController = CyberPakietVulnerabilityScanReportMemberController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CyberPakietWebVulnerabilitiesHierarchicalController = /*#__PURE__*/function () {
    function CyberPakietWebVulnerabilitiesHierarchicalController() {
      _classCallCheck(this, CyberPakietWebVulnerabilitiesHierarchicalController);

      var controller = this;
      ApiConnect.get('/member/api/cyber-pakiet/web/applications/by-url').then(function (response) {
        var urls = $("#accordion");
        response.data.forEach(function (url) {
          var count;

          if (url.count === 1) {
            count = '1 podatność';
          } else {
            count = url.count + ' podatności';
          }

          var head = document.createElement("h3");
          var displayedUrl = url.url === 'unknown' ? 'Nieznany URL' : url.url;
          head.innerHTML = displayedUrl + ' (' + count + ')';
          urls.append(head);
          var body = document.createElement("div");
          body.innerHTML = "<div data-url='" + url.url + "' class='id'></div>";
          urls.append(body);
        });
        urls.accordion({
          heightStyle: "content",
          collapsible: true,
          active: false,
          beforeActivate: function beforeActivate(event, ui) {
            if (ui.newPanel[0].children[0].className === 'id') {
              var url = ui.newPanel[0].children[0].dataset['url'];
              var block = $("[data-url='" + url + "']");
              block.html("");
              block.removeClass('id');
              block.addClass('spinner');
              ApiConnect.get('/member/api/cyber-pakiet/web/applications/by-severity?url=' + url).then(function (response) {
                block.removeClass('spinner');
                controller.showSeverityList(response);
              })["catch"](function (errorThrown) {
                if (errorThrown !== 'redirect') {
                  ApiNotification.notify({
                    type: 'error',
                    _message: 'Wystąpił błąd podczas wczytywania danych'
                  });
                }
              });
            }
          }
        });
      })["catch"](function (errorThrown) {
        if (errorThrown !== 'redirect') {
          ApiNotification.notify({
            type: 'error',
            _message: 'Wystąpił błąd podczas wczytywania danych'
          });
        }
      });
    }

    _createClass(CyberPakietWebVulnerabilitiesHierarchicalController, [{
      key: "showSeverityList",
      value: function showSeverityList(response) {
        var controller = this;
        var container = $("[data-url='" + response.url + "']");
        response.data.forEach(function (severity) {
          var count;

          if (severity.count === 1) {
            count = '1 podatność';
          } else {
            count = severity.count + ' podatności';
          }

          var head = document.createElement("h3");
          var displayedSeverity = 'Nieznana krytyczność';

          switch (severity.severity) {
            case 'critical':
              displayedSeverity = 'Krytyczna';
              break;

            case 'high':
              displayedSeverity = 'Wysoka';
              break;

            case 'medium':
              displayedSeverity = 'Średnia';
              break;

            case 'low':
              displayedSeverity = 'Niska';
              break;

            case 'log':
              displayedSeverity = 'Log';
              break;

            case 'info':
              displayedSeverity = 'Informacyjna';
              break;
          }

          head.innerHTML = displayedSeverity + ' (' + count + ')';
          container.append(head);
          var body = document.createElement("div");
          body.innerHTML = "<div data-url='" + response.url + "' data-severity='" + severity.severity + "' class='id'></div>";
          container.append(body);
        });
        container.accordion({
          heightStyle: "content",
          collapsible: true,
          active: false,
          beforeActivate: function beforeActivate(event, ui) {
            if (ui.newPanel[0].children[0].className === 'id') {
              var url = ui.newPanel[0].children[0].dataset['url'];
              var severity = ui.newPanel[0].children[0].dataset['severity'];
              var block = $("[data-url='" + url + "'][data-severity='" + severity + "']");
              block.html("");
              block.removeClass('id');
              block.addClass('spinner');
              ApiConnect.get('/member/api/cyber-pakiet/web/applications/for-severity/' + severity + '?url=' + url).then(function (data) {
                controller.listVulnerabilities(data);
              })["catch"](function (errorThrown) {
                if (errorThrown !== 'redirect') {
                  ApiNotification.notify({
                    type: 'error',
                    _message: 'Wystąpił błąd podczas wczytywania danych'
                  });
                }
              });
            }
          }
        });
      }
    }, {
      key: "listVulnerabilities",
      value: function listVulnerabilities(response) {
        var list = document.createElement("div");
        list.setAttribute('class', 'vulnerabilities');
        response.data.forEach(function (vulnerability) {
          var el = document.createElement("a");
          el.setAttribute('href', '/member/cyber-pakiet/web/vulnerabilities/' + vulnerability.id);
          el.innerText = vulnerability.name + ' (lokalizacja: ' + (vulnerability.location || 'b.d.') + ')';
          list.append(el);
        });
        var selector = "[data-url='" + response.url + "'][data-severity='" + response.severity + "']";
        $(selector).removeClass('spinner');
        $(selector).append(list);
      }
    }]);

    return CyberPakietWebVulnerabilitiesHierarchicalController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberPakietWebVulnerabilitiesHierarchicalController = CyberPakietWebVulnerabilitiesHierarchicalController || {};
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CybertarczaErrorReportListController = /*#__PURE__*/function () {
    function CybertarczaErrorReportListController(config) {
      _classCallCheck(this, CybertarczaErrorReportListController);

      this.settings = {
        table: {
          id: 'grid-container'
        }
      };
      this.init(config);
    }

    _createClass(CybertarczaErrorReportListController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Id",
            "dataIndex": "id",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": 150
          }, {
            "label": "Hash",
            "dataIndex": "hash",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "filterType": "text",
            "width": "*"
          }, {
            "label": "Id żądania",
            "dataIndex": "request_id",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "width": 200
          }, {
            "label": "Status odpowiedzi",
            "dataIndex": "response_status",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "width": 150
          }, {
            "label": "Data utworzenia",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isFilterable": false,
            "isSortable": false,
            "isEditable": false,
            "width": 300
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config['table_data_url'],
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': this.settings['table']['id'],
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CybertarczaErrorReportListController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberTarczaErrorReportListController = CybertarczaErrorReportListController || {};
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var CybertarczaThreatManagerResponseListController = /*#__PURE__*/function () {
    function CybertarczaThreatManagerResponseListController(config) {
      _classCallCheck(this, CybertarczaThreatManagerResponseListController);

      this.settings = {
        table: {
          id: 'grid-container'
        }
      };
      this.init(config);
    }

    _createClass(CybertarczaThreatManagerResponseListController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Id",
            "dataIndex": "id",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Id żądania",
            "dataIndex": "request_id",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "width": "*"
          }, {
            "label": "Adres IP",
            "dataIndex": "source_ip",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "width": "*"
          }, {
            "label": "Status odpowiedzi",
            "dataIndex": "response_status",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "width": "*"
          }, {
            "label": "Data utworzenia",
            "dataIndex": "created_at",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isFilterable": false,
            "isSortable": false,
            "isEditable": false,
            "width": "*"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config['table_data_url'],
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': this.settings['table']['id'],
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return CybertarczaThreatManagerResponseListController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.CyberTarczaThreatManagerResponseListController = CybertarczaThreatManagerResponseListController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosAlertPreviewController = /*#__PURE__*/function () {
    function DdosAlertPreviewController(config) {
      _classCallCheck(this, DdosAlertPreviewController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "bar-chart"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(DdosAlertPreviewController, [{
      key: "init",
      value: function init(config) {
        console.log('test-cert');
        this.loadDataChart(config);
      }
    }, {
      key: "loadDataChart",
      value: function loadDataChart(config) {
        var me = this;
        var cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
        $(document).bind('ajaxStart', function () {
          $('.loading').show('fast');
          $('.chart-title').hide();
          cardActions.css('opacity', 0);
        }).bind('ajaxStop', function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
        });
        ApiConnect.get(config.chart_data_url).then(function (data) {
          me.drawCharts(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
        });
      }
    }, {
      key: "drawCharts",
      value: function drawCharts(data) {
        this.barChart = new NS.Charts.LineChartScroll({
          "container-id": this.settings["charts"]["barChart"]["id"],
          "data": data["data"][this.settings["charts"]["barChart"]["dataName"]],
          "multidata": false,
          "scaleLabel": " Mbps"
        });
      }
    }]);

    return DdosAlertPreviewController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosAlertPreviewController = DdosAlertPreviewController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosArchivesController = /*#__PURE__*/function () {
    function DdosArchivesController(config) {
      _classCallCheck(this, DdosArchivesController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(DdosArchivesController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data utworzenia archiwum",
            "dataIndex": "date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": "200"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return DdosArchivesController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosArchivesController = DdosArchivesController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosChartProtocolController = /*#__PURE__*/function () {
    function DdosChartProtocolController(config) {
      _classCallCheck(this, DdosChartProtocolController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "bar-chart"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(DdosChartProtocolController, [{
      key: "init",
      value: function init(config) {
        this.loadDataChart(config, this.settings);
        this.createGrid(config);
      }
    }, {
      key: "loadDataChart",
      value: function loadDataChart(config, settings) {
        var me = this;
        var cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
        $(document).bind('ajaxStart', function () {
          $('.loading').show('fast');
          $('.chart-title').hide();
          cardActions.css('opacity', 0);
        }).bind('ajaxStop', function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
          $('.chart-title').show();
          cardActions.css('opacity', 1);
        });
        ApiConnect.get(config.chart_data_url).then(function (data) {
          me.drawCharts(data, settings);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
          $('.chart-title').show();
          cardActions.css('opacity', 1);
        });
      }
    }, {
      key: "drawCharts",
      value: function drawCharts(data, settings) {
        this.lineChart = new NS.Charts.DdosProtocolChart({
          "container-id": settings["charts"]["barChart"]["id"],
          "data": data["data"][settings["charts"]["barChart"]["dataName"]],
          "label_y": data["data"]["label_y"],
          "default_show": data["data"]["default_show"],
          "multidata": true,
          'show_legend': true
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Aplikacja",
            "dataIndex": "application",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true
          }, {
            "label": "Rodzaj",
            "dataIndex": "type",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Suma",
            "dataIndex": "value",
            "dataType": "text",
            "isEditable": false
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return DdosChartProtocolController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosChartProtocolController = DdosChartProtocolController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosController = /*#__PURE__*/function () {
    function DdosController(config) {
      _classCallCheck(this, DdosController);

      this.settings = {
        charts: {
          pieCharts: {
            alertsByImportance: {
              id: "summaryByImportance",
              dataName: "summary_by_importance"
            },
            alertsByType: {
              id: "summaryByType",
              dataName: "summary_by_type"
            }
          },
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(DdosController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _div2 = _step.value;

            var closestCard = _div2.closest('.card');

            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _div = _step2.value;
              _div.style.display = 'block';

              _div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var el = document.getElementById('charLinear1');
        var span = el.querySelector('span');
        var div = el.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var columnData = data.data.column_data;

          if (columnData.length === 0) {
            span.style.display = 'block';
          } else {
            div.style.display = 'block';

            _this.drawBarChart(data);
          }

          _this.drawPieCharts(data);

          _this.setCardHeaders(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(data) {
        var chartSettings = this.settings.charts;
        var pieChartSettings = chartSettings.pieCharts;
        var barChartId = chartSettings.barChart.id;
        var pieChartKeys = Object.keys(pieChartSettings);
        var firstPieChartSettings = pieChartSettings[pieChartKeys[0]];
        var firstPieChartId = firstPieChartSettings.id;
        var firstPieChartDataName = firstPieChartSettings.dataName;
        var firstPieChartTabId = firstPieChartId + 'Tab';
        var barChart = document.getElementById(barChartId);
        var barChartCard = barChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = this.config["bar_chart_title"];
        document.querySelectorAll('.pie-charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var firstPieChart = document.getElementById(firstPieChartId);
        var pieChartsCard = firstPieChart.closest('.card');
        var pieChartTitleEl = pieChartsCard.querySelector('.chart-title');
        pieChartTitleEl.textContent = data.data[firstPieChartDataName].name;
        var firstPieChartTab = document.getElementById(firstPieChartTabId);
        firstPieChartTab.classList.add('active');

        for (var _i = 0, _pieChartKeys = pieChartKeys; _i < _pieChartKeys.length; _i++) {
          var key = _pieChartKeys[_i];
          var chart = pieChartSettings[key];
          var pieChartMenuEl = document.querySelector('.pie-chart-menu');
          pieChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
        }

        this.bindChangeTabPieChart();
      }
    }, {
      key: "bindChangeTabPieChart",
      value: function bindChangeTabPieChart() {
        var chartTabToggles = document.querySelectorAll('.char-tab-toggle');

        var _iterator6 = _createForOfIteratorHelper(chartTabToggles),
            _step6;

        try {
          var _loop3 = function _loop3() {
            var toggle = _step6.value;
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              var target = document.getElementById(toggle.getAttribute('data-target-id'));

              if (target) {
                var otherTabs = Array.prototype.filter.call(target.parentNode.children, function (child) {
                  return child !== target;
                });

                var _iterator7 = _createForOfIteratorHelper(otherTabs),
                    _step7;

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var tab = _step7.value;
                    tab.classList.remove('active');
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                target.classList.add('active');
              }

              var cardHeader = toggle.closest('.card-header');
              var chartTitleEl = cardHeader.querySelector('h2');
              chartTitleEl.textContent = toggle.textContent;
            });
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "drawBarChart",
      value: function drawBarChart(data) {
        this.barChart = new NS.Charts.BarChart({
          "container-id": "alarms",
          data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
          multidata: true,
          colors: {
            low: this.settings["colors"]["low"],
            medium: this.settings["colors"]["medium"],
            high: this.settings["colors"]["high"]
          },
          name_mapping: {
            low: "Niski",
            medium: "Średni",
            high: "Wysoki"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawPieCharts",
      value: function drawPieCharts(data) {
        this.summaryByImportanceChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByImportance"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByImportance"]["dataName"]],
          colors: {
            low: this.settings["colors"]["low"],
            medium: this.settings["colors"]["medium"],
            high: this.settings["colors"]["high"]
          },
          name_mapping: {
            low: "Niski",
            medium: "Średni",
            high: "Wysoki"
          },
          show_legend: this.config['show_legend']
        });
        this.summaryByTypeChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByType"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByType"]["dataName"]]
        });
      }
    }, {
      key: "bindExport",
      value: function bindExport(dataSource) {
        var _loop4 = function _loop4() {
          var id = _arr[_i2];
          var button = document.getElementById(id);
          button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var filterStartIndex = dataSource.baseUrl.indexOf('/alerts?');
            var filterString = dataSource.baseUrl.substring(filterStartIndex).replace('/alerts', '');
            var basePath = button.getAttribute('href');
            dataSource['filterValues'].forEach(function (filter) {
              if (filter['value']) {
                filterString += '&filters[' + filter['dataIndex'] + ']=' + filter['value'];
              }
            });

            if (dataSource['sortValues']) {
              if (dataSource['sortValues']['order']) {
                filterString += '&sort[order]=' + dataSource['sortValues']['order'];
              }

              if (dataSource['sortValues']['order']) {
                filterString += '&sort[key]=' + dataSource['sortValues']['dataIndex'];
              }
            }

            window.open(basePath + filterString);
          });
        };

        for (var _i2 = 0, _arr = ['csv-export']; _i2 < _arr.length; _i2++) {
          _loop4();
        }
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "ID",
            dataIndex: "id",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            isMovable: true,
            width: 100
          }, {
            label: "Rozpoczęty",
            dataIndex: "start",
            dataType: "text",
            isEditable: false,
            width: "*"
          }, {
            label: "Zakończony",
            dataIndex: "finished",
            dataType: "text",
            isEditable: false
          }, {
            label: "Ważność",
            dataIndex: "priority",
            dataType: "importants",
            isEditable: false
          }, {
            label: "Managed object",
            dataIndex: "managed_object",
            dataType: "text",
            isEditable: false
          }, {
            label: "Typ",
            dataIndex: "type",
            dataType: "text",
            isEditable: false
          }, {
            label: "Incydent",
            dataIndex: "incident",
            dataType: "text",
            isEditable: false
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "link",
            isEditable: false,
            width: 100
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        this.bindExport(dataSource);
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return DdosController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosController = DdosController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosIncidentController = /*#__PURE__*/function () {
    function DdosIncidentController(config) {
      _classCallCheck(this, DdosIncidentController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "bar-chart"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(DdosIncidentController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _div2 = _step.value;

            var closestCard = _div2.closest('.card');

            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _div = _step2.value;
              _div.style.display = 'block';

              _div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var el = document.getElementById('charLinear1');
        var span = el.querySelector('span');
        var div = el.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var values = data.data.column_data.values;

          if (Object.keys(values).length === 0 && values.constructor === Object) {
            span.style.display = 'block';
          } else {
            div.style.display = 'block';

            _this.drawCharts(data);
          }

          _this.setCardHeaders();
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders() {
        var barChartId = this.settings.charts.barChart.id;
        var barChart = document.getElementById(barChartId);
        var barChartCard = barChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = this.config["bar_chart_title"];
      }
    }, {
      key: "drawCharts",
      value: function drawCharts(data) {
        this.barChart = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barChart"]["id"],
          data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
          multidata: false
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "Numer",
            dataIndex: "number",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            isMovable: true
          }, {
            label: "Rozpoczęty",
            dataIndex: "start",
            dataType: "text",
            isEditable: false,
            width: "*"
          }, {
            label: "Zmodyfikowany",
            dataIndex: "changed",
            dataType: "text",
            isEditable: false
          }, {
            label: "Tytuł",
            dataIndex: "title",
            dataType: "text",
            isEditable: false
          }, {
            label: "Status",
            dataIndex: "status",
            dataType: "text",
            isEditable: false
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "actions",
            isEditable: false,
            width: 100
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return DdosIncidentController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosIncidentController = DdosIncidentController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosMitigationController = /*#__PURE__*/function () {
    function DdosMitigationController(config) {
      _classCallCheck(this, DdosMitigationController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(DdosMitigationController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _div2 = _step.value;

            var closestCard = _div2.closest('.card');

            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _div = _step2.value;
              _div.style.display = 'block';

              _div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var el = document.getElementById('charLinear1');
        var span = el.querySelector('span');
        var div = el.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var values = data.data.column_data.values;

          if (Object.keys(values).length === 0 && values.constructor === Object) {
            span.style.display = 'block';
          } else {
            div.style.display = 'block';

            _this.drawCharts(data);
          }

          _this.setCardHeaders();
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders() {
        var barChartId = this.settings.charts.barChart.id;
        var barChart = document.getElementById(barChartId);
        var barChartCard = barChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = this.config["bar_chart_title"];
      }
    }, {
      key: "drawCharts",
      value: function drawCharts(data) {
        this.barChart = new NS.Charts.BarChart({
          "container-id": "alarms",
          data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
          multidata: false
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "Rozpoczęta",
            dataIndex: "start",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            isMovable: true
          }, {
            label: "Zakończona",
            dataIndex: "finished",
            dataType: "text",
            isEditable: false,
            width: "*"
          }, {
            label: "Nazwa",
            dataIndex: "name",
            dataType: "text",
            isEditable: false
          }, {
            label: "Managed object",
            dataIndex: "managed_object",
            dataType: "text",
            isEditable: false
          }, {
            label: "Alert",
            dataIndex: "alert",
            dataType: "text",
            isEditable: false
          }, {
            label: "Raport",
            dataIndex: "report",
            dataType: "text",
            isEditable: false
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "actions",
            isEditable: false
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return DdosMitigationController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosMitigationController = DdosMitigationController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosMitigationPreviewController = /*#__PURE__*/function () {
    function DdosMitigationPreviewController(config) {
      _classCallCheck(this, DdosMitigationPreviewController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "bar-chart"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(DdosMitigationPreviewController, [{
      key: "init",
      value: function init(config) {
        this.loadDataChart(config);
      }
    }, {
      key: "loadDataChart",
      value: function loadDataChart(config) {
        var me = this;
        var cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
        $(document).bind('ajaxStart', function () {
          $('.loading').show('fast');
          $('.chart-title').hide();
          cardActions.css('opacity', 0);
        }).bind('ajaxStop', function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
        });
        ApiConnect.get(config.chart_data_url).then(function (data) {
          me.drawCharts(data, this.settings);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
        });
      }
    }, {
      key: "drawCharts",
      value: function drawCharts(data) {
        this.barChart = new NS.Charts.LineChart({
          "container-id": this.settings["charts"]["barChart"]["id"],
          "data": data["data"][this.settings["charts"]["barChart"]["dataName"]],
          "multidata": false
        });
      }
    }]);

    return DdosMitigationPreviewController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosMitigationPreviewController = DdosMitigationPreviewController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosReportController = /*#__PURE__*/function () {
    function DdosReportController(config) {
      _classCallCheck(this, DdosReportController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(DdosReportController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": "*"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return DdosReportController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosReportController = DdosReportController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var DdosTrafficController = /*#__PURE__*/function () {
    function DdosTrafficController(config) {
      _classCallCheck(this, DdosTrafficController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "bar-chart"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(DdosTrafficController, [{
      key: "init",
      value: function init(config) {
        this.loadDataChart(config, this.settings);
      }
    }, {
      key: "loadDataChart",
      value: function loadDataChart(config, settings) {
        var _this = this;

        var cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
        $(document).bind('ajaxStart', function () {
          $('.loading').show('fast');
          $('.chart-title').hide();
          cardActions.css('opacity', 0);
        }).bind('ajaxStop', function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
          $('.chart-title').show();
          cardActions.css('opacity', 1);
        });
        ApiConnect.get(config.chart_data_url).then(function (data) {
          _this.drawCharts(data, settings, config);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
          $('.chart-title').show();
          cardActions.css('opacity', 1);
        });
      }
    }, {
      key: "drawCharts",
      value: function drawCharts(data, settings, config) {
        this.lineChart = new NS.Charts.LineChartScroll({
          "container-id": settings["charts"]["barChart"]["id"],
          "data": data["data"][settings["charts"]["barChart"]["dataName"]],
          "multidata": false,
          'show_legend': config['show_legend'],
          'y_value_decimals': 2
        });
      }
    }]);

    return DdosTrafficController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.DdosTrafficController = DdosTrafficController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var FeedController = /*#__PURE__*/function () {
    function FeedController(config) {
      _classCallCheck(this, FeedController);

      this.settings = {
        charts: {
          barCharts: {
            chartBarIPDNS: {
              id: "chartBarIPDNS",
              dataName: "chart_bar_ip_dns"
            },
            chartBarHoneypot: {
              id: "chartBarHoneypot",
              dataName: "chart_bar_honeypot"
            }
          },
          pieCharts: {
            chartPieIPDNS: {
              id: "chartPieIPDNS",
              dataName: "chart_pie_ip_dns"
            },
            chartPieHoneypot: {
              id: "chartPieHoneypot",
              dataName: "chart_pie_honeypot"
            }
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(FeedController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var div = _step.value;
            var closestCard = div.closest('.card');
            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var div = _step2.value;
              div.style.display = 'block';
              div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var ipDnsEl = document.getElementById('chartBarIPDNSTab');
        var ipDnsSpan = ipDnsEl.querySelector('span');
        var ipDnsDiv = ipDnsEl.querySelector('div');
        var honeypotEl = document.getElementById('chartBarHoneypotTab');
        var honeypotSpan = honeypotEl.querySelector('span');
        var honeypotDiv = honeypotEl.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var ipDnsValues = data.data.chart_bar_ip_dns.values; // noinspection JSUnresolvedVariable

          var honeypotValues = data.data.chart_bar_honeypot.values;

          if (ipDnsValues.length === 0) {
            ipDnsSpan.style.display = 'block';
          } else {
            ipDnsDiv.style.display = 'block';

            _this.drawIpDnsBarChart(data);
          }

          if (honeypotValues.length === 0) {
            honeypotSpan.style.display = 'block';
          } else {
            honeypotDiv.style.display = 'block';

            _this.drawHoneypotBarChart(data);
          }

          _this.drawPieCharts(data);

          _this.setCardHeaders(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(data) {
        var chartSettings = this.settings.charts;
        var barChartSettings = chartSettings.barCharts;
        var pieChartSettings = chartSettings.pieCharts;
        var barChartKeys = Object.keys(barChartSettings);
        var pieChartKeys = Object.keys(pieChartSettings);
        var firstBarChartSettings = barChartSettings[barChartKeys[0]];
        var firstBarChartId = firstBarChartSettings.id;
        var firstBarChartDataName = firstBarChartSettings.dataName;
        var firstBarChartTabId = firstBarChartId + 'Tab';
        var firstPieChartSettings = pieChartSettings[pieChartKeys[0]];
        var firstPieChartId = firstPieChartSettings.id;
        var firstPieChartDataName = firstPieChartSettings.dataName;
        var firstPieChartTabId = firstPieChartId + 'Tab'; //bar charts

        document.querySelectorAll('.bar-charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var firstBarChart = document.getElementById(firstBarChartId);
        var barChartsCard = firstBarChart.closest('.card');
        var barChartTitleEl = barChartsCard.querySelector('.chart-title');
        barChartTitleEl.textContent = data.data[firstBarChartDataName].name;
        var firstBarChartTab = document.getElementById(firstBarChartTabId);
        firstBarChartTab.classList.add('active');
        var barChartMenuEl = document.querySelector('.bar-chart-menu');

        if (barChartKeys.length > 1) {
          var _iterator6 = _createForOfIteratorHelper(barChartKeys),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var key = _step6.value;
              var chart = barChartSettings[key];
              barChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        } else {
          var barChartActionsEl = barChartMenuEl.closest('.actions');
          barChartActionsEl.parentNode.removeChild(barChartActionsEl);
        } //pie charts


        document.querySelectorAll('.pie-charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var firstPieChart = document.getElementById(firstPieChartId);
        var pieChartsCard = firstPieChart.closest('.card');
        var pieChartTitleEl = pieChartsCard.querySelector('.chart-title');
        pieChartTitleEl.textContent = data.data[firstPieChartDataName].name;
        var firstPieChartTab = document.getElementById(firstPieChartTabId);
        firstPieChartTab.classList.add('active');
        var pieChartMenuEl = document.querySelector('.pie-chart-menu');

        if (pieChartKeys.length > 1) {
          var _iterator7 = _createForOfIteratorHelper(pieChartKeys),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _key = _step7.value;
              var _chart = pieChartSettings[_key];
              pieChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + _chart.id + 'Tab" class="char-tab-toggle">' + data.data[_chart.dataName].name + '</a></li>');
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        } else {
          var pieChartActionsEl = pieChartMenuEl.closest('.actions');
          pieChartActionsEl.parentNode.removeChild(pieChartActionsEl);
        }

        this.bindChangeTabChart();
      }
    }, {
      key: "bindChangeTabChart",
      value: function bindChangeTabChart() {
        var chartTabToggles = document.querySelectorAll('.char-tab-toggle');

        var _iterator8 = _createForOfIteratorHelper(chartTabToggles),
            _step8;

        try {
          var _loop3 = function _loop3() {
            var toggle = _step8.value;
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              var target = document.getElementById(toggle.getAttribute('data-target-id'));

              if (target) {
                var otherTabs = Array.prototype.filter.call(target.parentNode.children, function (child) {
                  return child !== target;
                });

                var _iterator9 = _createForOfIteratorHelper(otherTabs),
                    _step9;

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var tab = _step9.value;
                    tab.classList.remove('active');
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                target.classList.add('active');
              }

              var cardHeader = toggle.closest('.card-header');
              var chartTitleEl = cardHeader.querySelector('h2');
              chartTitleEl.textContent = toggle.textContent;
            });
          };

          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }, {
      key: "drawIpDnsBarChart",
      value: function drawIpDnsBarChart(data) {
        this.chartBarIPDNS = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barCharts"]["chartBarIPDNS"]["id"],
          data: data["data"][this.settings["charts"]["barCharts"]["chartBarIPDNS"]["dataName"]],
          multidata: false,
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawHoneypotBarChart",
      value: function drawHoneypotBarChart(data) {
        this.chartBarHoneypot = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barCharts"]["chartBarHoneypot"]["id"],
          data: data["data"][this.settings["charts"]["barCharts"]["chartBarHoneypot"]["dataName"]],
          multidata: false,
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawPieCharts",
      value: function drawPieCharts(data) {
        this.chartPieIPDNS = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["chartPieIPDNS"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["chartPieIPDNS"]["dataName"]],
          show_legend: this.config['show_legend']
        });
        this.chartPieHoneypot = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["chartPieHoneypot"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["chartPieHoneypot"]["dataName"]],
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "Data",
            dataIndex: "date",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            isMovable: true
          }, {
            label: "Nazwa",
            dataIndex: "name",
            dataType: "text",
            isEditable: false,
            width: "*"
          }, {
            label: "Status pobrania",
            dataIndex: "download_status",
            dataType: "download_status",
            isEditable: false,
            width: "*"
          }, {
            label: "Data pobrania",
            dataIndex: "download_date",
            dataType: "text",
            isEditable: false
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "actions",
            isEditable: false,
            width: 150
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return FeedController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.FeedController = FeedController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var FeedPreviewController = /*#__PURE__*/function () {
    function FeedPreviewController(config) {
      _classCallCheck(this, FeedPreviewController);

      this.init(config);
    }

    _createClass(FeedPreviewController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGridIPDNS",
      value: function createGridIPDNS(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Czas zdarzenia",
            "dataIndex": "event_time",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "IP Malware'u",
            "dataIndex": "malware_ip",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "DNS Malware'u",
            "dataIndex": "malware_dns",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "Nazwa Malware'u",
            "dataIndex": "malware_name",
            "dataType": "text",
            "isEditable": false
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_ip_dns_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId1"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container-ip-dns',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {}
        });
      }
    }, {
      key: "createGridWebGatewayDNS",
      value: function createGridWebGatewayDNS(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Czas zdarzenia",
            "dataIndex": "event_time",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "IP Malware'u",
            "dataIndex": "malware_ip",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "DNS Malware'u",
            "dataIndex": "malware_dns",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "Nazwa Malware'u",
            "dataIndex": "malware_name",
            "dataType": "text",
            "isEditable": false
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_web_gateway_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId2"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container-web-gateway',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "pageSize": 20,
          'listeners': {}
        });
      }
    }, {
      key: "createGridHoneypot",
      value: function createGridHoneypot(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Czas zdarzenia",
            "dataIndex": "event_time",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "Państwo",
            "dataIndex": "country",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Źródłowy IP",
            "dataIndex": "source_ip",
            "dataType": "text",
            "isEditable": false
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_honeypot_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId3"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container-honeypot',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "pageSize": 20,
          'listeners': {}
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        this.createGridIPDNS(config);
        this.createGridWebGatewayDNS(config);
        this.createGridHoneypot(config);
      }
    }]);

    return FeedPreviewController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.FeedPreviewController = FeedPreviewController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var FireEyeController = /*#__PURE__*/function () {
    function FireEyeController(config) {
      _classCallCheck(this, FireEyeController);

      this.settings = {
        charts: {
          pieCharts: {
            alertsByImportance: {
              id: "summaryByImportance",
              dataName: "summary_by_importance"
            },
            alertsByType: {
              id: "summaryByType",
              dataName: "summary_by_type"
            },
            alertsByAction: {
              id: "summaryByAction",
              dataName: "summary_by_action"
            },
            alertsByMalware: {
              id: "summaryByMalware",
              dataName: "summary_by_malware"
            }
          },
          barChart: {
            dataName: "column_data",
            id: "threats"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(FireEyeController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _div2 = _step.value;

            var closestCard = _div2.closest('.card');

            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _div = _step2.value;
              _div.style.display = 'block';

              _div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var el = document.getElementById('charLinear1');
        var span = el.querySelector('span');
        var div = el.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var columnData = data.data.column_data;

          if (columnData.length === 0) {
            span.style.display = 'block';
          } else {
            div.style.display = 'block';

            _this.drawBarChart(data);
          }

          _this.drawPieCharts(data);

          _this.setCardHeaders(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(data) {
        var chartSettings = this.settings.charts;
        var pieChartSettings = chartSettings.pieCharts;
        var barChartId = chartSettings.barChart.id;
        var pieChartKeys = Object.keys(pieChartSettings);
        var firstPieChartSettings = pieChartSettings[pieChartKeys[0]];
        var firstPieChartId = firstPieChartSettings.id;
        var firstPieChartDataName = firstPieChartSettings.dataName;
        var firstPieChartTabId = firstPieChartId + 'Tab';
        var barChart = document.getElementById(barChartId);
        var barChartCard = barChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = this.config["bar_chart_title"];
        document.querySelectorAll('.pie-charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var firstPieChart = document.getElementById(firstPieChartId);
        var pieChartsCard = firstPieChart.closest('.card');
        var pieChartTitleEl = pieChartsCard.querySelector('.chart-title');
        pieChartTitleEl.textContent = data.data[firstPieChartDataName].name;
        var firstPieChartTab = document.getElementById(firstPieChartTabId);
        firstPieChartTab.classList.add('active');

        for (var _i = 0, _pieChartKeys = pieChartKeys; _i < _pieChartKeys.length; _i++) {
          var key = _pieChartKeys[_i];
          var chart = pieChartSettings[key];
          var pieChartMenuEl = document.querySelector('.pie-chart-menu');
          pieChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
        }

        this.bindChangeTabPieChart();
      }
    }, {
      key: "bindChangeTabPieChart",
      value: function bindChangeTabPieChart() {
        var chartTabToggles = document.querySelectorAll('.char-tab-toggle');

        var _iterator6 = _createForOfIteratorHelper(chartTabToggles),
            _step6;

        try {
          var _loop3 = function _loop3() {
            var toggle = _step6.value;
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              var target = document.getElementById(toggle.getAttribute('data-target-id'));

              if (target) {
                var otherTabs = Array.prototype.filter.call(target.parentNode.children, function (child) {
                  return child !== target;
                });

                var _iterator7 = _createForOfIteratorHelper(otherTabs),
                    _step7;

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var tab = _step7.value;
                    tab.classList.remove('active');
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                target.classList.add('active');
              }

              var cardHeader = toggle.closest('.card-header');
              var chartTitleEl = cardHeader.querySelector('h2');
              chartTitleEl.textContent = toggle.textContent;
            });
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "drawBarChart",
      value: function drawBarChart(data) {
        this.barChart = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barChart"]["id"],
          data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
          multidata: true,
          colors: {
            minr: this.settings["colors"]["low"],
            majr: this.settings["colors"]["medium"],
            crit: this.settings["colors"]["high"]
          },
          name_mapping: {
            minr: "Niski",
            majr: "Średni",
            crit: "Wysoki"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawPieCharts",
      value: function drawPieCharts(data) {
        this.summaryByImportanceChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByImportance"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByImportance"]["dataName"]],
          colors: {
            minr: this.settings["colors"]["low"],
            majr: this.settings["colors"]["medium"],
            crit: this.settings["colors"]["high"]
          },
          name_mapping: {
            minr: "Niski",
            majr: "Średni",
            crit: "Wysoki"
          },
          show_legend: this.config['show_legend']
        });
        this.summaryByTypeChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByType"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByType"]["dataName"]]
        });
        this.summaryByStatusAnalysisChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByAction"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByAction"]["dataName"]]
        });
        this.summaryByMalware = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByMalware"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByMalware"]["dataName"]]
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "ID",
            dataIndex: "id",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            isMovable: true
          }, {
            label: "Czas zdarzenia",
            dataIndex: "event_time",
            dataType: "text",
            isEditable: false,
            width: "*"
          }, {
            label: "Typ zdarzenia",
            dataIndex: "event_type",
            dataType: "text",
            isEditable: false
          }, {
            label: "Zagrożenie",
            dataIndex: "danger",
            dataType: "danger",
            isEditable: false
          }, {
            label: "Akcja",
            dataIndex: "action",
            dataType: "blocked",
            isEditable: false
          }, {
            label: "Adres źródłowy",
            dataIndex: "source_address",
            dataType: "text",
            isEditable: false
          }, {
            label: "Port źródłowy",
            dataIndex: "source_port",
            dataType: "text",
            isEditable: false
          }, {
            label: "Adres docelowy",
            dataIndex: "destination_address",
            dataType: "text",
            isEditable: false
          }, {
            label: "Port docelowy",
            dataIndex: "destination_port",
            dataType: "text",
            isEditable: false,
            width: 100
          }, {
            label: "Malware",
            dataIndex: "malware",
            dataType: "text",
            isEditable: false,
            width: 100
          }, {
            label: "VLAN",
            dataIndex: "vlan",
            dataType: "text",
            isEditable: false,
            width: 100
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "link",
            isEditable: false,
            width: 100
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return FireEyeController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.FireEyeController = FireEyeController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var FortifyController = /*#__PURE__*/function () {
    function FortifyController(config) {
      _classCallCheck(this, FortifyController);

      this.settings = {};
      this.init(config);
    }

    _createClass(FortifyController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data dodania",
            "dataIndex": "add_date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Nazwa skanu",
            "dataIndex": "scan_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Nazwa aplikacji",
            "dataIndex": "application_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Wersja aplikacji",
            "dataIndex": "application_version",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 140
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return FortifyController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.FortifyController = FortifyController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var FortifyPreviewController = /*#__PURE__*/function () {
    function FortifyPreviewController(config) {
      _classCallCheck(this, FortifyPreviewController);

      this.settings = {
        charts: {
          barChart: {
            chartVulnerabilitiesNumber: {
              id: "chartVulnerabilitiesNumber",
              dataName: "vulnerabilities_number"
            },
            chartAnalysisNumber: {
              id: "chartAnalysisNumber",
              dataName: "analysis_number"
            },
            chartCriticalityDistribution: {
              id: "chartCriticalityDistribution",
              dataName: "criticality_distribution"
            }
          },
          pieCharts: {
            chartCriticalityVulnerabilityDistribution: {
              id: "chartCriticalityVulnerabilityDistribution",
              dataName: "criticality_vulnerability_distribution"
            },
            chartCriticalityVulnerabilityAnalysis: {
              id: "chartCriticalityVulnerabilityAnalysis",
              dataName: "criticality_vulnerability_analysis"
            }
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51",
          color1: "124, 181, 236",
          color2: "67, 67, 72",
          color3: "144, 237, 125",
          color4: "247, 163, 92"
        }
      };
      this.init(config);
    }

    _createClass(FortifyPreviewController, [{
      key: "init",
      value: function init(config) {
        this.loadDataChart(config, this.settings);
        this.createGrid(config);
      }
    }, {
      key: "loadDataChart",
      value: function loadDataChart(config, settings) {
        var _this = this;

        var cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
        $(document).bind('ajaxStart', function () {
          $('.loading').show('fast');
          $('.chart-title').hide();
          cardActions.css('opacity', 0);
        }).bind('ajaxStop', function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
          $('.chart-title').show();
          cardActions.css('opacity', 1);
        });
        ApiConnect.get(config.chart_data_url).then(function (data) {
          _this.drawCharts(data, settings, config);

          _this.setCardHeaders(config, settings, data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          $('.loading').animate({
            opacity: 0
          }, function () {
            $(this).hide();
          });
          $('.chart-title').show();
          cardActions.css('opacity', 1);
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(config, settings, data) {
        $('#' + settings["charts"]["barChart"]["id"]).parents('.card').find('.chart-title').text(config["bar_chart_title"]);
        $('.pie-charts .char-tab').removeClass('active');
        var keys = Object.keys(settings["charts"]["pieCharts"]);
        $('#' + settings["charts"]["pieCharts"][keys[0]]["id"]).parents('.card').find('.chart-title').text(data["data"][settings["charts"]["pieCharts"][keys[0]]["dataName"]]["name"]);
        $('#' + settings["charts"]["pieCharts"][keys[0]]["id"] + 'Tab').addClass('active'); // noinspection JSUnusedLocalSymbols

        $.each(settings["charts"]["pieCharts"], function (index, val) {
          $('.pie-chart-menu').append('<li><a href="#' + settings["charts"]["pieCharts"][index]["id"] + 'Tab" class="char-tab-toggle">' + data["data"][settings["charts"]["pieCharts"][index]["dataName"]]["name"] + '</a></li>');
        });
        this.bindChangeTabPieChart();
      }
    }, {
      key: "bindChangeTabPieChart",
      value: function bindChangeTabPieChart() {
        $('.char-tab-toggle').on('click', function (e) {
          e.preventDefault();
          var $target = $($(this).attr('href'));

          if ($target.length) {
            $target.siblings().removeClass('active');
            $target.addClass('active');
          }

          $(this).closest('.card-header').find('h2').text($(this).text());
        });
      }
    }, {
      key: "drawCharts",
      value: function drawCharts(data, settings, config) {
        //wykresy belkowe
        //----------------------------------------
        this.chartVulnerabilitiesNumber = new NS.Charts.BarChart({
          "container-id": settings["charts"]["barChart"]["chartVulnerabilitiesNumber"]["id"],
          "data": data["data"][settings["charts"]["barChart"]["chartVulnerabilitiesNumber"]["dataName"]],
          "multidata": false,
          'show_legend': config['show_legend'],
          labelLength: 15
        });
        this.chartVulnerabilitiesNumber = new NS.Charts.BarChart({
          "container-id": settings["charts"]["barChart"]["chartAnalysisNumber"]["id"],
          "data": data["data"][settings["charts"]["barChart"]["chartAnalysisNumber"]["dataName"]],
          "multidata": true,
          'show_legend': config['show_legend'],
          labelLength: 15
        });
        this.chartCriticalityDistribution = new NS.Charts.BarChart({
          "container-id": settings["charts"]["barChart"]["chartCriticalityDistribution"]["id"],
          "data": data["data"][settings["charts"]["barChart"]["chartCriticalityDistribution"]["dataName"]],
          "multidata": true,
          "colors": {
            "low": settings["colors"]["low"],
            "medium": settings["colors"]["medium"],
            "high": settings["colors"]["high"]
          },
          "name_mapping": {
            "low": "Niski",
            "medium": "Średni",
            "high": "Wysoki"
          },
          'show_legend': config['show_legend'],
          labelLength: 15
        }); //wykresy pie
        //----------------------------------------

        this.chartCriticalityVulnerabilityAnalysis = new NS.Charts.PieChart({
          "container-id": settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityDistribution"]["id"],
          "data": data["data"][settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityDistribution"]["dataName"]],
          "colors": {
            "low": settings["colors"]["low"],
            "medium": settings["colors"]["medium"],
            "high": settings["colors"]["high"]
          },
          "name_mapping": {
            "low": "Niski",
            "medium": "Średni",
            "high": "Wysoki"
          },
          'show_legend': config['show_legend']
        });
        this.criticalityVulnerabilityDistributionChart = new NS.Charts.PieChart({
          "container-id": settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityAnalysis"]["id"],
          "data": data["data"][settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityAnalysis"]["dataName"]],
          'show_legend': config['show_legend']
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Kategoria podatności",
            "dataIndex": "category",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            width: '*'
          }, {
            "label": "Krytyczność podatności",
            "dataIndex": "criticality",
            "dataType": "importants",
            "isEditable": false
          }, {
            "label": "Analiza podatności",
            "dataIndex": "vulnerability_analysis",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "link",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 120
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return FortifyPreviewController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.FortifyPreviewController = FortifyPreviewController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var IpReputationController = /*#__PURE__*/function () {
    function IpReputationController(config) {
      _classCallCheck(this, IpReputationController);

      this.settings = {
        charts: {
          pieCharts: {
            infectionsStatusDistribution: {
              id: "infectionsStatusDistribution",
              dataName: "infections_status_distribution"
            }
          },
          barChart: {
            dataName: "column_data",
            id: "infectionStatus"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(IpReputationController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _div2 = _step.value;

            var closestCard = _div2.closest('.card');

            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _div = _step2.value;
              _div.style.display = 'block';

              _div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var el = document.getElementById('charLinear1');
        var span = el.querySelector('span');
        var div = el.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var columnData = data.data.column_data;

          if (columnData.length === 0) {
            span.style.display = 'block';
          } else {
            div.style.display = 'block';

            _this.drawBarChart(data);
          }

          _this.drawPieChart(data);

          _this.setCardHeaders(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(data) {
        var chartSettings = this.settings.charts;
        var pieChartSettings = chartSettings.pieCharts;
        var barChartId = chartSettings.barChart.id;
        var pieChartKeys = Object.keys(pieChartSettings);
        var firstPieChartSettings = pieChartSettings[pieChartKeys[0]];
        var firstPieChartId = firstPieChartSettings.id;
        var firstPieChartDataName = firstPieChartSettings.dataName;
        var firstPieChartTabId = firstPieChartId + 'Tab';
        var barChart = document.getElementById(barChartId);
        var barChartCard = barChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = this.config["bar_chart_title"];
        document.querySelectorAll('.pie-charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var firstPieChart = document.getElementById(firstPieChartId);
        var pieChartsCard = firstPieChart.closest('.card');
        var pieChartTitleEl = pieChartsCard.querySelector('.chart-title');
        pieChartTitleEl.textContent = data.data[firstPieChartDataName].name;
        var firstPieChartTab = document.getElementById(firstPieChartTabId);
        firstPieChartTab.classList.add('active');

        for (var _i = 0, _pieChartKeys = pieChartKeys; _i < _pieChartKeys.length; _i++) {
          var key = _pieChartKeys[_i];
          var chart = pieChartSettings[key];
          var pieChartMenuEl = document.querySelector('.pie-chart-menu');
          pieChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
        }

        this.bindChangeTabPieChart();
      }
    }, {
      key: "bindChangeTabPieChart",
      value: function bindChangeTabPieChart() {
        var chartTabToggles = document.querySelectorAll('.char-tab-toggle');

        var _iterator6 = _createForOfIteratorHelper(chartTabToggles),
            _step6;

        try {
          var _loop3 = function _loop3() {
            var toggle = _step6.value;
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              var target = document.getElementById(toggle.getAttribute('data-target-id'));

              if (target) {
                var otherTabs = Array.prototype.filter.call(target.parentNode.children, function (child) {
                  return child !== target;
                });

                var _iterator7 = _createForOfIteratorHelper(otherTabs),
                    _step7;

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var tab = _step7.value;
                    tab.classList.remove('active');
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                target.classList.add('active');
              }

              var cardHeader = toggle.closest('.card-header');
              var chartTitleEl = cardHeader.querySelector('h2');
              chartTitleEl.textContent = toggle.textContent;
            });
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "drawBarChart",
      value: function drawBarChart(data) {
        this.barChart = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barChart"]["id"],
          data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
          multidata: true,
          colors: {
            secure: this.settings["colors"]["low"],
            unknown: this.settings["colors"]["medium"],
            dangerous: this.settings["colors"]["high"]
          },
          name_mapping: {
            secure: "Bezpieczny",
            unknown: "Nieznany",
            dangerous: "Niebezpieczny"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawPieChart",
      value: function drawPieChart(data) {
        this.infectionsStatusDistribution = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["infectionsStatusDistribution"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["infectionsStatusDistribution"]["dataName"]],
          colors: {
            secure: this.settings["colors"]["low"],
            unknown: this.settings["colors"]["medium"],
            dangerous: this.settings["colors"]["high"]
          },
          name_mapping: {
            secure: "Bezpieczny",
            unknown: "Nieznany",
            dangerous: "Niebezpieczny"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "Data",
            dataIndex: "date",
            dataType: "text",
            isEditable: false,
            width: "*"
          }, {
            label: "Bezpieczne",
            dataIndex: "secure",
            dataType: "text",
            isEditable: false
          }, {
            label: "Nieznane",
            dataIndex: "unknown",
            dataType: "text",
            isEditable: false
          }, {
            label: "Niebezpieczne",
            dataIndex: "dangerous",
            dataType: "text",
            isEditable: false
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return IpReputationController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.IPReputationController = IpReputationController || {};
})(window);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function (global) {
  var InputElement = /*#__PURE__*/function (_HTMLDivElement) {
    _inherits(InputElement, _HTMLDivElement);

    var _super = _createSuper(InputElement);

    function InputElement(label, value) {
      var _this;

      _classCallCheck(this, InputElement);

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this._label = label;
      _this.input = document.createElement('input');
      _this.input.value = value;

      _this.input.setAttribute('id', "some_funny_input_id_".concat(InputElement.lastId++));

      _this.input.classList.add('input-sm', 'form-control', 'fg-input');

      _this.input.style.minWidth = '350px'; // noinspection JSUnusedLocalSymbols

      _this.input.addEventListener('focus', function (e) {
        _this.input.parentElement.classList.add('fg-toggled');
      }); // noinspection JSUnusedLocalSymbols


      _this.input.addEventListener('blur', function (e) {
        if (!_this.input.value || !_this.input.value.length) {
          _this.input.parentElement.classList.remove('fg-toggled');
        }
      });

      return _this;
    }

    _createClass(InputElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.classList.add('form-group', 'fg-float', 'm-b-5');
        this.style.setProperty('margin-bottom', '30px', 'important');
        var div = document.createElement('div');
        div.classList.add('fg-line');

        if (this.input.value && this.input.value.length) {
          div.classList.add('fg-toggled');
        }

        div.appendChild(this.input);
        this.appendChild(div);
        var label = document.createElement('label');
        label.classList.add('fg-label');
        label.setAttribute('for', this.input.getAttribute('id'));
        label.innerText = this._label;
        this.appendChild(label);
        delete this._label;
      }
    }, {
      key: "value",
      get: function get() {
        return this.input.value;
      }
    }, {
      key: "disabled",
      set: function set(val) {
        if (val) this.input.setAttribute('disabled', 'disabled');else this.input.removeAttribute('disabled');
      }
    }]);

    return InputElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  _defineProperty(InputElement, "lastId", 1);

  var EditFormElement = /*#__PURE__*/function (_HTMLDivElement2) {
    _inherits(EditFormElement, _HTMLDivElement2);

    var _super2 = _createSuper(EditFormElement);

    function EditFormElement(mo) {
      var _this2;

      _classCallCheck(this, EditFormElement);

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this].concat(args));
      _this2.mo = mo;
      return _this2;
    }

    _createClass(EditFormElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.appendChild(new InputElement('Firma', this.mo.companyName || '-')).disabled = true;
        this.appendChild(new InputElement('Obiekt nadrzędny', (this.mo.parent || {}).name || '-')).disabled = true;
        this.appendChild(new InputElement('Nazwa', this.mo.name || '-')).disabled = true;
        this.appendChild(this.input = new InputElement('Nazwa wyświetlana', this.mo.displayName || ''));
      }
    }, {
      key: "value",
      get: function get() {
        return {
          label: this.input.value
        };
      }
    }]);

    return EditFormElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var ManagedObject = /*#__PURE__*/function () {
    function ManagedObject(id, name, displayName, companyName, children, parent) {
      _classCallCheck(this, ManagedObject);

      this._id = id;
      this._name = name;
      this._displayName = displayName;
      this._companyName = companyName;
      this._children = children;
      this._parent = parent;
    }

    _createClass(ManagedObject, [{
      key: "id",
      get: function get() {
        return this._id;
      }
    }, {
      key: "name",
      get: function get() {
        return this._name;
      }
    }, {
      key: "displayName",
      get: function get() {
        return this._displayName;
      },
      set: function set(name) {
        this._displayName = name;
      }
    }, {
      key: "companyName",
      get: function get() {
        return this._companyName;
      }
    }, {
      key: "children",
      get: function get() {
        return this._children;
      }
    }, {
      key: "parent",
      get: function get() {
        return this._parent;
      }
    }]);

    return ManagedObject;
  }();

  var RowElement = /*#__PURE__*/function (_HTMLLIElement) {
    _inherits(RowElement, _HTMLLIElement);

    var _super3 = _createSuper(RowElement);

    function RowElement(mo) {
      var _this3;

      _classCallCheck(this, RowElement);

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      _this3 = _super3.call.apply(_super3, [this].concat(args));
      _this3.mo = mo || {};
      return _this3;
    }

    _createClass(RowElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this4 = this;

        var div = document.createElement('div');
        div.classList.add('checkbox');
        var label = document.createElement('label');
        var input = this.input = document.createElement('input');
        input.setAttribute('type', 'checkbox');
        input.setAttribute('name', "managed_object_".concat(this.mo.id));
        input.setAttribute('data-mo', this.mo.id);
        input.addEventListener('change', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (_this4.checkable) {
            var _iterator = _createForOfIteratorHelper(_this4.inputs),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _input = _step.value;
                // noinspection JSUnresolvedVariable
                _input.checked = e.target.checked;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            var checked = false;

            var _iterator2 = _createForOfIteratorHelper(_this4.inputs),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _input2 = _step2.value;

                if (!_input2.checked) {
                  checked = true;
                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            var _iterator3 = _createForOfIteratorHelper(_this4.inputs),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _input3 = _step3.value;
                _input3.checked = checked;
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            e.target.checked = false;
          }

          _this4.dispatchEvent(createEvent('change', input.checked));
        });

        if (this.mo.companyName && this.mo.children && this.mo.children.length && !this.mo.children.filter(function (child) {
          return !child.companyName;
        }).length) {
          input.setAttribute('disabled', 'disabled');
        }

        if (this.mo.companyName && (!this.mo.children || !this.mo.children.length)) {
          input.setAttribute('disabled', 'disabled');
        }

        var i = document.createElement('i');
        i.classList.add('input-helper');
        var txt = this.textNode = document.createTextNode(this.label);
        var button = document.createElement('a');
        button.innerText = 'Edytuj';
        button.style.marginLeft = '10px';
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _this4.onEdit();
        });
        label.appendChild(input);
        label.appendChild(i);
        label.appendChild(txt);
        label.appendChild(button);
        div.appendChild(label);
        this.appendChild(div);

        if (this.mo.children && this.mo.children.length) {
          var ul = document.createElement('ul');

          var _iterator4 = _createForOfIteratorHelper(this.mo.children),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var child = _step4.value;
              ul.appendChild(new RowElement(child)).addEventListener('change', function (e) {
                e.preventDefault();
                e.stopPropagation(); // noinspection JSUnresolvedVariable

                _this4.onChildChange(e.target.input);
              });
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          this.appendChild(ul);
        }
      }
    }, {
      key: "remove",
      value: function remove() {
        var _this5 = this;

        if (!this.parentElement) {
          return;
        }

        this.style.transition = 'none';
        this.style.height = "".concat(this.scrollHeight, "px");
        this.style.overflow = 'hidden';
        this.style.transition = '300ms';
        setTimeout(function () {
          _this5.style.height = '0';
          setTimeout(function () {
            _get(_getPrototypeOf(RowElement.prototype), "remove", _this5).call(_this5);
          }, 300);
        });
      }
    }, {
      key: "onChildChange",
      value: function onChildChange(target) {
        if (this.checkable) {
          var checked = true;

          if (!target.checked) {
            checked = false;
          } else {
            var _iterator5 = _createForOfIteratorHelper(this.inputs),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var input = _step5.value;

                if (!input.checked) {
                  checked = false;
                  break;
                }
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }

          if (!checked) {
            this.input.checked = checked;
          }
        }

        this.dispatchEvent(createEvent('change'));
      }
    }, {
      key: "onEdit",
      value: function onEdit() {
        var _this6 = this;

        var form = new EditFormElement(this.mo);
        var popup = new HTMLElements.PopupElement();
        popup.header = 'Edycja';
        popup.content = form;
        var closeBtn = popup.addButton('Zamknij', function () {
          return popup.hide();
        });
        var saveBtn = popup.addButton('Zapisz', function () {
          saveBtn.setAttribute('disabled', 'disabled');
          closeBtn.setAttribute('disabled', 'disabled');
          popup.closeable = false;
          ApiConnect.put("/operator/managed-object/".concat(_this6.mo.id), form.value).then(function (response) {
            if (!response.status || response.status !== 'success') throw new Error(response.message || 'Wystąpił błąd podczas zapisu.');
          }).then(function () {
            console.log('ok');
            _this6.mo.displayName = form.value.label;

            _this6.relabel();

            popup.hide();
          })["catch"](function (err) {
            console.log('error', err);
            popup.content = err.message;
            popup.closeable = true;
            saveBtn.remove();
            closeBtn.removeAttribute('disabled');
          });
        });
        popup.show();
      }
    }, {
      key: "relabel",
      value: function relabel() {
        this.textNode.textContent = this.label;
      }
    }, {
      key: "label",
      get: function get() {
        var label = this.mo.name;

        if (this.mo.displayName || this.mo.companyName) {
          var parts = [];

          if (this.mo.companyName) {
            parts.push("firma: ".concat(this.mo.companyName));
          }

          if (this.mo.displayName) {
            parts.push("nazwa wy\u015Bwietlana: ".concat(this.mo.displayName));
          }

          label += " (".concat(parts.join(', '), ")");
        }

        return label;
      }
    }, {
      key: "checkable",
      get: function get() {
        if (typeof this._checkable === 'boolean') {
          return this._checkable;
        }

        var _iterator6 = _createForOfIteratorHelper(this.mo.children || []),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var child = _step6.value;

            if (child.companyName) {
              return this._checkable = false;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        return this._checkable = true;
      }
    }, {
      key: "inputs",
      get: function get() {
        if (!this._inputs) {
          this._inputs = [];

          var _iterator7 = _createForOfIteratorHelper(this.mo.children || []),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var child = _step7.value;

              if (!child.companyName) {
                this._inputs.push(this.querySelector("input[name=\"managed_object_".concat(child.id, "\"]")));
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }

        return this._inputs;
      }
    }]);

    return RowElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLLIElement));

  var ManagedObjectsController = /*#__PURE__*/function () {
    function ManagedObjectsController(options) {
      var _this7 = this;

      _classCallCheck(this, ManagedObjectsController);

      this.container = document.getElementById('list-container');
      this.container.appendChild(this.loadingBox = document.createElement('li'));
      this.deleteButton = document.getElementById('delete-button');
      this.deleteButton.setAttribute('disabled', 'disabled');
      this.deleteButton.addEventListener('click', function (e) {
        e.preventDefault();

        _this7.onDeleteRequest(_this7.selected.map(function (row) {
          return row.mo.id;
        }));
      });
      this.loadingBox.innerText = 'Trwa wczytywanie danych...';
      this.loadingBox.style.textAlign = 'center';
      this.loadingBox.style.paddingBottom = this.loadingBox.style.paddingTop = '15px';
      this.loadingBox.style.height = "".concat(this.loadingBox.scrollHeight, "px");
      this.loadingBox.style.transition = '300ms';
      this.load(options.loadUrl);
    }

    _createClass(ManagedObjectsController, [{
      key: "load",
      value: function load(url) {
        var _this8 = this;

        ApiConnect.get(url).then(function (data) {
          return data.map(function (obj) {
            return _this8.toManagedObject(obj);
          });
        }).then(function (mos) {
          _this8.loadingBox.style.height = '0';
          setTimeout(function () {
            _this8.loadingBox.remove();

            var _iterator8 = _createForOfIteratorHelper(mos),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var mo = _step8.value;

                var row = _this8.container.appendChild(new RowElement(mo));

                row.addEventListener('change', function (e) {
                  return _this8.onChange(e);
                });
                row.style.height = '0';
                row.style.overflow = 'hidden';
                row.style.transition = '600ms';
                row.style.height = "".concat(row.scrollHeight, "px");
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }, 350);
        })["catch"](function (err) {
          console.error(err);
          _this8.loadingBox.innerText = 'Wystąpił błąd podczas wczytywania danych.';
        });
      }
    }, {
      key: "onChange",
      value: function onChange(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.selected.length) {
          this.deleteButton.removeAttribute('disabled');
        } else {
          this.deleteButton.setAttribute('disabled', 'disabled');
        }
      }
    }, {
      key: "onDeleteRequest",
      value: function onDeleteRequest(ids) {
        var popup = new HTMLElements.PopupElement();
        popup.header = 'To dzieje się naprawdę!';
        popup.content = "W kolejnym kroku usuniemy".concat(ids.length > 2 ? ' aż' : '', " ").concat(ids.length, " ").concat(ids.length === 1 ? 'obiekt ' + 'chroniony' : ids.length % 10 > 1 && ids.length % 10 < 5 && ids.length % 100 / 10 !== 1 ? 'obiekty chronione' : 'obiektów chronionych', ".\n\nCzy jest to Twoja ostateczna decyzja?");
        var no = popup.addButton('Nie', function () {
          return popup.hide();
        });
        var btn = popup.addButton('Tak', function () {
          btn.disabled = true;
          ApiConnect["delete"]('/operator/managed-object', {
            ids: ids
          }).then(function (response) {
            if (!response.status || response.status !== 'success') throw new Error(response.message || 'Wystąpił błąd podczas usuwania rekordów.');
          }).then(function () {
            var _iterator9 = _createForOfIteratorHelper(ids),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var id = _step9.value;
                var input = document.querySelector("input[name=\"managed_object_".concat(id, "\"]"));

                if (input) {
                  input.closest('li, mo-row').remove();
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }

            popup.hide();
          })["catch"](function (err) {
            popup.header = '';
            popup.content = err.message;
            btn.remove();
            no.innerText = 'Zamknij';
          });
        });
        popup.show();
      }
    }, {
      key: "toManagedObject",
      value: function toManagedObject(data, parent) {
        var children = [];
        var result = new ManagedObject(data.id, data.name, data.label, data.companyName, children, parent);

        if (data.children && data.children.length) {
          var _iterator10 = _createForOfIteratorHelper(data.children),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var child = _step10.value;
              children.push(this.toManagedObject(child, result));
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        }

        return result;
      }
    }, {
      key: "selected",
      get: function get() {
        var inputs = Array.from(document.querySelectorAll('input[name^="managed_object_"]')).filter(function (input) {
          return input.checked;
        });
        var results = [];

        var _iterator11 = _createForOfIteratorHelper(inputs),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var input = _step11.value;
            results.push(input.closest('li, mo-row'));
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }

        return results;
      }
    }]);

    return ManagedObjectsController;
  }();

  customElements.define('mo-row', RowElement, {
    "extends": 'li'
  });
  customElements.define('mo-edit-form', EditFormElement, {
    "extends": 'div'
  });
  customElements.define('mo-input', InputElement, {
    "extends": 'div'
  }); //wyeksportowanie klasy

  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.ManagedObjectsController = ManagedObjectsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var MarketingTabsController = /*#__PURE__*/function () {
    function MarketingTabsController(config) {
      _classCallCheck(this, MarketingTabsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "grind-container"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(MarketingTabsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Zakładka",
            "dataIndex": "overlap",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": "100"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return MarketingTabsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.MarketingTabsController = MarketingTabsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var MitigationReportsController = /*#__PURE__*/function () {
    function MitigationReportsController(config) {
      _classCallCheck(this, MitigationReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "grind-container"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(MitigationReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Nazwa alertu",
            "dataIndex": "alert_name",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Status raportu",
            "dataIndex": "report_status",
            "dataType": "reports",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 300
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return MitigationReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.MitigationReportsController = MitigationReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var MonthlyReportsController = /*#__PURE__*/function () {
    function MonthlyReportsController(config) {
      _classCallCheck(this, MonthlyReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "grind-container"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(MonthlyReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Status raportu",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 180
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return MonthlyReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.MonthlyReportsController = MonthlyReportsController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var PaloAltoController = /*#__PURE__*/function () {
    function PaloAltoController(config) {
      _classCallCheck(this, PaloAltoController);

      this.settings = {
        charts: {
          pieCharts: {
            alertsByFileType: {
              id: "summaryByFileType",
              dataName: "summary_by_file_type"
            },
            alertsByHarmfulnessSample: {
              id: "summaryByHarmfulnessSample",
              dataName: "summary_by_harmfulness_sample"
            },
            alertsByStatusAnalysis: {
              id: "summaryByStatusAnalysis",
              dataName: "summary_by_status_analysis"
            }
          },
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(PaloAltoController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _div2 = _step.value;

            var closestCard = _div2.closest('.card');

            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _div = _step2.value;
              _div.style.display = 'block';

              _div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var el = document.getElementById('charLinear1');
        var span = el.querySelector('span');
        var div = el.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var values = data.data.column_data.values;

          if (Object.keys(values).length === 0 && values.constructor === Object) {
            span.style.display = 'block';
          } else {
            div.style.display = 'block';

            _this.drawBarChart(data);
          }

          _this.drawPieCharts(data);

          _this.setCardHeaders(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(data) {
        var chartSettings = this.settings.charts;
        var pieChartSettings = chartSettings.pieCharts;
        var barChartId = chartSettings.barChart.id;
        var pieChartKeys = Object.keys(pieChartSettings);
        var firstPieChartSettings = pieChartSettings[pieChartKeys[0]];
        var firstPieChartId = firstPieChartSettings.id;
        var firstPieChartDataName = firstPieChartSettings.dataName;
        var firstPieChartTabId = firstPieChartId + 'Tab';
        var barChart = document.getElementById(barChartId);
        var barChartCard = barChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = this.config["bar_chart_title"];
        document.querySelectorAll('.pie-charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var firstPieChart = document.getElementById(firstPieChartId);
        var pieChartsCard = firstPieChart.closest('.card');
        var pieChartTitleEl = pieChartsCard.querySelector('.chart-title');
        pieChartTitleEl.textContent = data.data[firstPieChartDataName].name;
        var firstPieChartTab = document.getElementById(firstPieChartTabId);
        firstPieChartTab.classList.add('active');

        for (var _i = 0, _pieChartKeys = pieChartKeys; _i < _pieChartKeys.length; _i++) {
          var key = _pieChartKeys[_i];
          var chart = pieChartSettings[key];
          var pieChartMenuEl = document.querySelector('.pie-chart-menu');
          pieChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
        }

        this.bindChangeTabPieChart();
      }
    }, {
      key: "bindChangeTabPieChart",
      value: function bindChangeTabPieChart() {
        var chartTabToggles = document.querySelectorAll('.char-tab-toggle');

        var _iterator6 = _createForOfIteratorHelper(chartTabToggles),
            _step6;

        try {
          var _loop3 = function _loop3() {
            var toggle = _step6.value;
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              var target = document.getElementById(toggle.getAttribute('data-target-id'));

              if (target) {
                var otherTabs = Array.prototype.filter.call(target.parentNode.children, function (child) {
                  return child !== target;
                });

                var _iterator7 = _createForOfIteratorHelper(otherTabs),
                    _step7;

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var tab = _step7.value;
                    tab.classList.remove('active');
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                target.classList.add('active');
              }

              var cardHeader = toggle.closest('.card-header');
              var chartTitleEl = cardHeader.querySelector('h2');
              chartTitleEl.textContent = toggle.textContent;
            });
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "drawBarChart",
      value: function drawBarChart(data) {
        this.barChart = new NS.Charts.BarChart({
          "container-id": "alarms",
          data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
          multidata: false,
          name_mapping: {
            val: "Dane"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawPieCharts",
      value: function drawPieCharts(data) {
        this.summaryByImportanceChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByHarmfulnessSample"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByHarmfulnessSample"]["dataName"]],
          show_legend: this.config['show_legend']
        });
        this.summaryByTypeChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByFileType"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByFileType"]["dataName"]],
          show_legend: this.config['show_legend']
        });
        this.summaryByStatusAnalysisChart = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["alertsByStatusAnalysis"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["alertsByStatusAnalysis"]["dataName"]],
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "Czas utworzenia próbki",
            dataIndex: "create_time",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            isMovable: true
          }, {
            label: "IP FW klienta",
            dataIndex: "client_ip",
            dataType: "text",
            isEditable: false,
            width: "*"
          }, {
            label: "Model FW klienta",
            dataIndex: "client_model",
            dataType: "text",
            isEditable: false
          }, {
            label: "Nazwa pliku",
            dataIndex: "file_name",
            dataType: "text",
            isEditable: false
          }, {
            label: "Typ pliku",
            dataIndex: "file_type",
            dataType: "text",
            isEditable: false
          }, {
            label: "Rozmiar pliku ",
            dataIndex: "file_size",
            dataType: "text",
            isEditable: false
          }, {
            label: "Próbka złośliwa",
            dataIndex: "malicious_sample",
            dataType: "text",
            isEditable: false
          }, {
            label: "Status ",
            dataIndex: "status",
            dataType: "text",
            isEditable: false
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "link",
            isEditable: false,
            width: 100
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return PaloAltoController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.PaloAltoController = PaloAltoController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var SecureCodeSecurityAuditAdminController = /*#__PURE__*/function () {
    function SecureCodeSecurityAuditAdminController(config) {
      _classCallCheck(this, SecureCodeSecurityAuditAdminController);

      this.settings = {};
      this.init(config);
    }

    _createClass(SecureCodeSecurityAuditAdminController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data dodania",
            "dataIndex": "add_date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Nazwa aplikacji",
            "dataIndex": "application_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Wersja aplikacji",
            "dataIndex": "application_version",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Plik PDF",
            "dataIndex": "file_pdf",
            "dataType": "link",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Plik XML",
            "dataIndex": "file_xml",
            "dataType": "link",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 120
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return SecureCodeSecurityAuditAdminController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.SecureCodeSecurityAuditAdminController = SecureCodeSecurityAuditAdminController || {};
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (_e) { function e(_x) { return _e.apply(this, arguments); } e.toString = function () { return _e.toString(); }; return e; }(function (e) { throw e; }), f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function (_e2) { function e(_x2) { return _e2.apply(this, arguments); } e.toString = function () { return _e2.toString(); }; return e; }(function (e) { didErr = true; err = e; }), f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (global) {
  /////////////// SPCell ///////////////
  var SPCell = /*#__PURE__*/function (_HTMLTableCellElement) {
    _inherits(SPCell, _HTMLTableCellElement);

    var _super = _createSuper(SPCell);

    function SPCell(value) {
      var _this;

      _classCallCheck(this, SPCell);

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.initialValue = value;
      return _this;
    }

    _createClass(SPCell, [{
      key: "connectedCallback",
      value: function connectedCallback() {// do nothing
      }
    }, {
      key: "detectChanges",
      value: function detectChanges() {
        if (!this.input) return;

        if (this.input.value !== this.initialValue) {
          this.classList.add('changed');
        } else {
          this.classList.remove('changed');
        }
      }
    }, {
      key: "clearChanges",
      value: function clearChanges() {
        if (!this.input) return;
        this.input.value = this.initialValue;
        this.detectChanges();
      }
    }, {
      key: "value",
      get: function get() {
        return this.input ? this.input.value || '' : '';
      }
    }, {
      key: "editable",
      set: function set(value) {
        if (this.input) {
          if (value) {
            this.input.removeAttribute('readonly');
          } else {
            this.input.setAttribute('readonly', 'readonly');
          }
        }
      }
    }]);

    return SPCell;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLTableCellElement)); /////////////// SPInput ///////////////


  var SPInput = /*#__PURE__*/function (_SPCell) {
    _inherits(SPInput, _SPCell);

    var _super2 = _createSuper(SPInput);

    function SPInput(value) {
      var _this2;

      _classCallCheck(this, SPInput);

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this, value || ''].concat(args));
      _this2.input = document.createElement('input');
      _this2.span = document.createElement('span');
      _this2.input.value = _this2.initialValue;
      _this2.span.style.paddingLeft = '2px';
      return _this2;
    }

    _createClass(SPInput, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this3 = this;

        _get(_getPrototypeOf(SPInput.prototype), "connectedCallback", this).call(this);

        if (!this.span.parentElement) {
          this.appendChild(this.input);
        }

        this.input.setAttribute('type', 'text');
        this.input.setAttribute('autocomplete', 'off');
        this.input.addEventListener('input', function (e) {
          e.stopPropagation();

          _this3.detectChanges();

          _this3.parentElement.dispatchEvent(createEvent('change'));
        });
      }
    }, {
      key: "editable",
      set: function set(editable) {
        this.input.remove();
        this.span.remove();

        if (editable) {
          this.appendChild(this.input);
        } else {
          this.appendChild(this.span).innerText = this.input.value;
        }
      }
    }]);

    return SPInput;
  }(SPCell); ///////////////SPTextInput ///////////////


  var SPTextInput = /*#__PURE__*/function (_SPCell2) {
    _inherits(SPTextInput, _SPCell2);

    var _super3 = _createSuper(SPTextInput);

    function SPTextInput(value) {
      var _this4;

      _classCallCheck(this, SPTextInput);

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      _this4 = _super3.call.apply(_super3, [this, value || ''].concat(args));
      _this4.input = document.createElement('textarea');
      _this4.div = document.createElement('div');
      _this4.input.value = _this4.initialValue;
      _this4.div.style.overflowY = 'auto';

      _this4.div.style.setProperty('overflow-wrap', 'break-word');

      _this4.div.style.setProperty('word-wrap', 'break-word');

      _this4.div.style.setProperty('hyphens', 'auto');

      _this4.div.style.width = "200px";
      _this4.div.style.height = "60px";
      _this4.div.style.paddingLeft = '2px';
      return _this4;
    }

    _createClass(SPTextInput, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this5 = this;

        _get(_getPrototypeOf(SPTextInput.prototype), "connectedCallback", this).call(this);

        if (!this.div.parentElement) {
          this.appendChild(this.input);
        }

        this.input.addEventListener('input', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _this5.detectChanges();

          _this5.parentElement.dispatchEvent(createEvent('change'));
        });
      }
    }, {
      key: "editable",
      set: function set(editable) {
        this.input.remove();
        this.div.remove();

        if (editable) {
          this.appendChild(this.input);
        } else {
          this.appendChild(this.div).innerText = this.input.value;
        }
      }
    }]);

    return SPTextInput;
  }(SPCell); /////////////// SPArrayInput ///////////////


  var SPArrayInput = /*#__PURE__*/function (_SPCell3) {
    _inherits(SPArrayInput, _SPCell3);

    var _super4 = _createSuper(SPArrayInput);

    function SPArrayInput(value) {
      var _this6;

      _classCallCheck(this, SPArrayInput);

      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      _this6 = _super4.call.apply(_super4, [this, (value || []).join("\n")].concat(args));
      _this6.input = document.createElement('textarea');
      _this6.div = document.createElement('div');
      _this6.input.value = _this6.initialValue;
      _this6.div.style.overflowY = 'auto';

      _this6.div.style.setProperty('overflow-wrap', 'break-word');

      _this6.div.style.setProperty('word-wrap', 'break-word');

      _this6.div.style.setProperty('hyphens', 'auto');

      _this6.div.style.width = "200px";
      _this6.div.style.height = "60px";
      _this6.div.style.paddingLeft = '2px';
      return _this6;
    }

    _createClass(SPArrayInput, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this7 = this;

        _get(_getPrototypeOf(SPArrayInput.prototype), "connectedCallback", this).call(this);

        if (!this.div.parentElement) {
          this.appendChild(this.input);
        }

        this.input.addEventListener('input', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _this7.detectChanges();

          _this7.parentElement.dispatchEvent(createEvent('change'));
        });
      }
    }, {
      key: "editable",
      set: function set(editable) {
        this.input.remove();
        this.div.remove();

        if (editable) {
          this.appendChild(this.input);
        } else {
          this.appendChild(this.div).innerText = this.input.value;
        }
      }
    }, {
      key: "value",
      get: function get() {
        var lines = this.input.value.split(/\r?\n/);
        return lines.map(function (v) {
          return v.trim();
        }).filter(function (v) {
          return v !== '' && v.length;
        });
      }
    }]);

    return SPArrayInput;
  }(SPCell); /////////////// SPRow ///////////////


  var SPRow = /*#__PURE__*/function (_HTMLTableRowElement) {
    _inherits(SPRow, _HTMLTableRowElement);

    var _super5 = _createSuper(SPRow);

    function SPRow(row) {
      var _this8;

      _classCallCheck(this, SPRow);

      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      _this8 = _super5.call.apply(_super5, [this].concat(args));
      _this8._changes = undefined;
      _this8._deleted = false;
      _this8.refreshSubject = new rxjs.Subject();
      _this8.onrefresh$ = _this8.refreshSubject.asObservable();
      _this8.id = row.id || -1;
      _this8._editable = false;
      _this8.index = document.createElement('td');
      _this8.reactionTime = document.createElement('td');
      _this8.mitigationTime = document.createElement('td');
      _this8.ticketNumber = new SPInput(row.ticket_number);
      _this8.reportedAt = new SPInput(row.reported_at);
      _this8.phishingUrls = new SPArrayInput(row.phishing_urls);
      _this8.phishingDomains = new SPArrayInput(row.phishing_domains);
      _this8.phishingIps = new SPArrayInput(row.phishing_ips);
      _this8.reactedAt = new SPInput(row.reacted_at);
      _this8.blockedDomains = new SPArrayInput(row.blocked_domains);
      _this8.blockedIps = new SPArrayInput(row.blocked_ips);
      _this8.blockedAt = new SPInput(row.blocked_at);
      _this8.remarks = new SPTextInput(row.remarks);
      _this8.editable = _this8.id < 1;
      return _this8;
    }

    _createClass(SPRow, [{
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.release();
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this9 = this;

        this.appendChild(this.index);
        this.appendChild(this.ticketNumber);
        this.appendChild(this.reportedAt);
        this.appendChild(this.phishingUrls);
        this.appendChild(this.phishingDomains);
        this.appendChild(this.phishingIps);
        this.appendChild(this.reactedAt);
        this.appendChild(this.reactionTime);
        this.appendChild(this.blockedDomains);
        this.appendChild(this.blockedIps);
        this.appendChild(this.blockedAt);
        this.appendChild(this.mitigationTime);
        this.appendChild(this.remarks);
        this.addEventListener('change', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _this9.calculateTimes();

          _this9.calculateChanges();

          _this9.refreshSubject.next({
            id: _this9.id,
            changes: _this9.changes
          });
        });
        setTimeout(function () {
          _this9.calculateTimes();
        });
      }
    }, {
      key: "release",
      value: function release() {
        this.refreshSubject.complete();
      }
    }, {
      key: "clearChanges",
      value: function clearChanges() {
        for (var _i = 0, _Array$from = Array.from(this.childNodes); _i < _Array$from.length; _i++) {
          var child = _Array$from[_i];

          if (child instanceof SPCell) {
            child.clearChanges();
          }
        }

        this.calculateChanges();
        this.calculateTimes();
        this.refreshSubject.next({
          id: this.id,
          changes: this.changes
        });
      }
    }, {
      key: "remove",
      value: function remove() {
        var container = this.parentElement;
        this._deleted = true;

        if (this.id > 0) {
          this.style.display = 'none';
        } else {
          _get(_getPrototypeOf(SPRow.prototype), "remove", this).call(this);
        } // this.release();


        container.dispatchEvent(createEvent('row-removed'));
      }
    }, {
      key: "reindex",
      value: function reindex(index) {
        this.index.innerText = index;
      }
    }, {
      key: "getReactionTime",
      value: function getReactionTime() {
        return this.reactionTimeValue;
      }
    }, {
      key: "getMitigationTime",
      value: function getMitigationTime() {
        return this.mitigationTimeValue;
      }
    }, {
      key: "getPhishingUrls",
      value: function getPhishingUrls() {
        return this.phishingUrls.value;
      }
    }, {
      key: "getPhishingDomains",
      value: function getPhishingDomains() {
        return this.phishingDomains.value;
      }
    }, {
      key: "getPhishingIps",
      value: function getPhishingIps() {
        return this.phishingIps.value;
      }
    }, {
      key: "getBlockedDomains",
      value: function getBlockedDomains() {
        return this.blockedDomains.value;
      }
    }, {
      key: "getBlockedIps",
      value: function getBlockedIps() {
        return this.blockedIps.value;
      }
    }, {
      key: "calculateTimes",
      value: function calculateTimes() {
        var reported_at = new Date(this.reportedAt.value.replace(' ', 'T'));
        var reacted_at = new Date(this.reactedAt.value.replace(' ', 'T'));
        var blocked_at = new Date(this.blockedAt.value.replace(' ', 'T'));

        if (Number.isNaN(reported_at.getTime()) || Number.isNaN(reacted_at.getTime())) {
          this.reactionTime.innerText = '-';
          delete this.reactionTimeValue;
        } else {
          var diff = Math.ceil((reacted_at.getTime() - reported_at.getTime()) / 1000 / 60); // w minutach

          this.reactionTime.innerText = diff.toTime();
          this.reactionTimeValue = diff;
        }

        if (Number.isNaN(reported_at.getTime()) || Number.isNaN(blocked_at.getTime())) {
          this.mitigationTime.innerText = '-';
          delete this.mitigationTimeValue;
        } else {
          var diff2 = Math.ceil((blocked_at.getTime() - reported_at.getTime()) / 1000 / 60); // w minutach

          this.mitigationTime.innerText = diff2.toTime();
          this.mitigationTimeValue = diff2;
        }
      }
    }, {
      key: "calculateChanges",
      value: function calculateChanges() {
        var changes = {};
        var changed = false;

        for (var _i2 = 0, _Object$keys = Object.keys(this); _i2 < _Object$keys.length; _i2++) {
          var key = _Object$keys[_i2];
          var obj = this[key];

          if (obj && _typeof(obj) === 'object' && obj instanceof SPCell) {
            if (obj.classList.contains('changed')) {
              changes[key.toSnake()] = obj.value;
              changed = true;
            }
          }
        }

        if (changed) {
          this._changes = changes;
        } else {
          delete this._changes;
        }
      }
    }, {
      key: "editable",
      set: function set(value) {
        this._editable = value;

        for (var _i3 = 0, _Object$keys2 = Object.keys(this); _i3 < _Object$keys2.length; _i3++) {
          var key = _Object$keys2[_i3];
          var child = this[key];

          if (child instanceof SPCell) {
            child.editable = value;
          }
        }
      },
      get: function get() {
        return !!this._editable;
      }
    }, {
      key: "deleted",
      set: function set(value) {
        if (value) {
          this.remove();
        } else {
          this._deleted = false;

          if (this.id > 0) {
            this.parentElement.style.display = 'table-row-group';
            this.style.display = 'table-row';
          }
        }
      },
      get: function get() {
        return !!this._deleted;
      }
    }, {
      key: "changed",
      get: function get() {
        return this._changes !== undefined;
      }
    }, {
      key: "changes",
      get: function get() {
        return this._changes || {};
      }
    }, {
      key: "value",
      get: function get() {
        return {
          ticket_number: this.ticketNumber.value || '',
          reported_at: this.reportedAt.value || '',
          phishing_urls: this.phishingUrls.value || [],
          phishing_domains: this.phishingDomains.value || [],
          phishing_ips: this.phishingIps.value || [],
          reacted_at: this.reactedAt.value || '',
          blocked_domains: this.blockedDomains.value || [],
          blocked_ips: this.blockedIps.value || [],
          blocked_at: this.blockedAt.value || '',
          remarks: this.remarks.value || ''
        };
      }
    }]);

    return SPRow;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLTableRowElement)); /////////////// SPContainer ///////////////


  var SPContainer = /*#__PURE__*/function () {
    function SPContainer(rows$) {
      var _this10 = this;

      _classCallCheck(this, SPContainer);

      this.container = document.getElementById('sp-content');
      this.statistics$ = new rxjs.Subject();
      this.changed$ = new rxjs.Subject();
      this.rows$ = rows$; // noinspection JSUnresolvedFunction

      this.rows$.subscribe(function (rows) {
        var child; // noinspection JSAssignmentUsedAsCondition

        while (child = _this10.container.firstChild) {
          if (child instanceof SPRow) {
            child.release();
          }

          _this10.container.removeChild(child);
        }

        var index = 1;

        var _iterator = _createForOfIteratorHelper(rows || []),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var row = _step.value;
            var spRow = new SPRow(row);
            spRow.reindex(index++);

            _this10.container.appendChild(spRow);

            spRow.onrefresh$.subscribe(function () {
              setTimeout(function () {
                _this10.recalculateStatistics();
              });
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if ((rows || []).length) _this10.container.style.display = 'table-row-group';else _this10.container.style.display = 'none';
        setTimeout(function () {
          _this10.recalculateStatistics();
        });
      });
      this.container.addEventListener('row-removed', function () {
        return _this10.afterRowRemoved();
      });
    }

    _createClass(SPContainer, [{
      key: "recalculateStatistics",
      value: function recalculateStatistics() {
        var result = {
          phishingUrlsTotalCount: 0,
          phishingDomainsTotalCount: 0,
          phishingIpsTotalCount: 0,
          blockedDomainsTotalCount: 0,
          blockedIpsTotalCount: 0,
          reactionTimeAvg: '0:00',
          reactionTimeMax: '0:00',
          mitigationTimeAvg: '0:00',
          mitigationTimeMax: '0:00'
        };
        var reactionTimeMax = 0;
        var mitigationTimeMax = 0;
        var reactionsCount = 0;
        var mitigationsCount = 0;
        var reactionsTotal = 0;
        var mitigationsTotal = 0;
        var changed = false;

        for (var _i4 = 0, _Array$from2 = Array.from(this.container.childNodes); _i4 < _Array$from2.length; _i4++) {
          var child = _Array$from2[_i4];
          if (!(child instanceof SPRow)) continue;

          if (child.deleted) {
            changed = true;
            continue;
          }

          changed = changed || child.changed;
          result.phishingUrlsTotalCount += child.getPhishingUrls().length;
          result.phishingDomainsTotalCount += child.getPhishingDomains().length;
          result.phishingIpsTotalCount += child.getPhishingIps().length;
          result.blockedDomainsTotalCount += child.getBlockedDomains().length;
          result.blockedIpsTotalCount += child.getBlockedIps().length;

          if (child.getReactionTime() !== undefined) {
            if (child.getReactionTime() > reactionTimeMax) {
              reactionTimeMax = child.getReactionTime();
            }

            reactionsCount++;
            reactionsTotal += child.getReactionTime();
          }

          if (child.getMitigationTime() !== undefined) {
            if (child.getMitigationTime() > mitigationTimeMax) {
              mitigationTimeMax = child.getMitigationTime();
            }

            mitigationsCount++;
            mitigationsTotal += child.getMitigationTime();
          }
        }

        result.reactionTimeMax = reactionTimeMax.toTime();
        result.mitigationTimeMax = mitigationTimeMax.toTime();
        result.reactionTimeAvg = (reactionsCount > 0 ? Math.floor(reactionsTotal / reactionsCount) : 0).toTime();
        result.mitigationTimeAvg = (mitigationsCount > 0 ? Math.floor(mitigationsTotal / mitigationsCount) : 0).toTime();
        this.statistics$.next(result);
        this.changed$.next(changed);
      }
    }, {
      key: "enterEditMode",
      value: function enterEditMode() {
        var _iterator2 = _createForOfIteratorHelper(this.rows),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;
            row.editable = true;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }, {
      key: "exitEditMode",
      value: function exitEditMode() {
        var _iterator3 = _createForOfIteratorHelper(this.rows),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var row = _step3.value;

            if (row.id > 0) {
              row.editable = false;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, {
      key: "cancelEditMode",
      value: function cancelEditMode() {
        var _iterator4 = _createForOfIteratorHelper(this.allRows),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var row = _step4.value;

            if (row.id > 0) {
              row.editable = false;
              row.deleted = false;
              row.clearChanges();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }, {
      key: "addEmptyRow",
      value: function addEmptyRow() {
        var _this11 = this;

        var spRow = new SPRow({});
        spRow.reindex(this.rows.length + 1);
        this.container.appendChild(spRow);
        spRow.onrefresh$.subscribe(function () {
          setTimeout(function () {
            _this11.recalculateStatistics();
          });
        });
        this.container.style.display = 'table-row-group';
      }
    }, {
      key: "afterRowRemoved",
      value: function afterRowRemoved() {
        this.recalculateStatistics();
        if (this.rows.length) this.container.style.display = 'table-row-group';else this.container.style.display = 'none';
        var index = 1;

        var _iterator5 = _createForOfIteratorHelper(this.rows),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var row = _step5.value;
            row.reindex(index);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }, {
      key: "hasChangesToExistingRows",
      value: function hasChangesToExistingRows() {
        for (var _i5 = 0, _Array$from3 = Array.from(this.container.childNodes); _i5 < _Array$from3.length; _i5++) {
          var child = _Array$from3[_i5];
          if (!(child instanceof SPRow) || !child.changed && !child.deleted) continue;

          if (child.deleted) {
            return true;
          } else if (child.id && child.id > 0) {
            if (child.changed) {
              return true;
            }
          }
        }

        return false;
      }
    }, {
      key: "hasChanges",
      value: function hasChanges() {
        for (var _i6 = 0, _Array$from4 = Array.from(this.container.childNodes); _i6 < _Array$from4.length; _i6++) {
          var child = _Array$from4[_i6];
          if (!(child instanceof SPRow) || !child.changed && !child.deleted) continue;

          if (child.deleted) {
            return true;
          } else if (child.id && child.id > 0) {
            if (child.changed) {
              return true;
            }
          } else {
            return true;
          }
        }

        return false;
      }
    }, {
      key: "rows",
      get: function get() {
        var result = [];

        for (var _i7 = 0, _Array$from5 = Array.from(this.container.childNodes); _i7 < _Array$from5.length; _i7++) {
          var child = _Array$from5[_i7];
          if (!(child instanceof SPRow) || child.deleted) continue;
          result.push(child);
        }

        return result;
      }
    }, {
      key: "allRows",
      get: function get() {
        var result = [];

        for (var _i8 = 0, _Array$from6 = Array.from(this.container.childNodes); _i8 < _Array$from6.length; _i8++) {
          var child = _Array$from6[_i8];
          if (!(child instanceof SPRow)) continue;
          result.push(child);
        }

        return result;
      }
    }, {
      key: "changes",
      get: function get() {
        var changes = [];

        for (var _i9 = 0, _Array$from7 = Array.from(this.container.childNodes); _i9 < _Array$from7.length; _i9++) {
          var child = _Array$from7[_i9];
          if (!(child instanceof SPRow) || !child.changed && !child.deleted) continue;

          if (child.deleted) {
            changes.push({
              id: child.id,
              deleted: true
            });
          } else if (child.id && child.id > 0) {
            changes.push(Object.assign({
              id: child.id,
              deleted: false
            }, child.changes));
          } else {
            changes.push(Object.assign({
              deleted: false
            }, child.value));
          }
        }

        return changes;
      }
    }]);

    return SPContainer;
  }(); /////////////// SPStatistics ///////////////


  var SPStatistics = function SPStatistics(stats$) {
    var _this12 = this;

    _classCallCheck(this, SPStatistics);

    this.phishingUrlsTotalCount = document.getElementById('phishing_urls_total_count');
    this.phishingDomainsTotalCount = document.getElementById('phishing_domains_total_count');
    this.phishingIpsTotalCount = document.getElementById('phishing_ips_total_count');
    this.blockedDomainsTotalCount = document.getElementById('blocked_domains_total_count');
    this.blockedIpsTotalCount = document.getElementById('blocked_ips_total_count');
    this.reactionTimeAvg = document.getElementById('reaction_time_avg');
    this.reactionTimeMax = document.getElementById('reaction_time_max');
    this.mitigationTimeAvg = document.getElementById('mitigation_time_avg');
    this.mitigationTimeMax = document.getElementById('mitigation_time_max');
    stats$.subscribe(function (stats) {
      _this12.phishingUrlsTotalCount.innerText = (stats.phishingUrlsTotalCount || 0).toString();
      _this12.phishingDomainsTotalCount.innerText = (stats.phishingDomainsTotalCount || 0).toString();
      _this12.phishingIpsTotalCount.innerText = (stats.phishingIpsTotalCount || 0).toString();
      _this12.blockedDomainsTotalCount.innerText = (stats.blockedDomainsTotalCount || 0).toString();
      _this12.blockedIpsTotalCount.innerText = (stats.blockedIpsTotalCount || 0).toString();
      _this12.reactionTimeAvg.innerText = stats.reactionTimeAvg || '0:00';
      _this12.reactionTimeMax.innerText = stats.reactionTimeMax || '0:00';
      _this12.mitigationTimeAvg.innerText = stats.mitigationTimeAvg || '0:00';
      _this12.mitigationTimeMax.innerText = stats.mitigationTimeMax || '0:00';
    });
  }; /////////////// SPMenu ///////////////


  var SPMenuAction = /*#__PURE__*/function (_HTMLDivElement) {
    _inherits(SPMenuAction, _HTMLDivElement);

    var _super6 = _createSuper(SPMenuAction);

    function SPMenuAction(label, icon, action) {
      var _this13;

      _classCallCheck(this, SPMenuAction);

      for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
        args[_key6 - 3] = arguments[_key6];
      }

      _this13 = _super6.call.apply(_super6, [this].concat(args));
      _this13.label = label;
      _this13.icon = icon;
      _this13.action = action;
      return _this13;
    }

    _createClass(SPMenuAction, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var icon = document.createElement('i');
        icon.classList.add('md', "md-".concat(this.icon));
        var label = document.createElement('span');
        label.innerText = this.label;
        this.appendChild(icon);
        this.appendChild(label);
        this.addEventListener('click', this.action);
      }
    }]);

    return SPMenuAction;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement));

  var SPMenu = /*#__PURE__*/function () {
    function SPMenu() {
      var _this14 = this;

      _classCallCheck(this, SPMenu);

      this.menu = null;
      this.overlay = null;
      window.addEventListener('contextmenu', function (e) {
        _this14.hide();

        var target = e.target;

        while (target && !(target instanceof SPRow)) {
          target = target.parentElement;
        }

        if (!target) return;

        if (_this14.show(target, e.pageX, e.pageY)) {
          e.preventDefault();
        }
      });
    }

    _createClass(SPMenu, [{
      key: "hide",
      value: function hide() {
        if (this.menu) {
          this.menu.remove();
          this.menu = null;
        }

        if (this.overlay) {
          this.overlay.remove();
          this.overlay = null;
        }
      }
    }, {
      key: "show",
      value: function show(row, x, y) {
        var _this15 = this;

        if (this.menu) {
          this.hide();
        }

        var actions = [];

        if (row.changed) {
          actions.push(new SPMenuAction(row.id > 0 ? 'Wycofaj zmiany' : "Wyczyść", 'clear', function () {
            return row.clearChanges();
          }));
        }

        if (row.editable) {
          actions.push(new SPMenuAction('Usuń wiersz', 'delete', function () {
            var popup = new HTMLElements.PopupElement();

            if (row.id > 0) {
              popup.content = 'Czy na pewno chcesz usunąć wiersz? Operację można wycofać odświeżając dane lub klikając w przycisk „Anuluj”.';
            } else {
              popup.content = 'Wiersz zostanie bezpowrotnie usunięty. Czy chcesz kontynuować?';
            }

            popup.addDefaultButton('Tak', function () {
              row.remove();
              popup.hide();
            });
            popup.addButton('Nie', function () {
              return popup.hide();
            });
            popup.show();
          }));
        }

        if (actions.length === 0) {
          return false;
        }

        document.body.appendChild(this.overlay = document.createElement('div'));
        document.body.appendChild(this.menu = document.createElement('div'));
        this.overlay.classList.add('overlay');
        this.menu.classList.add('contextmenu');
        this.menu.style.top = "".concat(y, "px");
        this.menu.style.left = "".concat(x, "px");
        this.overlay.addEventListener('click', function () {
          return _this15.hide();
        });
        this.menu.addEventListener('click', function () {
          return _this15.hide();
        });

        for (var _i10 = 0, _actions = actions; _i10 < _actions.length; _i10++) {
          var action = _actions[_i10];
          this.menu.appendChild(action);
        }

        return true;
      }
    }]);

    return SPMenu;
  }(); /////////////// MessagesContainer ///////////////


  var MessageContainerElement = /*#__PURE__*/function (_HTMLDivElement2) {
    _inherits(MessageContainerElement, _HTMLDivElement2);

    var _super7 = _createSuper(MessageContainerElement);

    function MessageContainerElement(type, messages) {
      var _this16;

      _classCallCheck(this, MessageContainerElement);

      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      _this16 = _super7.call.apply(_super7, [this].concat(args));
      _this16.type = type || MessageContainerElement.TypeNotice;
      _this16.messages = messages || [];
      return _this16;
    }

    _createClass(MessageContainerElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var msg;

        switch (this.type) {
          case MessageContainerElement.TypeNotice:
            msg = this.messages.length ? 'Podczas analizy wykryto potencjalne problemy:' : 'Wystąpił niezidentyfikowany problem.';
            break;

          case MessageContainerElement.TypeWarning:
            msg = this.messages.length ? 'Wystąpiły następujące błędy:' : 'Wystąpił niezidentyfikowany problem.';
            break;
        }

        this.appendChild(document.createTextNode(msg));

        if (this.messages.length) {
          var ul = document.createElement('ul');

          var _iterator6 = _createForOfIteratorHelper(this.messages),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _err = _step6.value;
              var li = document.createElement('li');
              li.innerText = _err;
              ul.appendChild(li);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          this.appendChild(ul);
        }
      }
    }]);

    return MessageContainerElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLDivElement)); /////////////// Controller ///////////////
  // noinspection JSUnresolvedVariable


  _defineProperty(MessageContainerElement, "TypeNotice", 'notice');

  _defineProperty(MessageContainerElement, "TypeWarning", 'warning');

  var StopPhishingBlockadeRequestsController = /*#__PURE__*/function () {
    function StopPhishingBlockadeRequestsController(config) {
      var _this17 = this;

      _classCallCheck(this, StopPhishingBlockadeRequestsController);

      this.rows$ = new rxjs.Subject();
      this.table = document.getElementById('sp-table');
      this.content = document.getElementById('sp-content');
      this.newRecord = document.getElementById('new-record');
      this.toggleEditMode = document.getElementById('edit-mode');
      this.save = document.getElementById('save-changes');
      this.container = new SPContainer(this.rows$.asObservable());
      this.statistics = new SPStatistics(this.container.statistics$.asObservable());
      this.menu = new SPMenu();
      this.lastFilters = {
        company: undefined,
        from: undefined,
        to: undefined
      };
      this.lastUpdateToken = undefined;
      this.init(this.config = config);
      global.addEventListener('beforeunload', function (e) {
        if (_this17.container.hasChanges()) {
          e.preventDefault();
          e.returnValue = '';
        }
      });
    }

    _createClass(StopPhishingBlockadeRequestsController, [{
      key: "init",
      value: function init(config) {
        var _this18 = this;

        var companyPicker = document.getElementById('company_picker');
        document.getElementById('filter-button').addEventListener('click', function (e) {
          e.preventDefault();
          var company = Number.isInteger(+companyPicker.value) ? +companyPicker.value : null;
          var from = document.getElementById('from-date').value;
          var to = document.getElementById('to-date').value;

          if (company === null) {
            return;
          }

          if (_this18.container.hasChanges()) {
            var popup = new HTMLElements.PopupElement();
            popup.content = 'Niezapisane zmiany zostaną utracone. Czy chcesz kontynuować?';
            popup.skippable = true;
            popup.addDefaultButton('Tak', function () {
              _this18.lastFilters.company = company;
              _this18.lastFilters.from = from;
              _this18.lastFilters.to = to;

              _this18.load();

              popup.hide();
            });
            popup.addCancelButton('Nie', function () {
              return popup.hide();
            });
            popup.show();
          } else {
            _this18.lastFilters.company = company;
            _this18.lastFilters.from = from;
            _this18.lastFilters.to = to;

            _this18.load();
          }
        });
        document.getElementById('export-button').addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var company = Number.isInteger(+companyPicker.value) ? +companyPicker.value : null;
          var from = document.getElementById('from-date').value;
          var to = document.getElementById('to-date').value;

          if (company === null) {
            return;
          }

          window.open("".concat(config.export_url, "?").concat($.param({
            company: company,
            from: from,
            to: to
          })), '_self');
        });
        this.container.changed$.asObservable().subscribe(function (changed) {
          if (changed) {
            _this18.save.removeAttribute('disabled');

            _this18.save.innerText = 'Zapisz zmiany';
          } else {
            _this18.save.setAttribute('disabled', 'disabled');

            _this18.save.innerText = 'Brak zmian';
          }
        });
        this.toggleEditMode.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (_this18.toggleEditMode.inEditMode) {
            if (_this18.container.hasChangesToExistingRows()) {
              var popup = new HTMLElements.PopupElement();
              popup.closeable = false;
              popup.content = 'Anulowanie spowoduje wycofanie zmian w już zapisanych wpisach, które zostały wprowadzone w trybie edycji. Czy chcesz kontynuować?';
              popup.addButton('Tak', function () {
                _this18.container.cancelEditMode();

                popup.hide();
                _this18.toggleEditMode.innerText = 'Edytuj';
                delete _this18.toggleEditMode.inEditMode;
              });
              popup.addCancelButton('Nie', function () {
                return popup.hide();
              });
              popup.show();
            } else {
              _this18.container.cancelEditMode();

              _this18.toggleEditMode.innerText = 'Edytuj';
              delete _this18.toggleEditMode.inEditMode;
            }
          } else {
            var _popup = new HTMLElements.PopupElement();

            _popup.closeable = false;
            _popup.content = 'Wchodzisz w tryb edycji, umożliwiający wprowadzanie zmian w już zapisanych wpisach. Czy chcesz kontynuować?';
            _popup.skippable = true;

            _popup.addDefaultButton('Tak', function () {
              _this18.container.enterEditMode();

              _popup.hide();

              _this18.toggleEditMode.innerText = 'Anuluj';
              _this18.toggleEditMode.inEditMode = true;
            });

            _popup.addCancelButton('Nie', function () {
              return _popup.hide();
            });

            _popup.show();
          }
        });
        this.newRecord.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          _this18.container.addEmptyRow();
        });
        this.save.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var popup = new HTMLElements.PopupElement();
          popup.content = 'Czy na pewno chcesz zapisać wprowadzone zmiany?';
          popup.addDefaultButton('Tak', function () {
            _this18.saveAll(_this18.container.changes);

            popup.hide();
          });
          popup.addCancelButton('Nie', function () {
            return popup.hide();
          });
          popup.show();
        });
      }
    }, {
      key: "saveAll",
      value: function saveAll(changes) {
        var _this19 = this;

        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        // {id: 123} - delete
        // {id: 123, other_fields:...} - update
        // {other_fields: ...} - insert
        var request = {
          company_id: this.lastFilters.company,
          requests: changes,
          token: this.lastUpdateToken,
          force: force
        };
        ApiConnect.post(this.config.update_url, request).then(function (response) {
          if (response.status === 'success') {
            _this19.load(true);
          } else if (response.status === 'notice') {
            var popup = new HTMLElements.PopupElement();
            popup.header = 'Ostrzeżenie';
            popup.closeable = false;
            popup.content = new MessageContainerElement(MessageContainerElement.TypeNotice, response.messages || []);
            popup.addCancelButton('Chcę poprawić', function () {
              return popup.hide();
            });
            popup.addButton('Zapisz i zamknij te głupoty', function () {
              _this19.saveAll(changes, true);

              popup.hide();
            });
            popup.show();
          } else {
            var _popup2 = new HTMLElements.PopupElement();

            _popup2.header = 'Błąd';
            _popup2.closeable = false;
            _popup2.content = new MessageContainerElement(MessageContainerElement.TypeWarning, response.messages || []);

            _popup2.addCancelButton('Już poprawiam', function () {
              return _popup2.hide();
            });

            _popup2.show();
          }
        })["catch"](function (err) {
          return console.error('Błąd zapisywania danych: ', err);
        });
      }
    }, {
      key: "load",
      value: function load() {
        var _this20 = this;

        var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var filterBtn = document.getElementById('filter-button');
        filterBtn.disabled = true;
        ApiConnect.get(this.config.data_url, this.lastFilters).then(function (data) {
          _this20.table.style.display = 'table';

          _this20.rows$.next((((data || {}).data || {}).blockade_requests || {}).rows || []);

          _this20.lastUpdateToken = (((data || {}).data || {}).blockade_requests || {}).csrf_token;
          _this20.toggleEditMode.innerText = 'Edytuj';
          delete _this20.toggleEditMode.inEditMode;

          if (reload) {
            setTimeout(function () {
              _this20.save.innerText = 'Zapisano';
            });
          }
        })["catch"](function (err) {
          return console.error('Błąd wczytywania danych: ', err);
        }, function () {
          return filterBtn.disabled = false;
        });
      }
    }]);

    return StopPhishingBlockadeRequestsController;
  }(); // Rejestracja customElements


  customElements.define('sp-cell', SPCell, {
    "extends": 'td'
  });
  customElements.define('sp-input', SPInput, {
    "extends": 'td'
  });
  customElements.define('sp-text-input', SPTextInput, {
    "extends": 'td'
  });
  customElements.define('sp-array-input', SPArrayInput, {
    "extends": 'td'
  });
  customElements.define('sp-row', SPRow, {
    "extends": 'tr'
  });
  customElements.define('sp-menu-action', SPMenuAction, {
    "extends": 'div'
  });
  customElements.define('sp-popup-messages', MessageContainerElement, {
    "extends": 'div'
  }); //wyeksportowanie klasy

  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.StopPhishingBlockadeRequestsController = StopPhishingBlockadeRequestsController || {};
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var StopPhishingMemberReportsController = /*#__PURE__*/function () {
    function StopPhishingMemberReportsController(config) {
      _classCallCheck(this, StopPhishingMemberReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(StopPhishingMemberReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "100px"
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": "300px"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return StopPhishingMemberReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.StopPhishingMemberReportsController = StopPhishingMemberReportsController || {};
})(window);
/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var StopPhishingOperatorReportsController = /*#__PURE__*/function () {
    function StopPhishingOperatorReportsController(config) {
      _classCallCheck(this, StopPhishingOperatorReportsController);

      this.settings = {
        charts: {
          barChart: {
            dataName: "column_data",
            id: "alarms"
          }
        },
        colors: {
          low: "250, 220, 0",
          medium: "255, 132, 51",
          high: "213, 71, 51"
        }
      };
      this.init(config);
    }

    _createClass(StopPhishingOperatorReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data",
            "dataIndex": "date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "100px"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Nazwa pliku",
            "dataIndex": "file_name",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": "300px"
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return StopPhishingOperatorReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.StopPhishingOperatorReportsController = StopPhishingOperatorReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var TufinController = /*#__PURE__*/function () {
    function TufinController(config) {
      _classCallCheck(this, TufinController);

      this.settings = {};
      this.init(config);
    }

    _createClass(TufinController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data dodania",
            "dataIndex": "add_date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "report_description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Status pobrania",
            "dataIndex": "download_status",
            "dataType": "download_status",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Data i czas pobrania",
            "dataIndex": "download_date",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "link",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 100
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return TufinController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.TufinController = TufinController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var TufinReportsController = /*#__PURE__*/function () {
    function TufinReportsController(config) {
      _classCallCheck(this, TufinReportsController);

      this.settings = {};
      this.init(config);
    }

    _createClass(TufinReportsController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Data dodania",
            "dataIndex": "add_date",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": "*"
          }, {
            "label": "Firma",
            "dataIndex": "firm",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Opis raportu",
            "dataIndex": "report_description",
            "dataType": "text",
            "isEditable": false,
            "width": "*"
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isEditable": false,
            "isFilterable": false,
            "isSortable": false,
            "width": 170
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config.table_data_url,
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': 'grid-container',
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return TufinReportsController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.TufinReportsController = TufinReportsController || {};
})(window);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var UserListController = /*#__PURE__*/function () {
    function UserListController(config) {
      _classCallCheck(this, UserListController);

      this.settings = {
        table: {
          id: 'grid-container'
        }
      };
      this.init(config);
    }

    _createClass(UserListController, [{
      key: "init",
      value: function init(config) {
        this.createGrid(config);
      }
    }, {
      key: "createGrid",
      value: function createGrid(config) {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          "columnDefinitions": [{
            "label": "Adres e-mail",
            "dataIndex": "email",
            "dataType": "text",
            "isEditable": false,
            "isSortable": true,
            "isFilterable": true,
            "isMovable": true,
            "width": 290
          }, {
            "label": "Rola",
            "dataIndex": "role_name",
            "dataType": "text",
            "isEditable": false,
            "isFilterable": true,
            "filterType": "text",
            "width": 150
          }, {
            "label": "Firma",
            "dataIndex": "company_name",
            "dataType": "text",
            "isEditable": false
          }, {
            "label": "Czas ostatniego logowania",
            "dataIndex": "last_login",
            "dataType": "text",
            "isEditable": false,
            "width": 200
          }, {
            "label": "Akcje",
            "dataIndex": "actions",
            "dataType": "actions",
            "isFilterable": false,
            "isSortable": false,
            "isEditable": false,
            "width": 270
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          'url': config['table_data_url'],
          'baseParameters': {},
          'updateUrl': "/js/app/update.json"
        });
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          "id": "gridContainerId"
        });
        new NS.Grid.Control({
          'id': "gridContainerWrapperId",
          'containerId': this.settings['table']['id'],
          'dataSource': dataSource,
          'reloadTime': null,
          //not implemented yet
          'autoLoad': true,
          'columnDefinitionSource': columnDefinitionSource,
          'settingsManager': settingsManager,
          'allowMultiselect': false,
          "showAllRows": config.show_all_rows || false,
          "pageSize": config.show_all_rows ? 99999999 : 20,
          'listeners': {
            'onDataChanged': function onDataChanged() {},
            'onDataSaved': function onDataSaved() {},
            'onDataInvalid': function onDataInvalid() {},
            'onDataError': function onDataError() {},
            'onSelectionChange': function onSelectionChange(ids) {}
          }
        });
      }
    }]);

    return UserListController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.UserListController = UserListController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var WafController = /*#__PURE__*/function () {
    function WafController(config) {
      _classCallCheck(this, WafController);

      this.settings = {
        charts: {
          barChart: {
            chartAllEvents: {
              id: "chartAllEvents",
              dataName: "all_events"
            }
          },
          pieCharts: {
            chartRisksDistribution: {
              id: "chartRisksDistribution",
              dataName: "risks_distribution"
            },
            chartRecentIP: {
              id: "chartRecentIP",
              dataName: "recent_ip"
            }
          }
        },
        colors: {
          low: "250,223,25",
          medium: "255,144,71",
          high: "217,89,71" // Niskie: "250,223,25",
          // 'Średnie': "255,144,71",
          // Wysokie: "217,89,71",

        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(WafController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _div2 = _step.value;

            var closestCard = _div2.closest('.card');

            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _div = _step2.value;
              _div.style.display = 'block';

              _div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var el = document.getElementById('allEventsTab');
        var span = el.querySelector('span');
        var div = el.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var columnData = data.data.all_events;

          if (columnData.length === 0) {
            span.style.display = 'block';
          } else {
            div.style.display = 'block';

            _this.drawBarChart(data);
          }

          _this.drawPieCharts(data);

          _this.setCardHeaders(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(data) {
        var chartSettings = this.settings.charts;
        var pieChartSettings = chartSettings.pieCharts;
        var barChartId = chartSettings.barChart.chartAllEvents.id;
        var pieChartKeys = Object.keys(pieChartSettings);
        var firstPieChartSettings = pieChartSettings[pieChartKeys[0]];
        var firstPieChartId = firstPieChartSettings.id;
        var firstPieChartDataName = firstPieChartSettings.dataName;
        var firstPieChartTabId = firstPieChartId + 'Tab';
        var barChart = document.getElementById(barChartId);
        var barChartCard = barChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = this.config["bar_chart_title"];
        document.querySelectorAll('.pie-charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var firstPieChart = document.getElementById(firstPieChartId);
        var pieChartsCard = firstPieChart.closest('.card');
        var pieChartTitleEl = pieChartsCard.querySelector('.chart-title');
        pieChartTitleEl.textContent = data.data[firstPieChartDataName].name;
        var firstPieChartTab = document.getElementById(firstPieChartTabId);
        firstPieChartTab.classList.add('active');

        for (var _i = 0, _pieChartKeys = pieChartKeys; _i < _pieChartKeys.length; _i++) {
          var key = _pieChartKeys[_i];
          var chart = pieChartSettings[key];
          var pieChartMenuEl = document.querySelector('.pie-chart-menu');
          pieChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
        }

        this.bindChangeTabPieChart();
      }
    }, {
      key: "bindChangeTabPieChart",
      value: function bindChangeTabPieChart() {
        var chartTabToggles = document.querySelectorAll('.char-tab-toggle');

        var _iterator6 = _createForOfIteratorHelper(chartTabToggles),
            _step6;

        try {
          var _loop3 = function _loop3() {
            var toggle = _step6.value;
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              var target = document.getElementById(toggle.getAttribute('data-target-id'));

              if (target) {
                var otherTabs = Array.prototype.filter.call(target.parentNode.children, function (child) {
                  return child !== target;
                });

                var _iterator7 = _createForOfIteratorHelper(otherTabs),
                    _step7;

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var tab = _step7.value;
                    tab.classList.remove('active');
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                target.classList.add('active');
              }

              var cardHeader = toggle.closest('.card-header');
              var chartTitleEl = cardHeader.querySelector('h2');
              chartTitleEl.textContent = toggle.textContent;
            });
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "drawBarChart",
      value: function drawBarChart(data) {
        this.chartAllEvents = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barChart"]["chartAllEvents"]["id"],
          data: data["data"][this.settings["charts"]["barChart"]["chartAllEvents"]["dataName"]],
          multidata: true,
          name_mapping: {
            low: "Niskie",
            medium: "Średnie",
            high: "Wysokie"
          },
          colors: {
            low: "250,223,25",
            medium: "255,144,71",
            high: "217,89,71"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawPieCharts",
      value: function drawPieCharts(data) {
        this.chartRisksDistribution = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["chartRisksDistribution"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["chartRisksDistribution"]["dataName"]],
          name_mapping: {
            low: "Niskie",
            medium: "Średnie",
            high: "Wysokie"
          },
          colors: {
            low: "250,223,25",
            medium: "255,144,71",
            high: "217,89,71"
          },
          show_legend: this.config['show_legend']
        });
        this.chartRecentIP = new NS.Charts.PieChart({
          "container-id": this.settings["charts"]["pieCharts"]["chartRecentIP"]["id"],
          data: data["data"][this.settings["charts"]["pieCharts"]["chartRecentIP"]["dataName"]],
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "bindExport",
      value: function bindExport(dataSource) {
        var _loop4 = function _loop4() {
          var id = _arr[_i2];
          var button = document.getElementById(id);
          button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var filterStartIndex = dataSource.baseUrl.indexOf('/incidents?');
            var filterString = dataSource.baseUrl.substring(filterStartIndex).replace('/incidents', '');
            var basePath = button.getAttribute('href');
            dataSource['filterValues'].forEach(function (filter) {
              if (filter['value']) {
                filterString += '&filters[' + filter['dataIndex'] + ']=' + filter['value'];
              }
            });

            if (dataSource['sortValues']) {
              if (dataSource['sortValues']['order']) {
                filterString += '&sort[order]=' + dataSource['sortValues']['order'];
              }

              if (dataSource['sortValues']['order']) {
                filterString += '&sort[key]=' + dataSource['sortValues']['dataIndex'];
              }
            }

            window.open(basePath + filterString);
          });
        };

        for (var _i2 = 0, _arr = ['pdf-export', 'csv-export']; _i2 < _arr.length; _i2++) {
          _loop4();
        }
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "Data i czas",
            dataIndex: "date",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            isMovable: true,
            width: '*'
          }, {
            label: "Zagrożenie",
            dataIndex: "danger",
            dataType: "danger",
            isEditable: false
          }, {
            label: "Aplikacja",
            dataIndex: "application",
            dataType: "text",
            isEditable: false
          }, {
            label: "Ścieżka",
            dataIndex: "path",
            dataType: "text",
            isEditable: false
          }, {
            label: "Adres IP : Port źródłowy",
            dataIndex: "ip_address_port",
            dataType: "text",
            isEditable: false
          }, {
            label: "Typ zdarzenia",
            dataIndex: "event_type",
            dataType: "text",
            isEditable: false
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "link",
            isEditable: false,
            isFilterable: false,
            width: 120
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        this.bindExport(dataSource);
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return WafController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.WafController = WafController || {};
})(window);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (global) {
  var WafDdosController = /*#__PURE__*/function () {
    function WafDdosController(config) {
      _classCallCheck(this, WafDdosController);

      this.settings = {
        charts: {
          barChart: {
            trafficUtilizationReportChart: {
              id: "chartTrafficUtilizationReport",
              dataName: "traffic_utilization_report_chart"
            },
            getPostRequestRateChart: {
              id: "chartGetPostRequestRate",
              dataName: "get_post_request_rate_chart"
            },
            dnsRequestRateChart: {
              id: "chartDnsRequestRate",
              dataName: "dns_request_rate_chart"
            }
          }
        },
        colors: {
          low: "250,223,25",
          medium: "255,144,71",
          high: "217,89,71" // Niskie: "250,223,25",
          // 'Średnie': "255,144,71",
          // Wysokie: "217,89,71",

        }
      };
      this.config = config;
      this.loadDataChart();
      this.createGrid();
    }

    _createClass(WafDdosController, [{
      key: "loadDataChart",
      value: function loadDataChart() {
        var _this = this;

        var loadingDivs = document.querySelectorAll('.loading');
        var cardActions = [];

        var _iterator = _createForOfIteratorHelper(loadingDivs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var div = _step.value;
            var closestCard = div.closest('.card');
            var cardHeaders = closestCard.querySelectorAll('.card-header');

            var _iterator5 = _createForOfIteratorHelper(cardHeaders),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var headerElement = _step5.value;
                var actions = headerElement.querySelectorAll('.actions');
                cardActions.push.apply(cardActions, _toConsumableArray(actions));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(document).on('ajaxStart', function () {
          var _iterator2 = _createForOfIteratorHelper(loadingDivs),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var div = _step2.value;
              div.style.display = 'block';
              div.classList.add('i-am-visible');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'none';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 0;
          });
        });
        $(document).on('ajaxStop', function () {
          var _iterator3 = _createForOfIteratorHelper(loadingDivs),
              _step3;

          try {
            var _loop = function _loop() {
              var div = _step3.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
        var trafficUtilizationReportEl = document.getElementById('chartTrafficUtilizationReportTab');
        var trafficUtilizationReportSpan = trafficUtilizationReportEl.querySelector('span');
        var trafficUtilizationReportDiv = trafficUtilizationReportEl.querySelector('div');
        var getPostRequestRateEl = document.getElementById('chartGetPostRequestRateTab');
        var getPostRequestRateSpan = getPostRequestRateEl.querySelector('span');
        var getPostRequestRateDiv = getPostRequestRateEl.querySelector('div');
        var dnsRequestRateEl = document.getElementById('chartDnsRequestRateTab');
        var dnsRequestRateSpan = dnsRequestRateEl.querySelector('span');
        var dnsRequestRateDiv = dnsRequestRateEl.querySelector('div');
        ApiConnect.get(this.config.chart_data_url).then(function (data) {
          // noinspection JSUnresolvedVariable
          var trafficUtilizationReportValues = data.data.traffic_utilization_report_chart.values; // noinspection JSUnresolvedVariable

          var getPostRequestRateValues = data.data.get_post_request_rate_chart.values; // noinspection JSUnresolvedVariable

          var dnsRequestRateValues = data.data.dns_request_rate_chart.values;

          if (trafficUtilizationReportValues.length === 0) {
            trafficUtilizationReportSpan.style.display = 'block';
          } else {
            trafficUtilizationReportDiv.style.display = 'block';

            _this.drawTrafficUtilizationReportChart(data);
          }

          if (getPostRequestRateValues.length === 0) {
            getPostRequestRateSpan.style.display = 'block';
          } else {
            getPostRequestRateDiv.style.display = 'block';

            _this.drawGetPostRequestRateChart(data);
          }

          if (dnsRequestRateValues.length === 0) {
            dnsRequestRateSpan.style.display = 'block';
          } else {
            dnsRequestRateDiv.style.display = 'block';

            _this.drawDnsRequestRateChart(data);
          }

          _this.setCardHeaders(data);
        })["catch"](function (errorThrown) {
          console.log('Błąd wczytywania danych: ', errorThrown);
        })["finally"](function () {
          var _iterator4 = _createForOfIteratorHelper(loadingDivs),
              _step4;

          try {
            var _loop2 = function _loop2() {
              var div = _step4.value;
              div.classList.add('hide-me');
              div.addEventListener('transitionend', function () {
                return div.style.display = 'none';
              });
            };

            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var chartTitleElements = document.querySelectorAll('.chart-title');
          chartTitleElements.forEach(function (el) {
            return el.style.display = 'block';
          });
          cardActions.forEach(function (el) {
            return el.style.opacity = 1;
          });
        });
      }
    }, {
      key: "setCardHeaders",
      value: function setCardHeaders(data) {
        var barChartSettings = this.settings.charts.barChart;
        document.querySelectorAll('.charts .char-tab').forEach(function (node) {
          return node.classList.remove('active');
        });
        var barChartKeys = Object.keys(barChartSettings);
        var firstBarChartSettings = barChartSettings[barChartKeys[0]];
        var firstBarChartId = firstBarChartSettings.id;
        var firstBarChartTabId = firstBarChartSettings.id + 'Tab';
        var firstBarChartDataName = firstBarChartSettings.dataName;
        var firstBarChart = document.getElementById(firstBarChartId);
        var barChartTab = firstBarChart.closest('.char-tab');
        barChartTab.classList.add('active');
        var barChartCard = firstBarChart.closest('.card');
        var barChartTitleEl = barChartCard.querySelector('.chart-title');
        barChartTitleEl.textContent = data.data[firstBarChartDataName].name;
        var firstBarChartTab = document.getElementById(firstBarChartTabId);
        firstBarChartTab.classList.add('active');
        var barChartMenuEl = document.querySelector('.bar-chart-menu');

        for (var _i = 0, _barChartKeys = barChartKeys; _i < _barChartKeys.length; _i++) {
          var key = _barChartKeys[_i];
          var chart = barChartSettings[key];
          barChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
        }

        this.bindChangeTabBarChart();
      }
    }, {
      key: "bindChangeTabBarChart",
      value: function bindChangeTabBarChart() {
        var chartTabToggles = document.querySelectorAll('.char-tab-toggle');

        var _iterator6 = _createForOfIteratorHelper(chartTabToggles),
            _step6;

        try {
          var _loop3 = function _loop3() {
            var toggle = _step6.value;
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              var target = document.getElementById(toggle.getAttribute('data-target-id'));

              if (target) {
                var otherTabs = Array.prototype.filter.call(target.parentNode.children, function (child) {
                  return child !== target;
                });

                var _iterator7 = _createForOfIteratorHelper(otherTabs),
                    _step7;

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var tab = _step7.value;
                    tab.classList.remove('active');
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                target.classList.add('active');
              }

              var cardHeader = toggle.closest('.card-header');
              var chartTitleEl = cardHeader.querySelector('h2');
              chartTitleEl.textContent = toggle.textContent;
            });
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "drawTrafficUtilizationReportChart",
      value: function drawTrafficUtilizationReportChart(data) {
        this.trafficUtilizationReportChart = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barChart"]["trafficUtilizationReportChart"]["id"],
          data: data["data"][this.settings["charts"]["barChart"]["trafficUtilizationReportChart"]["dataName"]].values,
          multidata: true,
          name_mapping: {
            legal: "Ruch legalny " + data['data']['traffic_utilization_report_chart_units'],
            attack: "Ruch związany z atakiem " + data['data']['traffic_utilization_report_chart_units']
          },
          colors: {
            legal: "250,223,25",
            medium: "255,144,71",
            attack: "217,89,71"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawGetPostRequestRateChart",
      value: function drawGetPostRequestRateChart(data) {
        this.getPostRequestRateChart = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barChart"]["getPostRequestRateChart"]["id"],
          data: data["data"][this.settings["charts"]["barChart"]["getPostRequestRateChart"]["dataName"]].values,
          multidata: true,
          name_mapping: {
            requests: "Średnia liczba żądań HTTP (RPS)"
          },
          colors: {
            requests: "255,144,71"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "drawDnsRequestRateChart",
      value: function drawDnsRequestRateChart(data) {
        this.dnsRequestRateChart = new NS.Charts.BarChart({
          "container-id": this.settings["charts"]["barChart"]["dnsRequestRateChart"]["id"],
          data: data["data"][this.settings["charts"]["barChart"]["dnsRequestRateChart"]["dataName"]].values,
          multidata: true,
          name_mapping: {
            legal_ipv4: "Ruch legalny IPv4 (QPS)",
            legal_ipv6: "Ruch legalny IPv6 (QPS)",
            attack_ipv4: "Ruch związany z atakiem IPv4 (QPS)",
            attack_ipv6: "Ruch związany z atakiem IPv6 (QPS)"
          },
          colors: {
            legal_ipv4: "255,162,100",
            legal_ipv6: "255,137,57",
            attack_ipv4: "255,103,0",
            attack_ipv6: "217,89,71"
          },
          show_legend: this.config['show_legend']
        });
      }
    }, {
      key: "bindExport",
      value: function bindExport(dataSource) {
        var _loop4 = function _loop4() {
          var id = _arr[_i2];
          var button = document.getElementById(id);
          button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var filterStartIndex = dataSource.baseUrl.indexOf('/ddos?');
            var filterString = dataSource.baseUrl.substring(filterStartIndex).replace('/ddos', '');
            var basePath = button.getAttribute('href');
            dataSource['filterValues'].forEach(function (filter) {
              if (filter['value']) {
                filterString += '&filters[' + filter['dataIndex'] + ']=' + filter['value'];
              }
            });

            if (dataSource['sortValues']) {
              if (dataSource['sortValues']['order']) {
                filterString += '&sort[order]=' + dataSource['sortValues']['order'];
              }

              if (dataSource['sortValues']['order']) {
                filterString += '&sort[key]=' + dataSource['sortValues']['dataIndex'];
              }
            }

            window.open(basePath + filterString);
          });
        };

        for (var _i2 = 0, _arr = ['pdf-export', 'csv-export']; _i2 < _arr.length; _i2++) {
          _loop4();
        }
      }
    }, {
      key: "createGrid",
      value: function createGrid() {
        var columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
          columnDefinitions: [{
            label: "Rozpoczęcie ataku",
            dataIndex: "start_time",
            dataType: "text",
            isEditable: false,
            isFilterable: true
          }, {
            label: "Zakończenie ataku",
            dataIndex: "end_time",
            dataType: "text",
            isEditable: false,
            isFilterable: true
          }, {
            label: "Nazwa ataku + ryzyko",
            dataIndex: "name",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true,
            width: '*'
          }, {
            label: "Status ataku",
            dataIndex: "status",
            dataType: "text",
            isEditable: false,
            isFilterable: true
          }, {
            label: "Wolumen (liczba pakietów)",
            dataIndex: "packet_count",
            dataType: "text",
            isEditable: false,
            isFilterable: true
          }, {
            label: "Wolumen (pps)",
            dataIndex: "pps",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true
          }, {
            label: "Wolumen (liczba bitów)",
            dataIndex: "packet_bandwidth_in_bits",
            dataType: "text",
            isEditable: false,
            isFilterable: true
          }, {
            label: "Wolumen (bps)",
            dataIndex: "bps",
            dataType: "text",
            isEditable: false,
            isSortable: true,
            isFilterable: true
          }, {
            label: "Akcje",
            dataIndex: "actions",
            dataType: "link",
            isEditable: false,
            isFilterable: false,
            isSortable: false,
            width: 120
          }]
        });
        var dataSource = new NS.Grid.SimpleDataSource({
          url: this.config.table_data_url,
          baseParameters: {},
          updateUrl: "/js/app/update.json"
        });
        this.bindExport(dataSource);
        var settingsManager = new NS.Grid.CookiesSettingsManager({
          id: "gridContainerId"
        });
        new NS.Grid.Control({
          id: "gridContainerWrapperId",
          containerId: 'grid-container',
          dataSource: dataSource,
          reloadTime: null,
          //not implemented yet
          autoLoad: true,
          columnDefinitionSource: columnDefinitionSource,
          settingsManager: settingsManager,
          allowMultiselect: false,
          showAllRows: this.config.show_all_rows || false,
          pageSize: this.config.show_all_rows ? 99999999 : 20,
          listeners: {
            onDataChanged: function onDataChanged() {},
            onDataSaved: function onDataSaved() {},
            onDataInvalid: function onDataInvalid() {},
            onDataError: function onDataError() {},
            onSelectionChange: function onSelectionChange() {}
          }
        });
      }
    }]);

    return WafDdosController;
  }(); //wyeksportowanie klasy


  global.NS = global.NS || {};
  global.NS.Views = global.NS.Views || {};
  global.NS.Views.WafDdosController = WafDdosController || {};
})(window);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * JavaScript Cookie v2.0.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = factory();
  } else {
    var _OldCookies = window.Cookies;
    var api = window.Cookies = factory();

    api.noConflict = function () {
      window.Cookies = _OldCookies;
      return api;
    };
  }
})(function () {
  function extend() {
    var i = 0;
    var result = {};

    for (; i < arguments.length; i++) {
      var attributes = arguments[i];

      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }

    return result;
  }

  function init(converter) {
    function api(key, value, attributes) {
      var result; // Write

      if (arguments.length > 1) {
        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          var expires = new Date();
          expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
          attributes.expires = expires;
        }

        try {
          result = JSON.stringify(value);

          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        value = encodeURIComponent(String(value));
        value = value.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);
        return document.cookie = [key, '=', value, attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
        attributes.path && '; path=' + attributes.path, attributes.domain && '; domain=' + attributes.domain, attributes.secure ? '; secure' : ''].join('');
      } // Read


      if (!key) {
        result = {};
      } // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()"


      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var name = parts[0].replace(rdecode, decodeURIComponent);
        var cookie = parts.slice(1).join('=');

        if (cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          cookie = converter && converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

          if (this.json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) {}
          }

          if (key === name) {
            result = cookie;
            break;
          }

          if (!key) {
            result[name] = cookie;
          }
        } catch (e) {}
      }

      return result;
    }

    api.get = api.set = api;

    api.getJSON = function () {
      return api.apply({
        json: true
      }, [].slice.call(arguments));
    };

    api.defaults = {};

    api.remove = function (key, attributes) {
      api(key, '', extend(attributes, {
        expires: -1
      }));
    };

    api.withConverter = init;
    return api;
  }

  return init();
});